/**
 * Enum containing all localization string keys used throughout the application.
 * Keys are organized alphabetically for easier maintenance.
 * This is a subset of the original Verbiage enum, excluding the 6 _alt keys.
 */
export var CommonVerbiage;
(function (CommonVerbiage) {
    CommonVerbiage["a_probably_fair_system"] = "a_probably_fair_system";
    CommonVerbiage["about_us"] = "about_us";
    CommonVerbiage["about_vip_alternative2_alt"] = "about_vip_alternative2_alt";
    CommonVerbiage["accept"] = "accept";
    CommonVerbiage["accept_bonus"] = "accept_bonus";
    CommonVerbiage["accepted"] = "accepted";
    CommonVerbiage["accepting"] = "accepting";
    CommonVerbiage["account"] = "account";
    CommonVerbiage["account_details"] = "account_details";
    CommonVerbiage["account_merge_request"] = "account_merge_request";
    CommonVerbiage["account_merge_this_account"] = "account_merge_this_account";
    CommonVerbiage["account_merge_other_account"] = "account_merge_other_account";
    CommonVerbiage["account_merge_into"] = "account_merge_into";
    CommonVerbiage["account_merge_reason"] = "account_merge_reason";
    CommonVerbiage["account_merge_reason_required"] = "account_merge_reason_required";
    CommonVerbiage["account_merge_other_required"] = "account_merge_other_required";
    CommonVerbiage["account_merge_submit"] = "account_merge_submit";
    CommonVerbiage["action"] = "action";
    CommonVerbiage["actions"] = "actions";
    CommonVerbiage["activate_now"] = "activate_now";
    CommonVerbiage["active"] = "active";
    CommonVerbiage["active_client_seed"] = "active_client_seed";
    CommonVerbiage["active_server_seed"] = "active_server_seed";
    CommonVerbiage["add_email_address"] = "add_email_address";
    CommonVerbiage["add_new_emailSec"] = "add_new_emailSec";
    CommonVerbiage["added_to_balance"] = "added_to_balance";
    CommonVerbiage["added_to_calendar"] = "added_to_calendar";
    CommonVerbiage["address_temporarily_unavailable"] = "address_temporarily_unavailable";
    CommonVerbiage["addressLine1Label"] = "addressLine1Label";
    CommonVerbiage["addressLine1Placeholder"] = "addressLine1Placeholder";
    CommonVerbiage["addressLine2Label"] = "addressLine2Label";
    CommonVerbiage["addressLine2Placeholder"] = "addressLine2Placeholder";
    CommonVerbiage["admin"] = "admin";
    CommonVerbiage["advent_calendar"] = "advent_calendar";
    CommonVerbiage["advent_calendar_banner_title"] = "advent_calendar_banner_title";
    CommonVerbiage["advent_calendar_banner_description"] = "advent_calendar_banner_description";
    CommonVerbiage["advent_calendar_description"] = "advent_calendar_description";
    CommonVerbiage["affiliate"] = "affiliate";
    CommonVerbiage["affiliate_agreement"] = "affiliate_agreement";
    CommonVerbiage["affiliate_form_fill_all_fields"] = "affiliate_form_fill_all_fields";
    CommonVerbiage["affiliate_form_success"] = "affiliate_form_success";
    CommonVerbiage["affiliate_managers_details"] = "affiliate_managers_details";
    CommonVerbiage["affiliate_marketing_promotion"] = "affiliate_marketing_promotion";
    CommonVerbiage["affiliate_modern_application_subtitle"] = "affiliate_modern_application_subtitle";
    CommonVerbiage["affiliate_modern_at_commission"] = "affiliate_modern_at_commission";
    CommonVerbiage["affiliate_modern_be_a_partner"] = "affiliate_modern_be_a_partner";
    CommonVerbiage["affiliate_modern_faq"] = "affiliate_modern_faq";
    CommonVerbiage["affiliate_modern_faq_commission_calculation_answer"] = "affiliate_modern_faq_commission_calculation_answer";
    CommonVerbiage["affiliate_modern_faq_commission_calculation_answer_2"] = "affiliate_modern_faq_commission_calculation_answer_2";
    CommonVerbiage["affiliate_modern_faq_negative_balances_answer"] = "affiliate_modern_faq_negative_balances_answer";
    CommonVerbiage["affiliate_modern_faq_negative_balances_answer_2"] = "affiliate_modern_faq_negative_balances_answer_2";
    CommonVerbiage["affiliate_modern_faq_overview_answer"] = "affiliate_modern_faq_overview_answer";
    CommonVerbiage["affiliate_modern_faq_payment_frequency_answer"] = "affiliate_modern_faq_payment_frequency_answer";
    CommonVerbiage["affiliate_modern_faq_program_working_answer"] = "affiliate_modern_faq_program_working_answer";
    CommonVerbiage["affiliate_modern_faq_program_working_answer_2"] = "affiliate_modern_faq_program_working_answer_2";
    CommonVerbiage["affiliate_modern_faq_promotion_restrictions_answer"] = "affiliate_modern_faq_promotion_restrictions_answer";
    CommonVerbiage["affiliate_modern_faq_promotion_restrictions_answer_2"] = "affiliate_modern_faq_promotion_restrictions_answer_2";
    CommonVerbiage["affiliate_modern_faq_promotional_materials_answer"] = "affiliate_modern_faq_promotional_materials_answer";
    CommonVerbiage["affiliate_modern_faq_promotional_materials_answer_2"] = "affiliate_modern_faq_promotional_materials_answer_2";
    CommonVerbiage["affiliate_modern_faq_referral_limit_answer"] = "affiliate_modern_faq_referral_limit_answer";
    CommonVerbiage["affiliate_modern_faq_referral_limit_answer_2"] = "affiliate_modern_faq_referral_limit_answer_2";
    CommonVerbiage["affiliate_modern_faq_referral_tracking_answer"] = "affiliate_modern_faq_referral_tracking_answer";
    CommonVerbiage["affiliate_modern_faq_title"] = "affiliate_modern_faq_title";
    CommonVerbiage["affiliate_modern_hero_body"] = "affiliate_modern_hero_body";
    CommonVerbiage["affiliate_modern_hero_subtitle"] = "affiliate_modern_hero_subtitle";
    CommonVerbiage["affiliate_modern_hero_title"] = "affiliate_modern_hero_title";
    CommonVerbiage["affiliate_modern_perks"] = "affiliate_modern_perks";
    CommonVerbiage["affiliate_modern_perks_intro"] = "affiliate_modern_perks_intro";
    CommonVerbiage["affiliate_modern_perks_title"] = "affiliate_modern_perks_title";
    CommonVerbiage["affiliate_modern_platform_body"] = "affiliate_modern_platform_body";
    CommonVerbiage["affiliate_modern_platform_body_2"] = "affiliate_modern_platform_body_2";
    CommonVerbiage["affiliate_modern_platform_card_title"] = "affiliate_modern_platform_card_title";
    CommonVerbiage["affiliate_modern_platform_title"] = "affiliate_modern_platform_title";
    CommonVerbiage["affiliate_modern_start_earning"] = "affiliate_modern_start_earning";
    CommonVerbiage["affiliate_modern_traffic"] = "affiliate_modern_traffic";
    CommonVerbiage["affiliate_modern_traffic_body"] = "affiliate_modern_traffic_body";
    CommonVerbiage["affiliate_modern_traffic_title"] = "affiliate_modern_traffic_title";
    CommonVerbiage["affiliate_terms_conditions"] = "affiliate_terms_conditions";
    CommonVerbiage["affiliates"] = "affiliates";
    CommonVerbiage["agree_to_forfeit"] = "agree_to_forfeit";
    CommonVerbiage["alias"] = "alias";
    CommonVerbiage["alias_on_leaderboards"] = "alias_on_leaderboards";
    CommonVerbiage["all"] = "all";
    CommonVerbiage["all_campaigns"] = "all_campaigns";
    CommonVerbiage["all_currencies"] = "all_currencies";
    CommonVerbiage["all_game_providers"] = "all_game_providers";
    CommonVerbiage["all_games"] = "all_games";
    CommonVerbiage["all_providers"] = "all_providers";
    CommonVerbiage["all_ranks"] = "all_ranks";
    CommonVerbiage["all_rights_reserved"] = "all_rights_reserved";
    CommonVerbiage["all_tiers_benefits_description"] = "all_tiers_benefits_description";
    CommonVerbiage["alphabetical"] = "alphabetical";
    CommonVerbiage["alphabetical_a_z"] = "alphabetical_a_z";
    CommonVerbiage["alphabetical_z_a"] = "alphabetical_z_a";
    CommonVerbiage["alphabetical_za"] = "alphabetical_za";
    CommonVerbiage["alpine_skiing"] = "alpine_skiing";
    CommonVerbiage["american_football"] = "american_football";
    CommonVerbiage["aml_policy"] = "aml_policy";
    CommonVerbiage["amount"] = "amount";
    CommonVerbiage["amount_fiat"] = "amount_fiat";
    CommonVerbiage["amount_of_people"] = "amount_of_people";
    CommonVerbiage["and_earn_the_best_rewards_available"] = "and_earn_the_best_rewards_available";
    CommonVerbiage["and_rewards"] = "and_rewards";
    CommonVerbiage["anniversary_bonus_text"] = "anniversary_bonus_text";
    CommonVerbiage["answer_daily_weekly_monthly"] = "answer_daily_weekly_monthly";
    CommonVerbiage["answer_how_communicate"] = "answer_how_communicate";
    CommonVerbiage["answer_how_ofter_bonuses"] = "answer_how_ofter_bonuses";
    CommonVerbiage["answer_monthly_bonus"] = "answer_monthly_bonus";
    CommonVerbiage["answer_vip_club_stand_out"] = "answer_vip_club_stand_out";
    CommonVerbiage["answer_wagering"] = "answer_wagering";
    CommonVerbiage["answer_what_are_calendar_distribuition_days"] = "answer_what_are_calendar_distribuition_days";
    CommonVerbiage["answer_what_is_cashback"] = "answer_what_is_cashback";
    CommonVerbiage["answer_what_is_happy_hour"] = "answer_what_is_happy_hour";
    CommonVerbiage["answer_what_is_rakeback"] = "answer_what_is_rakeback";
    CommonVerbiage["answer_which_tier_im_on"] = "answer_which_tier_im_on";
    CommonVerbiage["approval_time_for_program"] = "approval_time_for_program";
    CommonVerbiage["approval_time_for_program_answer"] = "approval_time_for_program_answer";
    CommonVerbiage["approving"] = "approving";
    CommonVerbiage["are_you_sure_you_want_to_cancel_this_item"] = "are_you_sure_you_want_to_cancel_this_item";
    CommonVerbiage["are_you_sure_you_want_to_delete_this_item"] = "are_you_sure_you_want_to_delete_this_item";
    CommonVerbiage["are_you_sure_you_want_to_disable_item"] = "are_you_sure_you_want_to_disable_item";
    CommonVerbiage["are_you_sure_you_want_to_proceed_with_this_action"] = "are_you_sure_you_want_to_proceed_with_this_action";
    CommonVerbiage["as_you_and_your_friends"] = "as_you_and_your_friends";
    CommonVerbiage["aussie_rules"] = "aussie_rules";
    CommonVerbiage["auth_hero_login_description"] = "auth_hero_login_description";
    CommonVerbiage["auth_hero_login_eyebrow"] = "auth_hero_login_eyebrow";
    CommonVerbiage["auth_hero_login_title"] = "auth_hero_login_title";
    CommonVerbiage["auth_hero_register_description"] = "auth_hero_register_description";
    CommonVerbiage["auth_hero_register_eyebrow"] = "auth_hero_register_eyebrow";
    CommonVerbiage["auth_hero_register_title"] = "auth_hero_register_title";
    CommonVerbiage["available"] = "available";
    CommonVerbiage["available_bonuses"] = "available_bonuses";
    CommonVerbiage["available_on_all_casino_games"] = "available_on_all_casino_games";
    CommonVerbiage["baccarat"] = "baccarat";
    CommonVerbiage["back"] = "back";
    CommonVerbiage["badminton"] = "badminton";
    CommonVerbiage["balance"] = "balance";
    CommonVerbiage["bank"] = "bank";
    CommonVerbiage["bank_not_allowed"] = "bank_not_allowed";
    CommonVerbiage["banks_country"] = "banks_country";
    CommonVerbiage["baseball"] = "baseball";
    CommonVerbiage["basketball"] = "basketball";
    CommonVerbiage["become_a_partner"] = "become_a_partner";
    CommonVerbiage["become_royalty_text"] = "become_royalty_text";
    CommonVerbiage["beginner_affiliate_marketing"] = "beginner_affiliate_marketing";
    CommonVerbiage["beginner_affiliate_marketing_answer"] = "beginner_affiliate_marketing_answer";
    CommonVerbiage["best_vip_club"] = "best_vip_club";
    CommonVerbiage["best_vip_club_description"] = "best_vip_club_description";
    CommonVerbiage["begin_your_journey"] = "begin_your_journey";
    CommonVerbiage["better_barn_house_bonanza"] = "better_barn_house_bonanza";
    CommonVerbiage["better_barn_house_bonanza_description"] = "better_barn_house_bonanza_description";
    CommonVerbiage["bet"] = "bet";
    CommonVerbiage["bet_feed"] = "bet_feed";
    CommonVerbiage["bet_id"] = "bet_id";
    CommonVerbiage["bet_now"] = "bet_now";
    CommonVerbiage["bet_statistics"] = "bet_statistics";
    CommonVerbiage["bet_on_basketball"] = "bet_on_basketball";
    CommonVerbiage["bet_on_cricket"] = "bet_on_cricket";
    CommonVerbiage["bet_on_cs2"] = "bet_on_cs2";
    CommonVerbiage["bet_on_dota2"] = "bet_on_dota2";
    CommonVerbiage["bet_on_f1"] = "bet_on_f1";
    CommonVerbiage["bet_on_football"] = "bet_on_football";
    CommonVerbiage["bet_on_lol"] = "bet_on_lol";
    CommonVerbiage["bet_on_tennis"] = "bet_on_tennis";
    CommonVerbiage["bet_on_ufc"] = "bet_on_ufc";
    CommonVerbiage["bet_on_valorant"] = "bet_on_valorant";
    CommonVerbiage["bets"] = "bets";
    CommonVerbiage["bets_on_providers"] = "bets_on_providers";
    CommonVerbiage["big_wins"] = "big_wins";
    CommonVerbiage["birthday_visibility"] = "birthday_visibility";
    CommonVerbiage["birthdayInfo"] = "birthdayInfo";
    CommonVerbiage["bitcoin_baccarat"] = "bitcoin_baccarat";
    CommonVerbiage["bitcoin_blackjack"] = "bitcoin_blackjack";
    CommonVerbiage["bitcoin_casino"] = "bitcoin_casino";
    CommonVerbiage["bitcoin_crash_game"] = "bitcoin_crash_game";
    CommonVerbiage["bitcoin_dice"] = "bitcoin_dice";
    CommonVerbiage["bitcoin_keno"] = "bitcoin_keno";
    CommonVerbiage["bitcoin_live_casino"] = "bitcoin_live_casino";
    CommonVerbiage["bitcoin_mines_game"] = "bitcoin_mines_game";
    CommonVerbiage["bitcoin_play_testimonial"] = "bitcoin_play_testimonial";
    CommonVerbiage["bitcoin_roulette"] = "bitcoin_roulette";
    CommonVerbiage["bitcoin_slots"] = "bitcoin_slots";
    CommonVerbiage["bitcoin_sportsbook"] = "bitcoin_sportsbook";
    CommonVerbiage["blackjack"] = "blackjack";
    CommonVerbiage["blaze_zombie"] = "blaze_zombie";
    CommonVerbiage["blaze_zombie_description"] = "blaze_zombie_description";
    CommonVerbiage["blocked_by_browser"] = "blocked_by_browser";
    CommonVerbiage["blog"] = "blog";
    CommonVerbiage["bonus"] = "bonus";
    CommonVerbiage["bonus_100"] = "bonus_100";
    CommonVerbiage["bonus_buy_slots"] = "bonus_buy_slots";
    CommonVerbiage["bonus_buys"] = "bonus_buys";
    CommonVerbiage["bonus_code"] = "bonus_code";
    CommonVerbiage["bonus_lock"] = "bonus_lock";
    CommonVerbiage["bonus_money"] = "bonus_money";
    CommonVerbiage["bonus_per_referral"] = "bonus_per_referral";
    CommonVerbiage["bonus_precondition_failed"] = "bonus_precondition_failed";
    CommonVerbiage["bonus_progress"] = "bonus_progress";
    CommonVerbiage["bonus_terms"] = "bonus_terms";
    CommonVerbiage["browse_and_play"] = "browse_and_play";
    CommonVerbiage["browse_through"] = "browse_through";
    CommonVerbiage["boost_your_holiday"] = "boost_your_holiday";
    CommonVerbiage["boxing"] = "boxing";
    CommonVerbiage["brand_events"] = "brand_events";
    CommonVerbiage["bronze"] = "bronze";
    CommonVerbiage["button"] = "button";
    CommonVerbiage["buy"] = "buy";
    CommonVerbiage["buy_crypto"] = "buy_crypto";
    CommonVerbiage["buy_crypto_disclaimer"] = "buy_crypto_disclaimer";
    CommonVerbiage["buy_crypto_tooltip"] = "buy_crypto_tooltip";
    CommonVerbiage["BUY_FEATURE"] = "BUY_FEATURE";
    CommonVerbiage["by"] = "by";
    CommonVerbiage["by_simply_getting"] = "by_simply_getting";
    CommonVerbiage["calculation"] = "calculation";
    CommonVerbiage["calendar"] = "calendar";
    CommonVerbiage["calendar_bonus"] = "calendar_bonus";
    CommonVerbiage["calendar_claimable_days"] = "calendar_claimable_days";
    CommonVerbiage["calendar_distribution_days_text"] = "calendar_distribution_days_text";
    CommonVerbiage["calendar_reward"] = "calendar_reward";
    CommonVerbiage["calendar_text"] = "calendar_text";
    CommonVerbiage["campaign_name"] = "campaign_name";
    CommonVerbiage["campaigns"] = "campaigns";
    CommonVerbiage["canada"] = "canada";
    CommonVerbiage["cancel"] = "cancel";
    CommonVerbiage["cancelled"] = "cancelled";
    CommonVerbiage["cancelling"] = "cancelling";
    CommonVerbiage["canelo_vs_crawford_description"] = "canelo_vs_crawford_description";
    CommonVerbiage["cannot_receive_tips"] = "cannot_receive_tips";
    CommonVerbiage["cash"] = "cash";
    CommonVerbiage["cash_and_drop"] = "cash_and_drop";
    CommonVerbiage["cash_back"] = "cash_back";
    CommonVerbiage["cash_drop"] = "cash_drop";
    CommonVerbiage["cash_drop_description"] = "cash_drop_description";
    CommonVerbiage["cash_or_crypto"] = "cash_or_crypto";
    CommonVerbiage["cash_or_crypto_description"] = "cash_or_crypto_description";
    CommonVerbiage["cash_out"] = "cash_out";
    CommonVerbiage["cash_out_cancel_title"] = "cash_out_cancel_title";
    CommonVerbiage["cash_out_earned_title"] = "cash_out_earned_title";
    CommonVerbiage["cash_out_forfeit_title"] = "cash_out_forfeit_title";
    CommonVerbiage["cash_out_success_cancel"] = "cash_out_success_cancel";
    CommonVerbiage["cash_out_success_earned"] = "cash_out_success_earned";
    CommonVerbiage["cash_fiat_amount_within_limits_hint"] = "cash_fiat_amount_within_limits_hint";
    CommonVerbiage["cashback"] = "cashback";
    CommonVerbiage["cashback_bonuses_description"] = "cashback_bonuses_description";
    CommonVerbiage["casino"] = "casino";
    CommonVerbiage["casino_bonus"] = "casino_bonus";
    CommonVerbiage["casino_bonus_free_spins_promo_codes"] = "casino_bonus_free_spins_promo_codes";
    CommonVerbiage["casino_deposit_bonus"] = "casino_deposit_bonus";
    CommonVerbiage["casino_card_title"] = "casino_card_title";
    CommonVerbiage["casino_promotions"] = "casino_promotions";
    CommonVerbiage["casino_subtitle"] = "casino_subtitle";
    CommonVerbiage["challenges"] = "challenges";
    CommonVerbiage["change"] = "change";
    CommonVerbiage["changeAlias"] = "changeAlias";
    CommonVerbiage["change_password"] = "change_password";
    CommonVerbiage["character_limit_reached"] = "character_limit_reached";
    CommonVerbiage["champions_league_final"] = "champions_league_final";
    CommonVerbiage["champions_league_final_description"] = "champions_league_final_description";
    CommonVerbiage["chat"] = "chat";
    CommonVerbiage["chat_deposit_required"] = "chat_deposit_required";
    CommonVerbiage["chat_emojis_activity_category"] = "chat_emojis_activity_category";
    CommonVerbiage["chat_emojis_flags_category"] = "chat_emojis_flags_category";
    CommonVerbiage["chat_emojis_foods_category"] = "chat_emojis_foods_category";
    CommonVerbiage["chat_emojis_nature_category"] = "chat_emojis_nature_category";
    CommonVerbiage["chat_emojis_objects_category"] = "chat_emojis_objects_category";
    CommonVerbiage["chat_emojis_people_category"] = "chat_emojis_people_category";
    CommonVerbiage["chat_emojis_places_category"] = "chat_emojis_places_category";
    CommonVerbiage["chat_emojis_recents_category"] = "chat_emojis_recents_category";
    CommonVerbiage["chat_emojis_symbols_category"] = "chat_emojis_symbols_category";
    CommonVerbiage["chat_invalid_content"] = "chat_invalid_content";
    CommonVerbiage["chat_media_emojis_tab"] = "chat_media_emojis_tab";
    CommonVerbiage["chat_media_gifs_tab"] = "chat_media_gifs_tab";
    CommonVerbiage["chat_media_stickers_tab"] = "chat_media_stickers_tab";
    CommonVerbiage["chat_muted_title"] = "chat_muted_title";
    CommonVerbiage["chat_muted_description"] = "chat_muted_description";
    CommonVerbiage["chat_muted_permanent_description"] = "chat_muted_permanent_description";
    CommonVerbiage["chat_rules"] = "chat_rules";
    CommonVerbiage["chat_search_emojis_placeholder"] = "chat_search_emojis_placeholder";
    CommonVerbiage["chat_search_gifs_placeholder"] = "chat_search_gifs_placeholder";
    CommonVerbiage["check"] = "check";
    CommonVerbiage["check_your_email_for"] = "check_your_email_for";
    CommonVerbiage["check_your_email_for_your_verification_code"] = "check_your_email_for_your_verification_code";
    CommonVerbiage["check_your_phone_for_your_verification_code"] = "check_your_phone_for_your_verification_code";
    CommonVerbiage["choose_a_display_name"] = "choose_a_display_name";
    CommonVerbiage["choose_a_password"] = "choose_a_password";
    CommonVerbiage["choose_a_username"] = "choose_a_username";
    CommonVerbiage["christmas_advent"] = "christmas_advent";
    CommonVerbiage["christmas_calendar"] = "christmas_calendar";
    CommonVerbiage["cityLabel"] = "cityLabel";
    CommonVerbiage["cityPlaceholder"] = "cityPlaceholder";
    CommonVerbiage["claim"] = "claim";
    CommonVerbiage["claim_now"] = "claim_now";
    CommonVerbiage["claim_total_in"] = "claim_total_in";
    CommonVerbiage["claim_your_rewards"] = "claim_your_rewards";
    CommonVerbiage["claim_your_slice"] = "claim_your_slice";
    CommonVerbiage["claimed"] = "claimed";
    CommonVerbiage["clear"] = "clear";
    CommonVerbiage["click_on_one_of_the_games"] = "click_on_one_of_the_games";
    CommonVerbiage["click_to_continue"] = "click_to_continue";
    CommonVerbiage["click_to_copy"] = "click_to_copy";
    CommonVerbiage["client_seed"] = "client_seed";
    CommonVerbiage["close"] = "close";
    CommonVerbiage["coming_soon"] = "coming_soon";
    CommonVerbiage["comission_plan"] = "comission_plan";
    CommonVerbiage["commision_shares"] = "commision_shares";
    CommonVerbiage["commission"] = "commission";
    CommonVerbiage["commission_calculation_details"] = "commission_calculation_details";
    CommonVerbiage["commission_calculation_details_answer"] = "commission_calculation_details_answer";
    CommonVerbiage["commission_from_new_affiliates"] = "commission_from_new_affiliates";
    CommonVerbiage["commission_from_new_affiliates_answer"] = "commission_from_new_affiliates_answer";
    CommonVerbiage["commission_levels_title"] = "commission_levels_title";
    CommonVerbiage["commission_levels_panel_footnote_active"] = "commission_levels_panel_footnote_active";
    CommonVerbiage["commission_levels_panel_footnote_monthly_cap"] = "commission_levels_panel_footnote_monthly_cap";
    CommonVerbiage["commission_levels_panel_intro"] = "commission_levels_panel_intro";
    CommonVerbiage["commission_levels_panel_tier1_badge"] = "commission_levels_panel_tier1_badge";
    CommonVerbiage["commission_levels_panel_tier1_description"] = "commission_levels_panel_tier1_description";
    CommonVerbiage["commission_levels_panel_tier1_title"] = "commission_levels_panel_tier1_title";
    CommonVerbiage["commission_levels_panel_tier2_badge"] = "commission_levels_panel_tier2_badge";
    CommonVerbiage["commission_levels_panel_tier2_description"] = "commission_levels_panel_tier2_description";
    CommonVerbiage["commission_levels_panel_tier2_title"] = "commission_levels_panel_tier2_title";
    CommonVerbiage["commission_levels_panel_tier3_badge"] = "commission_levels_panel_tier3_badge";
    CommonVerbiage["commission_levels_panel_tier3_description"] = "commission_levels_panel_tier3_description";
    CommonVerbiage["commission_levels_panel_tier3_title"] = "commission_levels_panel_tier3_title";
    CommonVerbiage["commission_payment_frequency"] = "commission_payment_frequency";
    CommonVerbiage["commission_payment_frequency_answer"] = "commission_payment_frequency_answer";
    CommonVerbiage["commission_percentage"] = "commission_percentage";
    CommonVerbiage["commission_plan"] = "commission_plan";
    CommonVerbiage["commission_rewards"] = "commission_rewards";
    CommonVerbiage["commission_schemes_details"] = "commission_schemes_details";
    CommonVerbiage["commission_shares"] = "commission_shares";
    CommonVerbiage["commission_sharings"] = "commission_sharings";
    CommonVerbiage["company"] = "company";
    CommonVerbiage["complaints_and_arbitration"] = "complaints_and_arbitration";
    CommonVerbiage["complete_all_fields"] = "complete_all_fields";
    CommonVerbiage["completed"] = "completed";
    CommonVerbiage["confirm"] = "confirm";
    CommonVerbiage["confirm_age_terms"] = "confirm_age_terms";
    CommonVerbiage["confirm_password"] = "confirm_password";
    CommonVerbiage["confirmed"] = "confirmed";
    CommonVerbiage["confirming"] = "confirming";
    CommonVerbiage["congratulations"] = "congratulations";
    CommonVerbiage["connect_wallet"] = "connect_wallet";
    CommonVerbiage["connected"] = "connected";
    CommonVerbiage["connected_accounts"] = "connected_accounts";
    CommonVerbiage["connected_wallet"] = "connected_wallet";
    CommonVerbiage["consistent_rewards_description"] = "consistent_rewards_description";
    CommonVerbiage["consolation"] = "consolation";
    CommonVerbiage["contact"] = "contact";
    CommonVerbiage["contact_email_support"] = "contact_email_support";
    CommonVerbiage["contact_finance"] = "contact_finance";
    CommonVerbiage["contact_intro"] = "contact_intro";
    CommonVerbiage["contact_member_services"] = "contact_member_services";
    CommonVerbiage["contact_partners"] = "contact_partners";
    CommonVerbiage["contact_partners_answer"] = "contact_partners_answer";
    CommonVerbiage["contact_share_username"] = "contact_share_username";
    CommonVerbiage["contact_support"] = "contact_support";
    CommonVerbiage["contact_support_for_assistance"] = "contact_support_for_assistance";
    CommonVerbiage["contact_us"] = "contact_us";
    CommonVerbiage["continue"] = "continue";
    CommonVerbiage["cooldown"] = "cooldown";
    CommonVerbiage["cooldown_tab"] = "cooldown_tab";
    CommonVerbiage["coolDownPeriodDisabled"] = "coolDownPeriodDisabled";
    CommonVerbiage["cooldownPeriodEnabled"] = "cooldownPeriodEnabled";
    CommonVerbiage["cooldownPeriodRequested"] = "cooldownPeriodRequested";
    CommonVerbiage["cookies_modal_text"] = "cookies_modal_text";
    CommonVerbiage["copied"] = "copied";
    CommonVerbiage["copied_address"] = "copied_address";
    CommonVerbiage["copied_long"] = "copied_long";
    CommonVerbiage["counter_strike"] = "counter_strike";
    CommonVerbiage["countryLabel"] = "countryLabel";
    CommonVerbiage["countryPlaceholder"] = "countryPlaceholder";
    CommonVerbiage["crash"] = "crash";
    CommonVerbiage["crash_and_win"] = "crash_and_win";
    CommonVerbiage["create_a_new_campaign"] = "create_a_new_campaign";
    CommonVerbiage["create_account"] = "create_account";
    CommonVerbiage["create_account_terms_notice"] = "create_account_terms_notice";
    CommonVerbiage["create_free_account"] = "create_free_account";
    CommonVerbiage["create_new_campaign"] = "create_new_campaign";
    CommonVerbiage["create_referral_code"] = "create_referral_code";
    CommonVerbiage["created"] = "created";
    CommonVerbiage["credit_card"] = "credit_card";
    CommonVerbiage["credited"] = "credited";
    CommonVerbiage["cricket"] = "cricket";
    CommonVerbiage["cross_country"] = "cross_country";
    CommonVerbiage["crypto"] = "crypto";
    CommonVerbiage["crypto_casino"] = "crypto_casino";
    CommonVerbiage["crypto_casino_description"] = "crypto_casino_description";
    CommonVerbiage["crypto_crash_game"] = "crypto_crash_game";
    CommonVerbiage["crypto_dice_game"] = "crypto_dice_game";
    CommonVerbiage["crypto_game_shows"] = "crypto_game_shows";
    CommonVerbiage["crypto_market_watch"] = "crypto_market_watch";
    CommonVerbiage["crypto_plinko"] = "crypto_plinko";
    CommonVerbiage["crypto_slots"] = "crypto_slots";
    CommonVerbiage["crypto_video_poker"] = "crypto_video_poker";
    CommonVerbiage["crypto_wheel"] = "crypto_wheel";
    CommonVerbiage["crypto_wheel_of_fortune"] = "crypto_wheel_of_fortune";
    CommonVerbiage["crypto_select_network"] = "crypto_select_network";
    CommonVerbiage["crypto_select_currency"] = "crypto_select_currency";
    CommonVerbiage["currency"] = "currency";
    CommonVerbiage["currency_in_play"] = "currency_in_play";
    CommonVerbiage["current_quest"] = "current_quest";
    CommonVerbiage["current_rank"] = "current_rank";
    CommonVerbiage["currentPassword"] = "currentPassword";
    CommonVerbiage["custom_deposit_pending_notification_title"] = "custom_deposit_pending_notification_title";
    CommonVerbiage["custom_deposit_success_notification_title"] = "custom_deposit_success_notification_title";
    CommonVerbiage["custom_vip_bonuses"] = "custom_vip_bonuses";
    CommonVerbiage["cycling"] = "cycling";
    CommonVerbiage["daily"] = "daily";
    CommonVerbiage["daily_bonus"] = "daily_bonus";
    CommonVerbiage["daily_bonus_text"] = "daily_bonus_text";
    CommonVerbiage["daily_bonuses_text"] = "daily_bonuses_text";
    CommonVerbiage["daily_cashback"] = "daily_cashback";
    CommonVerbiage["daily_limit"] = "daily_limit";
    CommonVerbiage["daily_prize_drops"] = "daily_prize_drops";
    CommonVerbiage["daily_prize_drops_amount"] = "daily_prize_drops_amount";
    CommonVerbiage["daily_prize_drops_description"] = "daily_prize_drops_description";
    CommonVerbiage["daily_rewards"] = "daily_rewards";
    CommonVerbiage["daily_rewards_tooltip"] = "daily_rewards_tooltip";
    CommonVerbiage["daily_slot_tournaments_and_weekly_wheel_drops"] = "daily_slot_tournaments_and_weekly_wheel_drops";
    CommonVerbiage["daily_slot_tournaments_and_weekly_wheel_drops_description"] = "daily_slot_tournaments_and_weekly_wheel_drops_description";
    CommonVerbiage["daily_tournaments"] = "daily_tournaments";
    CommonVerbiage["daily_wins"] = "daily_wins";
    CommonVerbiage["daily_wins_amount"] = "daily_wins_amount";
    CommonVerbiage["daily_wins_description"] = "daily_wins_description";
    CommonVerbiage["daily_wins_slots"] = "daily_wins_slots";
    CommonVerbiage["daily_wins_slots_description"] = "daily_wins_slots_description";
    CommonVerbiage["darts"] = "darts";
    CommonVerbiage["dashboard"] = "dashboard";
    CommonVerbiage["date_of_birth"] = "date_of_birth";
    CommonVerbiage["date_of_birth_day_invalid"] = "date_of_birth_day_invalid";
    CommonVerbiage["date_of_birth_invalid"] = "date_of_birth_invalid";
    CommonVerbiage["date_of_birth_minimum_age"] = "date_of_birth_minimum_age";
    CommonVerbiage["date_of_birth_month_required"] = "date_of_birth_month_required";
    CommonVerbiage["date_of_birth_year_invalid"] = "date_of_birth_year_invalid";
    CommonVerbiage["dayLabel"] = "dayLabel";
    CommonVerbiage["day_streak"] = "day_streak";
    CommonVerbiage["days"] = "days";
    CommonVerbiage["decline"] = "decline";
    CommonVerbiage["decline_bonus"] = "decline_bonus";
    CommonVerbiage["declined"] = "declined";
    CommonVerbiage["dedicated_affiliate_managers"] = "dedicated_affiliate_managers";
    CommonVerbiage["dedicated_vip_host"] = "dedicated_vip_host";
    CommonVerbiage["dedicated_vip_host_text"] = "dedicated_vip_host_text";
    CommonVerbiage["default"] = "default";
    CommonVerbiage["delete"] = "delete";
    CommonVerbiage["demo_play"] = "demo_play";
    CommonVerbiage["deposit"] = "deposit";
    CommonVerbiage["deposit_address"] = "deposit_address";
    CommonVerbiage["deposit_bonus"] = "deposit_bonus";
    CommonVerbiage["deposit_bonus_accept"] = "deposit_bonus_accept";
    CommonVerbiage["deposit_bonus_accepted"] = "deposit_bonus_accepted";
    CommonVerbiage["deposit_bonus_decline"] = "deposit_bonus_decline";
    CommonVerbiage["deposit_bonus_declined"] = "deposit_bonus_declined";
    CommonVerbiage["deposit_bonus_description"] = "deposit_bonus_description";
    CommonVerbiage["deposit_bonus_terms"] = "deposit_bonus_terms";
    CommonVerbiage["deposit_bonus_text"] = "deposit_bonus_text";
    CommonVerbiage["deposit_bonus_title"] = "deposit_bonus_title";
    CommonVerbiage["deposit_cash"] = "deposit_cash";
    CommonVerbiage["deposit_crypto"] = "deposit_crypto";
    CommonVerbiage["deposit_disabled"] = "deposit_disabled";
    CommonVerbiage["deposit_error_button"] = "deposit_error_button";
    CommonVerbiage["deposit_error_subtitle"] = "deposit_error_subtitle";
    CommonVerbiage["deposit_error_title"] = "deposit_error_title";
    CommonVerbiage["deposit_fiat"] = "deposit_fiat";
    CommonVerbiage["deposit_fiat_text"] = "deposit_fiat_text";
    CommonVerbiage["deposit_first"] = "deposit_first";
    CommonVerbiage["deposit_from"] = "deposit_from";
    CommonVerbiage["deposit_funds"] = "deposit_funds";
    CommonVerbiage["deposit_meme_coins"] = "deposit_meme_coins";
    CommonVerbiage["deposit_method"] = "deposit_method";
    CommonVerbiage["deposit_minimum"] = "deposit_minimum";
    CommonVerbiage["deposit_minimum_wager_within"] = "deposit_minimum_wager_within";
    CommonVerbiage["deposit_options"] = "deposit_options";
    CommonVerbiage["deposit_pending_notification_text"] = "deposit_pending_notification_text";
    CommonVerbiage["deposit_pending_notification_title"] = "deposit_pending_notification_title";
    CommonVerbiage["deposit_success_button"] = "deposit_success_button";
    CommonVerbiage["deposit_success_notification_text"] = "deposit_success_notification_text";
    CommonVerbiage["deposit_success_notification_title"] = "deposit_success_notification_title";
    CommonVerbiage["deposit_success_title"] = "deposit_success_title";
    CommonVerbiage["deposits"] = "deposits";
    CommonVerbiage["description"] = "description";
    CommonVerbiage["details"] = "details";
    CommonVerbiage["dev_settings"] = "dev_settings";
    CommonVerbiage["diamond"] = "diamond";
    CommonVerbiage["dice"] = "dice";
    CommonVerbiage["different_commission_schemes"] = "different_commission_schemes";
    CommonVerbiage["disable"] = "disable";
    CommonVerbiage["disabled"] = "disabled";
    CommonVerbiage["disable_login_via_wallet"] = "disable_login_via_wallet";
    CommonVerbiage["disclaimer"] = "disclaimer";
    CommonVerbiage["disconnect"] = "disconnect";
    CommonVerbiage["discover_games"] = "discover_games";
    CommonVerbiage["display_in_fiat"] = "display_in_fiat";
    CommonVerbiage["display_name"] = "display_name";
    CommonVerbiage["display_name_note"] = "display_name_note";
    CommonVerbiage["distribution_day_increase_text"] = "distribution_day_increase_text";
    CommonVerbiage["do_not_send_on"] = "do_not_send_on";
    CommonVerbiage["do_not_send_to"] = "do_not_send_to";
    CommonVerbiage["dota"] = "dota";
    CommonVerbiage["double_bet_amount"] = "double_bet_amount";
    CommonVerbiage["double_first_deposit_description"] = "double_first_deposit_description";
    CommonVerbiage["double_first_deposit_first_part_title"] = "double_first_deposit_first_part_title";
    CommonVerbiage["double_first_deposit_second_part_title"] = "double_first_deposit_second_part_title";
    CommonVerbiage["double_first_deposit_title_highlight"] = "double_first_deposit_title_highlight";
    CommonVerbiage["download_as_csv_file"] = "download_as_csv_file";
    CommonVerbiage["e_cricket"] = "e_cricket";
    CommonVerbiage["earn_cashback_bonuses_description"] = "earn_cashback_bonuses_description";
    CommonVerbiage["earn_rakeback_rewards_description"] = "earn_rakeback_rewards_description";
    CommonVerbiage["earn_up_to"] = "earn_up_to";
    CommonVerbiage["earn_with"] = "earn_with";
    CommonVerbiage["earn_with_text"] = "earn_with_text";
    CommonVerbiage["earnings_potential_with_partners"] = "earnings_potential_with_partners";
    CommonVerbiage["edit"] = "edit";
    CommonVerbiage["efighting"] = "efighting";
    CommonVerbiage["ehorse_racing"] = "ehorse_racing";
    CommonVerbiage["email"] = "email";
    CommonVerbiage["enter_your_email_address"] = "enter_your_email_address";
    CommonVerbiage["enter_your_password"] = "enter_your_password";
    CommonVerbiage["enter_your_username"] = "enter_your_username";
    CommonVerbiage["enter_your_username_or_email"] = "enter_your_username_or_email";
    CommonVerbiage["email_address"] = "email_address";
    CommonVerbiage["email_address_invalid"] = "email_address_invalid";
    CommonVerbiage["email_address_required"] = "email_address_required";
    CommonVerbiage["email_already_in_use"] = "email_already_in_use";
    CommonVerbiage["email_not_verified"] = "email_not_verified";
    CommonVerbiage["email_preferences"] = "email_preferences";
    CommonVerbiage["email_required"] = "email_required";
    CommonVerbiage["email_required_for_withdrawal"] = "email_required_for_withdrawal";
    CommonVerbiage["email_sub_cashier"] = "email_sub_cashier";
    CommonVerbiage["email_sub_daily"] = "email_sub_daily";
    CommonVerbiage["email_sub_monthly"] = "email_sub_monthly";
    CommonVerbiage["email_sub_personalized"] = "email_sub_personalized";
    CommonVerbiage["email_sub_sportsbook"] = "email_sub_sportsbook";
    CommonVerbiage["email_sub_subscribe_all"] = "email_sub_subscribe_all";
    CommonVerbiage["email_sub_unsubscribe_all"] = "email_sub_unsubscribe_all";
    CommonVerbiage["email_sub_weekly"] = "email_sub_weekly";
    CommonVerbiage["emerald"] = "emerald";
    CommonVerbiage["empty_personal_notifications_message"] = "empty_personal_notifications_message";
    CommonVerbiage["empty_platform_notifications_message"] = "empty_platform_notifications_message";
    CommonVerbiage["enable"] = "enable";
    CommonVerbiage["enable_2fa"] = "enable_2fa";
    CommonVerbiage["enable_2fa_text"] = "enable_2fa_text";
    CommonVerbiage["enabled"] = "enabled";
    CommonVerbiage["enable_login_via_wallet"] = "enable_login_via_wallet";
    CommonVerbiage["ended"] = "ended";
    CommonVerbiage["english"] = "english";
    CommonVerbiage["enter"] = "enter";
    CommonVerbiage["enter_a_campaign_name"] = "enter_a_campaign_name";
    CommonVerbiage["enter_a_referral_code"] = "enter_a_referral_code";
    CommonVerbiage["enter_address"] = "enter_address";
    CommonVerbiage["enter_amount_greater_than_zero"] = "enter_amount_greater_than_zero";
    CommonVerbiage["enter_now"] = "enter_now";
    CommonVerbiage["enter_valid_number_of_people"] = "enter_valid_number_of_people";
    CommonVerbiage["enter_valid_username"] = "enter_valid_username";
    CommonVerbiage["enter_phone_verification_code"] = "enter_phone_verification_code";
    CommonVerbiage["enter_verify"] = "enter_verify";
    CommonVerbiage["equation"] = "equation";
    CommonVerbiage["error"] = "error";
    CommonVerbiage["error_body"] = "error_body";
    CommonVerbiage["error_creating_rain"] = "error_creating_rain";
    CommonVerbiage["error_description"] = "error_description";
    CommonVerbiage["error_game_bonus"] = "error_game_bonus";
    CommonVerbiage["error_game_currency"] = "error_game_currency";
    CommonVerbiage["error_game_geo"] = "error_game_geo";
    CommonVerbiage["error_game_maintenance"] = "error_game_maintenance";
    CommonVerbiage["error_game_title"] = "error_game_title";
    CommonVerbiage["error_game_unavailable"] = "error_game_unavailable";
    CommonVerbiage["error_removing_address"] = "error_removing_address";
    CommonVerbiage["error_searching_for_player"] = "error_searching_for_player";
    CommonVerbiage["esports"] = "esports";
    CommonVerbiage["esports_betting"] = "esports_betting";
    CommonVerbiage["esports_live_betting"] = "esports_live_betting";
    CommonVerbiage["error_title"] = "error_title";
    CommonVerbiage["europe"] = "europe";
    CommonVerbiage["evoplay_has_landed"] = "evoplay_has_landed";
    CommonVerbiage["evoplay_has_landed_description"] = "evoplay_has_landed_description";
    CommonVerbiage["every_spin_pays_out"] = "every_spin_pays_out";
    CommonVerbiage["exceeded_maximum_users"] = "exceeded_maximum_users";
    CommonVerbiage["exclusive"] = "exclusive";
    CommonVerbiage["exclusive_affiliate_program"] = "exclusive_affiliate_program";
    CommonVerbiage["exclusive_affiliate_program_text"] = "exclusive_affiliate_program_text";
    CommonVerbiage["exclusive_events_text"] = "exclusive_events_text";
    CommonVerbiage["exclusive_vip_events"] = "exclusive_vip_events";
    CommonVerbiage["expired"] = "expired";
    CommonVerbiage["expires"] = "expires";
    CommonVerbiage["expanded_hero_invite_friends_and_earn_title"] = "expanded_hero_invite_friends_and_earn_title";
    CommonVerbiage["expanded_hero_invite_now_cta"] = "expanded_hero_invite_now_cta";
    CommonVerbiage["expanded_hero_up_to_35_percent_commission"] = "expanded_hero_up_to_35_percent_commission";
    CommonVerbiage["f1"] = "f1";
    CommonVerbiage["failed"] = "failed";
    CommonVerbiage["failed_create_update_review"] = "failed_create_update_review";
    CommonVerbiage["failed_delete_review"] = "failed_delete_review";
    CommonVerbiage["failed_submit_review"] = "failed_submit_review";
    CommonVerbiage["fairness"] = "fairness";
    CommonVerbiage["fairness_and_rng"] = "fairness_and_rng";
    CommonVerbiage["faq_about_refer_and_earn_1"] = "faq_about_refer_and_earn_1";
    CommonVerbiage["faq_about_refer_and_earn_1_answer"] = "faq_about_refer_and_earn_1_answer";
    CommonVerbiage["faq_about_refer_and_earn_2"] = "faq_about_refer_and_earn_2";
    CommonVerbiage["faq_about_refer_and_earn_2_answer"] = "faq_about_refer_and_earn_2_answer";
    CommonVerbiage["faq_about_refer_and_earn_3"] = "faq_about_refer_and_earn_3";
    CommonVerbiage["faq_about_refer_and_earn_3_answer"] = "faq_about_refer_and_earn_3_answer";
    CommonVerbiage["faq_about_refer_and_earn_4"] = "faq_about_refer_and_earn_4";
    CommonVerbiage["faq_about_refer_and_earn_4_answer"] = "faq_about_refer_and_earn_4_answer";
    CommonVerbiage["faq_about_refer_and_earn_5"] = "faq_about_refer_and_earn_5";
    CommonVerbiage["faq_about_refer_and_earn_5_answer"] = "faq_about_refer_and_earn_5_answer";
    CommonVerbiage["faq_about_refer_and_earn_6"] = "faq_about_refer_and_earn_6";
    CommonVerbiage["faq_about_refer_and_earn_6_answer"] = "faq_about_refer_and_earn_6_answer";
    CommonVerbiage["faq_about_refer_and_earn_7"] = "faq_about_refer_and_earn_7";
    CommonVerbiage["faq_about_refer_and_earn_7_answer"] = "faq_about_refer_and_earn_7_answer";
    CommonVerbiage["faq_about_refer_and_earn_8"] = "faq_about_refer_and_earn_8";
    CommonVerbiage["faq_about_refer_and_earn_8_answer"] = "faq_about_refer_and_earn_8_answer";
    CommonVerbiage["faq_referral_dashboard_1"] = "faq_referral_dashboard_1";
    CommonVerbiage["faq_referral_dashboard_1_answer"] = "faq_referral_dashboard_1_answer";
    CommonVerbiage["faq_referral_dashboard_2"] = "faq_referral_dashboard_2";
    CommonVerbiage["faq_referral_dashboard_2_answer"] = "faq_referral_dashboard_2_answer";
    CommonVerbiage["faq_referral_dashboard_3"] = "faq_referral_dashboard_3";
    CommonVerbiage["faq_referral_dashboard_3_answer"] = "faq_referral_dashboard_3_answer";
    CommonVerbiage["faq_referral_dashboard_4"] = "faq_referral_dashboard_4";
    CommonVerbiage["faq_referral_dashboard_4_answer"] = "faq_referral_dashboard_4_answer";
    CommonVerbiage["faq_referral_dashboard_5"] = "faq_referral_dashboard_5";
    CommonVerbiage["faq_referral_dashboard_5_answer"] = "faq_referral_dashboard_5_answer";
    CommonVerbiage["faq_referral_dashboard_6"] = "faq_referral_dashboard_6";
    CommonVerbiage["faq_referral_dashboard_6_answer"] = "faq_referral_dashboard_6_answer";
    CommonVerbiage["faq_referral_dashboard_7"] = "faq_referral_dashboard_7";
    CommonVerbiage["faq_referral_dashboard_7_answer"] = "faq_referral_dashboard_7_answer";
    CommonVerbiage["faq_referral_dashboard_8"] = "faq_referral_dashboard_8";
    CommonVerbiage["faq_referral_dashboard_8_answer"] = "faq_referral_dashboard_8_answer";
    CommonVerbiage["fast_efficient_payments"] = "fast_efficient_payments";
    CommonVerbiage["favorites"] = "favorites";
    CommonVerbiage["favorite_team"] = "favorite_team";
    CommonVerbiage["favourite"] = "favourite";
    CommonVerbiage["favourite_game"] = "favourite_game";
    CommonVerbiage["favourite_token_coin"] = "favourite_token_coin";
    CommonVerbiage["feature_buy_in"] = "feature_buy_in";
    CommonVerbiage["feature_buy_in_slots"] = "feature_buy_in_slots";
    CommonVerbiage["feature_temporary_unavailable"] = "feature_temporary_unavailable";
    CommonVerbiage["feature_unavailable_description"] = "feature_unavailable_description";
    CommonVerbiage["feature_unavailable_thanks"] = "feature_unavailable_thanks";
    CommonVerbiage["feature_unavailable_title"] = "feature_unavailable_title";
    CommonVerbiage["featured_provider"] = "featured_provider";
    CommonVerbiage["features_text"] = "features_text";
    CommonVerbiage["fee"] = "fee";
    CommonVerbiage["fifa"] = "fifa";
    CommonVerbiage["fifteen_per_page"] = "fifteen_per_page";
    CommonVerbiage["finishes"] = "finishes";
    CommonVerbiage["first_name"] = "first_name";
    CommonVerbiage["first_name_required"] = "first_name_required";
    CommonVerbiage["firstNameLabel"] = "firstNameLabel";
    CommonVerbiage["firstNamePlaceholder"] = "firstNamePlaceholder";
    CommonVerbiage["fist_of_destruction_megamultiplier"] = "fist_of_destruction_megamultiplier";
    CommonVerbiage["fist_of_destruction_megamultiplier_description"] = "fist_of_destruction_megamultiplier_description";
    CommonVerbiage["five_per_page"] = "five_per_page";
    CommonVerbiage["floorball"] = "floorball";
    CommonVerbiage["flush_crypto_casino"] = "flush_crypto_casino";
    CommonVerbiage["flush_races"] = "flush_races";
    CommonVerbiage["flush_races_description"] = "flush_races_description";
    CommonVerbiage["FOMO_bets"] = "FOMO_bets";
    CommonVerbiage["FOMO_bets02"] = "FOMO_bets02";
    CommonVerbiage["fomo_deposit_bonus"] = "fomo_deposit_bonus";
    CommonVerbiage["fomo_deposit_bonus_description"] = "fomo_deposit_bonus_description";
    CommonVerbiage["FOMO_jackpot"] = "FOMO_jackpot";
    CommonVerbiage["fomo_jackpot_description"] = "fomo_jackpot_description";
    CommonVerbiage["fomo_jackpot_first_part_title"] = "fomo_jackpot_first_part_title";
    CommonVerbiage["fomo_jackpot_second_part_title"] = "fomo_jackpot_second_part_title";
    CommonVerbiage["fomo_jackpot_title_highlight"] = "fomo_jackpot_title_highlight";
    CommonVerbiage["fomo_limited_cashback"] = "fomo_limited_cashback";
    CommonVerbiage["fomo_limited_cashback_description"] = "fomo_limited_cashback_description";
    CommonVerbiage["fomo_points"] = "fomo_points";
    CommonVerbiage["fomo_points02"] = "fomo_points02";
    CommonVerbiage["fomo_betby_betslip"] = "fomo_betby_betslip";
    CommonVerbiage["fomo_registration_reward"] = "fomo_registration_reward";
    CommonVerbiage["fomo_registration_reward_description"] = "fomo_registration_reward_description";
    CommonVerbiage["fomo_sidebar_exclusive"] = "fomo_sidebar_exclusive";
    CommonVerbiage["fomo_sidebar_updown_game"] = "fomo_sidebar_updown_game";
    CommonVerbiage["fomo_vip_rank_all"] = "fomo_vip_rank_all";
    CommonVerbiage["fomo_vip_rank_current"] = "fomo_vip_rank_current";
    CommonVerbiage["fomo_vip_rank_next"] = "fomo_vip_rank_next";
    CommonVerbiage["fomo_vip_rank_play"] = "fomo_vip_rank_play";
    CommonVerbiage["fomo_vip_rank_progress"] = "fomo_vip_rank_progress";
    CommonVerbiage["fomo_vip_rank_reward"] = "fomo_vip_rank_reward";
    CommonVerbiage["fomo_vip_rank_title"] = "fomo_vip_rank_title";
    CommonVerbiage["fomo_vip_rank_wagering"] = "fomo_vip_rank_wagering";
    CommonVerbiage["fomoio_150_welcome"] = "fomoio_150_welcome";
    CommonVerbiage["fomoio_affiliate_agreement"] = "fomoio_affiliate_agreement";
    CommonVerbiage["fomoio_affiliate_managers_details"] = "fomoio_affiliate_managers_details";
    CommonVerbiage["fomoio_affiliate_marketing_promotion"] = "fomoio_affiliate_marketing_promotion";
    CommonVerbiage["fomoio_affiliate_terms_conditions"] = "fomoio_affiliate_terms_conditions";
    CommonVerbiage["fomoio_all_tiers_benefits_description"] = "fomoio_all_tiers_benefits_description";
    CommonVerbiage["fomoio_and_earn_the_best_rewards_available"] = "fomoio_and_earn_the_best_rewards_available";
    CommonVerbiage["fomoio_anniversary_bonus_text"] = "fomoio_anniversary_bonus_text";
    CommonVerbiage["fomoio_answer_daily_weekly_monthly"] = "fomoio_answer_daily_weekly_monthly";
    CommonVerbiage["fomoio_answer_how_communicate"] = "fomoio_answer_how_communicate";
    CommonVerbiage["fomoio_answer_how_ofter_bonuses"] = "fomoio_answer_how_ofter_bonuses";
    CommonVerbiage["fomoio_answer_monthly_bonus"] = "fomoio_answer_monthly_bonus";
    CommonVerbiage["fomoio_answer_vip_club_stand_out"] = "fomoio_answer_vip_club_stand_out";
    CommonVerbiage["fomoio_answer_wagering"] = "fomoio_answer_wagering";
    CommonVerbiage["fomoio_answer_what_are_calendar_distribuition_days"] = "fomoio_answer_what_are_calendar_distribuition_days";
    CommonVerbiage["fomoio_answer_what_is_cashback"] = "fomoio_answer_what_is_cashback";
    CommonVerbiage["fomoio_answer_what_is_happy_hour"] = "fomoio_answer_what_is_happy_hour";
    CommonVerbiage["fomoio_answer_what_is_rakeback"] = "fomoio_answer_what_is_rakeback";
    CommonVerbiage["fomoio_answer_which_tier_im_on"] = "fomoio_answer_which_tier_im_on";
    CommonVerbiage["fomoio_approval_time_for_program"] = "fomoio_approval_time_for_program";
    CommonVerbiage["fomoio_approval_time_for_program_answer"] = "fomoio_approval_time_for_program_answer";
    CommonVerbiage["fomoio_as_you_and_your_friends"] = "fomoio_as_you_and_your_friends";
    CommonVerbiage["fomoio_balance"] = "fomoio_balance";
    CommonVerbiage["fomoio_become_royalty_text"] = "fomoio_become_royalty_text";
    CommonVerbiage["fomoio_beginner_affiliate_marketing"] = "fomoio_beginner_affiliate_marketing";
    CommonVerbiage["fomoio_beginner_affiliate_marketing_answer"] = "fomoio_beginner_affiliate_marketing_answer";
    CommonVerbiage["fomoio_bitcoin_play_testimonial"] = "fomoio_bitcoin_play_testimonial";
    CommonVerbiage["fomoio_bonus"] = "fomoio_bonus";
    CommonVerbiage["fomoio_bonus_per_referral"] = "fomoio_bonus_per_referral";
    CommonVerbiage["fomoio_buy_crypto_tooltip"] = "fomoio_buy_crypto_tooltip";
    CommonVerbiage["fomoio_by_simply_getting"] = "fomoio_by_simply_getting";
    CommonVerbiage["fomoio_calculation"] = "fomoio_calculation";
    CommonVerbiage["fomoio_calendar_claimable_days"] = "fomoio_calendar_claimable_days";
    CommonVerbiage["fomoio_calendar_distribution_days_text"] = "fomoio_calendar_distribution_days_text";
    CommonVerbiage["fomoio_calendar_text"] = "fomoio_calendar_text";
    CommonVerbiage["fomoio_cashback_bonuses_description"] = "fomoio_cashback_bonuses_description";
    CommonVerbiage["fomoio_cashback_bonuses02_description"] = "fomoio_cashback_bonuses02_description";
    CommonVerbiage["fomoio_comission_plan"] = "fomoio_comission_plan";
    CommonVerbiage["fomoio_commission"] = "fomoio_commission";
    CommonVerbiage["fomoio_commission_calculation_details"] = "fomoio_commission_calculation_details";
    CommonVerbiage["fomoio_commission_calculation_details_answer"] = "fomoio_commission_calculation_details_answer";
    CommonVerbiage["fomoio_commission_from_new_affiliates"] = "fomoio_commission_from_new_affiliates";
    CommonVerbiage["fomoio_commission_from_new_affiliates_answer"] = "fomoio_commission_from_new_affiliates_answer";
    CommonVerbiage["fomoio_commission_levels_title"] = "fomoio_commission_levels_title";
    CommonVerbiage["fomoio_commission_payment_frequency"] = "fomoio_commission_payment_frequency";
    CommonVerbiage["fomoio_commission_payment_frequency_answer"] = "fomoio_commission_payment_frequency_answer";
    CommonVerbiage["fomoio_commission_plan"] = "fomoio_commission_plan";
    CommonVerbiage["fomoio_commission_schemes_details"] = "fomoio_commission_schemes_details";
    CommonVerbiage["fomoio_company"] = "fomoio_company";
    CommonVerbiage["fomoio_consistent_rewards_description"] = "fomoio_consistent_rewards_description";
    CommonVerbiage["fomoio_consistent_rewards02_description"] = "fomoio_consistent_rewards02_description";
    CommonVerbiage["fomoio_contact_partners"] = "fomoio_contact_partners";
    CommonVerbiage["fomoio_contact_partners_answer"] = "fomoio_contact_partners_answer";
    CommonVerbiage["fomoio_contact_us"] = "fomoio_contact_us";
    CommonVerbiage["fomoio_crash_and_win_description"] = "fomoio_crash_and_win_description";
    CommonVerbiage["fomoio_crypto_casino"] = "fomoio_crypto_casino";
    CommonVerbiage["fomoio_crypto_casino_description"] = "fomoio_crypto_casino_description";
    CommonVerbiage["fomoio_custom_vip_bonuses"] = "fomoio_custom_vip_bonuses";
    CommonVerbiage["fomoio_daily_bonus_text"] = "fomoio_daily_bonus_text";
    CommonVerbiage["fomoio_daily_bonuses_text"] = "fomoio_daily_bonuses_text";
    CommonVerbiage["fomoio_daily_cashback"] = "fomoio_daily_cashback";
    CommonVerbiage["fomoio_days"] = "fomoio_days";
    CommonVerbiage["fomoio_dedicated_affiliate_managers"] = "fomoio_dedicated_affiliate_managers";
    CommonVerbiage["fomoio_dedicated_vip_host"] = "fomoio_dedicated_vip_host";
    CommonVerbiage["fomoio_dedicated_vip_host_text"] = "fomoio_dedicated_vip_host_text";
    CommonVerbiage["fomoio_different_commission_schemes"] = "fomoio_different_commission_schemes";
    CommonVerbiage["fomoio_distribution_day_increase_text"] = "fomoio_distribution_day_increase_text";
    CommonVerbiage["fomoio_earn_cashback_bonuses_description"] = "fomoio_earn_cashback_bonuses_description";
    CommonVerbiage["fomoio_earn_rakeback_rewards_description"] = "fomoio_earn_rakeback_rewards_description";
    CommonVerbiage["fomoio_earn_up_to"] = "fomoio_earn_up_to";
    CommonVerbiage["fomoio_earnings_potential_with_partners"] = "fomoio_earnings_potential_with_partners";
    CommonVerbiage["fomoio_email_address"] = "fomoio_email_address";
    CommonVerbiage["fomoio_enter_your_email_address"] = "fomoio_enter_your_email_address";
    CommonVerbiage["fomoio_equation"] = "fomoio_equation";
    CommonVerbiage["fomoio_exclusive_events_text"] = "fomoio_exclusive_events_text";
    CommonVerbiage["fomoio_exclusive_vip_events"] = "fomoio_exclusive_vip_events";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_1"] = "fomoio_faq_about_refer_and_earn_1";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_1_answer"] = "fomoio_faq_about_refer_and_earn_1_answer";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_2"] = "fomoio_faq_about_refer_and_earn_2";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_2_answer"] = "fomoio_faq_about_refer_and_earn_2_answer";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_3"] = "fomoio_faq_about_refer_and_earn_3";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_3_answer"] = "fomoio_faq_about_refer_and_earn_3_answer";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_4"] = "fomoio_faq_about_refer_and_earn_4";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_4_answer"] = "fomoio_faq_about_refer_and_earn_4_answer";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_5"] = "fomoio_faq_about_refer_and_earn_5";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_5_answer"] = "fomoio_faq_about_refer_and_earn_5_answer";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_6"] = "fomoio_faq_about_refer_and_earn_6";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_6_answer"] = "fomoio_faq_about_refer_and_earn_6_answer";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_7"] = "fomoio_faq_about_refer_and_earn_7";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_7_answer"] = "fomoio_faq_about_refer_and_earn_7_answer";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_8"] = "fomoio_faq_about_refer_and_earn_8";
    CommonVerbiage["fomoio_faq_about_refer_and_earn_8_answer"] = "fomoio_faq_about_refer_and_earn_8_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_1"] = "fomoio_faq_referral_dashboard_1";
    CommonVerbiage["fomoio_faq_referral_dashboard_1_answer"] = "fomoio_faq_referral_dashboard_1_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_2"] = "fomoio_faq_referral_dashboard_2";
    CommonVerbiage["fomoio_faq_referral_dashboard_2_answer"] = "fomoio_faq_referral_dashboard_2_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_3"] = "fomoio_faq_referral_dashboard_3";
    CommonVerbiage["fomoio_faq_referral_dashboard_3_answer"] = "fomoio_faq_referral_dashboard_3_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_4"] = "fomoio_faq_referral_dashboard_4";
    CommonVerbiage["fomoio_faq_referral_dashboard_4_answer"] = "fomoio_faq_referral_dashboard_4_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_5"] = "fomoio_faq_referral_dashboard_5";
    CommonVerbiage["fomoio_faq_referral_dashboard_5_answer"] = "fomoio_faq_referral_dashboard_5_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_6"] = "fomoio_faq_referral_dashboard_6";
    CommonVerbiage["fomoio_faq_referral_dashboard_6_answer"] = "fomoio_faq_referral_dashboard_6_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_7"] = "fomoio_faq_referral_dashboard_7";
    CommonVerbiage["fomoio_faq_referral_dashboard_7_answer"] = "fomoio_faq_referral_dashboard_7_answer";
    CommonVerbiage["fomoio_faq_referral_dashboard_8"] = "fomoio_faq_referral_dashboard_8";
    CommonVerbiage["fomoio_faq_referral_dashboard_8_answer"] = "fomoio_faq_referral_dashboard_8_answer";
    CommonVerbiage["fomoio_fast_efficient_payments"] = "fomoio_fast_efficient_payments";
    CommonVerbiage["fomoio_favorite_games"] = "fomoio_favorite_games";
    CommonVerbiage["fomoio_features_text"] = "fomoio_features_text";
    CommonVerbiage["fomoio_first_name"] = "fomoio_first_name";
    CommonVerbiage["fomoio_frequently_asked_questions"] = "fomoio_frequently_asked_questions";
    CommonVerbiage["fomoio_frequently_asked_questions_text"] = "fomoio_frequently_asked_questions_text";
    CommonVerbiage["fomoio_friends"] = "fomoio_friends";
    CommonVerbiage["fomoio_friends_level"] = "fomoio_friends_level";
    CommonVerbiage["fomoio_games_details"] = "fomoio_games_details";
    CommonVerbiage["fomoio_get_up_to_25"] = "fomoio_get_up_to_25";
    CommonVerbiage["fomoio_getting_started"] = "fomoio_getting_started";
    CommonVerbiage["fomoio_high_ngr_increased_revenue"] = "fomoio_high_ngr_increased_revenue";
    CommonVerbiage["fomoio_house_edge"] = "fomoio_house_edge";
    CommonVerbiage["fomoio_i_want_to_earn_monthly"] = "fomoio_i_want_to_earn_monthly";
    CommonVerbiage["fomoio_invite_only_promotions"] = "fomoio_invite_only_promotions";
    CommonVerbiage["fomoio_invite_referrals"] = "fomoio_invite_referrals";
    CommonVerbiage["fomoio_invite_your"] = "fomoio_invite_your";
    CommonVerbiage["fomoio_join_now_text"] = "fomoio_join_now_text";
    CommonVerbiage["fomoio_join_vip_club_call_to_action"] = "fomoio_join_vip_club_call_to_action";
    CommonVerbiage["fomoio_last_name"] = "fomoio_last_name";
    CommonVerbiage["fomoio_level_up_reward_text"] = "fomoio_level_up_reward_text";
    CommonVerbiage["fomoio_level_up_rewards_description"] = "fomoio_level_up_rewards_description";
    CommonVerbiage["fomoio_level_up_rewards_earnings_description"] = "fomoio_level_up_rewards_earnings_description";
    CommonVerbiage["fomoio_level_up_rewards02_description"] = "fomoio_level_up_rewards02_description";
    CommonVerbiage["fomoio_lifetime_commissions"] = "fomoio_lifetime_commissions";
    CommonVerbiage["fomoio_lifetime_commissions_details"] = "fomoio_lifetime_commissions_details";
    CommonVerbiage["fomoio_like_what_you_see_text"] = "fomoio_like_what_you_see_text";
    CommonVerbiage["fomoio_maximize_playtime_rewards_description"] = "fomoio_maximize_playtime_rewards_description";
    CommonVerbiage["fomoio_message"] = "fomoio_message";
    CommonVerbiage["fomoio_minimum_deposit_tooltip"] = "fomoio_minimum_deposit_tooltip";
    CommonVerbiage["fomoio_monthly_bonus_text"] = "fomoio_monthly_bonus_text";
    CommonVerbiage["fomoio_monthly_bonuses_text"] = "fomoio_monthly_bonuses_text";
    CommonVerbiage["fomoio_monthly_cashback"] = "fomoio_monthly_cashback";
    CommonVerbiage["fomoio_more_text"] = "fomoio_more_text";
    CommonVerbiage["fomoio_negative_balances_policy"] = "fomoio_negative_balances_policy";
    CommonVerbiage["fomoio_negative_balances_policy_answer"] = "fomoio_negative_balances_policy_answer";
    CommonVerbiage["fomoio_ngr_details"] = "fomoio_ngr_details";
    CommonVerbiage["fomoio_originals"] = "fomoio_originals";
    CommonVerbiage["fomoio_partner_review_1"] = "fomoio_partner_review_1";
    CommonVerbiage["fomoio_partner_review_10"] = "fomoio_partner_review_10";
    CommonVerbiage["fomoio_partner_review_11"] = "fomoio_partner_review_11";
    CommonVerbiage["fomoio_partner_review_12"] = "fomoio_partner_review_12";
    CommonVerbiage["fomoio_partner_review_13"] = "fomoio_partner_review_13";
    CommonVerbiage["fomoio_partner_review_14"] = "fomoio_partner_review_14";
    CommonVerbiage["fomoio_partner_review_15"] = "fomoio_partner_review_15";
    CommonVerbiage["fomoio_partner_review_16"] = "fomoio_partner_review_16";
    CommonVerbiage["fomoio_partner_review_17"] = "fomoio_partner_review_17";
    CommonVerbiage["fomoio_partner_review_18"] = "fomoio_partner_review_18";
    CommonVerbiage["fomoio_partner_review_19"] = "fomoio_partner_review_19";
    CommonVerbiage["fomoio_partner_review_2"] = "fomoio_partner_review_2";
    CommonVerbiage["fomoio_partner_review_20"] = "fomoio_partner_review_20";
    CommonVerbiage["fomoio_partner_review_21"] = "fomoio_partner_review_21";
    CommonVerbiage["fomoio_partner_review_22"] = "fomoio_partner_review_22";
    CommonVerbiage["fomoio_partner_review_23"] = "fomoio_partner_review_23";
    CommonVerbiage["fomoio_partner_review_3"] = "fomoio_partner_review_3";
    CommonVerbiage["fomoio_partner_review_4"] = "fomoio_partner_review_4";
    CommonVerbiage["fomoio_partner_review_5"] = "fomoio_partner_review_5";
    CommonVerbiage["fomoio_partner_review_6"] = "fomoio_partner_review_6";
    CommonVerbiage["fomoio_partner_review_7"] = "fomoio_partner_review_7";
    CommonVerbiage["fomoio_partner_review_8"] = "fomoio_partner_review_8";
    CommonVerbiage["fomoio_partner_review_9"] = "fomoio_partner_review_9";
    CommonVerbiage["fomoio_partner_testimonials"] = "fomoio_partner_testimonials";
    CommonVerbiage["fomoio_partners_perks"] = "fomoio_partners_perks";
    CommonVerbiage["fomoio_partners_program"] = "fomoio_partners_program";
    CommonVerbiage["fomoio_partners_program_overview"] = "fomoio_partners_program_overview";
    CommonVerbiage["fomoio_partners_program_overview_answer"] = "fomoio_partners_program_overview_answer";
    CommonVerbiage["fomoio_payment_details"] = "fomoio_payment_details";
    CommonVerbiage["fomoio_potencial_questions"] = "fomoio_potencial_questions";
    CommonVerbiage["fomoio_program_working_details"] = "fomoio_program_working_details";
    CommonVerbiage["fomoio_program_working_details_answer"] = "fomoio_program_working_details_answer";
    CommonVerbiage["fomoio_promotion_restrictions"] = "fomoio_promotion_restrictions";
    CommonVerbiage["fomoio_promotion_restrictions_answer"] = "fomoio_promotion_restrictions_answer";
    CommonVerbiage["fomoio_promotional_materials_provided"] = "fomoio_promotional_materials_provided";
    CommonVerbiage["fomoio_promotional_materials_provided_answer"] = "fomoio_promotional_materials_provided_answer";
    CommonVerbiage["fomoio_promotions_details"] = "fomoio_promotions_details";
    CommonVerbiage["fomoio_question_daily_weekly_monthly"] = "fomoio_question_daily_weekly_monthly";
    CommonVerbiage["fomoio_question_how_communicate"] = "fomoio_question_how_communicate";
    CommonVerbiage["fomoio_question_how_ofter_bonuses"] = "fomoio_question_how_ofter_bonuses";
    CommonVerbiage["fomoio_question_monthly_bonus"] = "fomoio_question_monthly_bonus";
    CommonVerbiage["fomoio_question_vip_club_stand_out"] = "fomoio_question_vip_club_stand_out";
    CommonVerbiage["fomoio_question_wagering"] = "fomoio_question_wagering";
    CommonVerbiage["fomoio_question_what_are_calendar_distribuition_days"] = "fomoio_question_what_are_calendar_distribuition_days";
    CommonVerbiage["fomoio_question_what_is_cashback"] = "fomoio_question_what_is_cashback";
    CommonVerbiage["fomoio_question_what_is_happy_hour"] = "fomoio_question_what_is_happy_hour";
    CommonVerbiage["fomoio_question_what_is_rakeback"] = "fomoio_question_what_is_rakeback";
    CommonVerbiage["fomoio_question_which_tier_im_on"] = "fomoio_question_which_tier_im_on";
    CommonVerbiage["fomoio_races"] = "fomoio_races";
    CommonVerbiage["fomoio_races_description"] = "fomoio_races_description";
    CommonVerbiage["fomoio_raise_your_game_and_stay"] = "fomoio_raise_your_game_and_stay";
    CommonVerbiage["fomoio_rakeback"] = "fomoio_rakeback";
    CommonVerbiage["fomoio_rakeback_perks_description"] = "fomoio_rakeback_perks_description";
    CommonVerbiage["fomoio_rakeback_perks02_description"] = "fomoio_rakeback_perks02_description";
    CommonVerbiage["fomoio_rakeback_text"] = "fomoio_rakeback_text";
    CommonVerbiage["fomoio_rakeboost"] = "fomoio_rakeboost";
    CommonVerbiage["fomoio_rakeboost_description"] = "fomoio_rakeboost_description";
    CommonVerbiage["fomoio_rakeboost_happy_hour_description"] = "fomoio_rakeboost_happy_hour_description";
    CommonVerbiage["fomoio_rakeboost_happy_hour02_description"] = "fomoio_rakeboost_happy_hour02_description";
    CommonVerbiage["fomoio_rakeboost_text"] = "fomoio_rakeboost_text";
    CommonVerbiage["fomoio_ready_to_text"] = "fomoio_ready_to_text";
    CommonVerbiage["fomoio_real_time_affiliate_data"] = "fomoio_real_time_affiliate_data";
    CommonVerbiage["fomoio_refer_and_earn"] = "fomoio_refer_and_earn";
    CommonVerbiage["fomoio_refer_and_earn_description"] = "fomoio_refer_and_earn_description";
    CommonVerbiage["fomoio_refer_new_users_to_get"] = "fomoio_refer_new_users_to_get";
    CommonVerbiage["fomoio_refer_now"] = "fomoio_refer_now";
    CommonVerbiage["fomoio_referral_commission_desc"] = "fomoio_referral_commission_desc";
    CommonVerbiage["fomoio_referral_commission_rewards"] = "fomoio_referral_commission_rewards";
    CommonVerbiage["fomoio_referral_faqs_title"] = "fomoio_referral_faqs_title";
    CommonVerbiage["fomoio_referral_limit_details"] = "fomoio_referral_limit_details";
    CommonVerbiage["fomoio_referral_limit_details_answer"] = "fomoio_referral_limit_details_answer";
    CommonVerbiage["fomoio_referral_rules_added_to_your_balance"] = "fomoio_referral_rules_added_to_your_balance";
    CommonVerbiage["fomoio_referral_rules_period"] = "fomoio_referral_rules_period";
    CommonVerbiage["fomoio_referral_rules_primary_description"] = "fomoio_referral_rules_primary_description";
    CommonVerbiage["fomoio_referral_rules_primary_referrals"] = "fomoio_referral_rules_primary_referrals";
    CommonVerbiage["fomoio_referral_rules_secondary_description"] = "fomoio_referral_rules_secondary_description";
    CommonVerbiage["fomoio_referral_rules_secondary_referrals"] = "fomoio_referral_rules_secondary_referrals";
    CommonVerbiage["fomoio_referral_rules_tertiary_description"] = "fomoio_referral_rules_tertiary_description";
    CommonVerbiage["fomoio_referral_rules_tertiary_referrals"] = "fomoio_referral_rules_tertiary_referrals";
    CommonVerbiage["fomoio_referral_rules_tier1"] = "fomoio_referral_rules_tier1";
    CommonVerbiage["fomoio_referral_rules_tier2"] = "fomoio_referral_rules_tier2";
    CommonVerbiage["fomoio_referral_rules_tier3"] = "fomoio_referral_rules_tier3";
    CommonVerbiage["fomoio_referral_rules_you_earn"] = "fomoio_referral_rules_you_earn";
    CommonVerbiage["fomoio_referral_tracking_details"] = "fomoio_referral_tracking_details";
    CommonVerbiage["fomoio_referral_tracking_details_answer"] = "fomoio_referral_tracking_details_answer";
    CommonVerbiage["fomoio_referrals"] = "fomoio_referrals";
    CommonVerbiage["fomoio_referrers_bonus"] = "fomoio_referrers_bonus";
    CommonVerbiage["fomoio_regular_promotions"] = "fomoio_regular_promotions";
    CommonVerbiage["fomoio_reporting_details"] = "fomoio_reporting_details";
    CommonVerbiage["fomoio_rewards_and_cashback_description"] = "fomoio_rewards_and_cashback_description";
    CommonVerbiage["fomoio_rewards_increase"] = "fomoio_rewards_increase";
    CommonVerbiage["fomoio_rewards_text"] = "fomoio_rewards_text";
    CommonVerbiage["fomoio_self_family_referral_policy"] = "fomoio_self_family_referral_policy";
    CommonVerbiage["fomoio_self_family_referral_policy_answer"] = "fomoio_self_family_referral_policy_answer";
    CommonVerbiage["fomoio_sign_up_text"] = "fomoio_sign_up_text";
    CommonVerbiage["fomoio_sign_up_today_call_to_action"] = "fomoio_sign_up_today_call_to_action";
    CommonVerbiage["fomoio_sportsbook_description"] = "fomoio_sportsbook_description";
    CommonVerbiage["fomoio_start_earning_today"] = "fomoio_start_earning_today";
    CommonVerbiage["fomoio_start_inviting_your_friends"] = "fomoio_start_inviting_your_friends";
    CommonVerbiage["fomoio_start_playing_with"] = "fomoio_start_playing_with";
    CommonVerbiage["fomoio_start_playing_with_description"] = "fomoio_start_playing_with_description";
    CommonVerbiage["fomoio_step_1_description"] = "fomoio_step_1_description";
    CommonVerbiage["fomoio_step_1_text"] = "fomoio_step_1_text";
    CommonVerbiage["fomoio_step_2_description"] = "fomoio_step_2_description";
    CommonVerbiage["fomoio_step_2_text"] = "fomoio_step_2_text";
    CommonVerbiage["fomoio_step_3_description"] = "fomoio_step_3_description";
    CommonVerbiage["fomoio_step_3_text"] = "fomoio_step_3_text";
    CommonVerbiage["fomoio_strategies_to_increase_earnings"] = "fomoio_strategies_to_increase_earnings";
    CommonVerbiage["fomoio_strategies_to_increase_earnings_answer"] = "fomoio_strategies_to_increase_earnings_answer";
    CommonVerbiage["fomoio_submit"] = "fomoio_submit";
    CommonVerbiage["fomoio_support_details"] = "fomoio_support_details";
    CommonVerbiage["fomoio_support_in_multiple_languages"] = "fomoio_support_in_multiple_languages";
    CommonVerbiage["fomoio_tailored_reload_bonuses_text"] = "fomoio_tailored_reload_bonuses_text";
    CommonVerbiage["fomoio_testimonial_1_text"] = "fomoio_testimonial_1_text";
    CommonVerbiage["fomoio_testimonial_2_text"] = "fomoio_testimonial_2_text";
    CommonVerbiage["fomoio_testimonial_3_text"] = "fomoio_testimonial_3_text";
    CommonVerbiage["fomoio_testimonial_4_text"] = "fomoio_testimonial_4_text";
    CommonVerbiage["fomoio_testimonials_text"] = "fomoio_testimonials_text";
    CommonVerbiage["fomoio_thousands_of_casino_games"] = "fomoio_thousands_of_casino_games";
    CommonVerbiage["fomoio_tier_name_text"] = "fomoio_tier_name_text";
    CommonVerbiage["fomoio_total_level_up_rewards"] = "fomoio_total_level_up_rewards";
    CommonVerbiage["fomoio_total_level_up_rewards_text"] = "fomoio_total_level_up_rewards_text";
    CommonVerbiage["fomoio_total_wager"] = "fomoio_total_wager";
    CommonVerbiage["fomoio_triple_rakeback_description"] = "fomoio_triple_rakeback_description";
    CommonVerbiage["fomoio_unlocking"] = "fomoio_unlocking";
    CommonVerbiage["fomoio_unlocking_rules"] = "fomoio_unlocking_rules";
    CommonVerbiage["fomoio_view_vip_level_details_text"] = "fomoio_view_vip_level_details_text";
    CommonVerbiage["fomoio_vip_benefits_text"] = "fomoio_vip_benefits_text";
    CommonVerbiage["fomoio_vip_club_description"] = "fomoio_vip_club_description";
    CommonVerbiage["fomoio_vip_club_text"] = "fomoio_vip_club_text";
    CommonVerbiage["fomoio_vip_desc"] = "fomoio_vip_desc";
    CommonVerbiage["fomoio_vip_faqs"] = "fomoio_vip_faqs";
    CommonVerbiage["fomoio_vip_level"] = "fomoio_vip_level";
    CommonVerbiage["fomoio_vip_rank_rewards"] = "fomoio_vip_rank_rewards";
    CommonVerbiage["fomoio_vip_rewards"] = "fomoio_vip_rewards";
    CommonVerbiage["fomoio_vip_subtitle01"] = "fomoio_vip_subtitle01";
    CommonVerbiage["fomoio_vip_subtitle02"] = "fomoio_vip_subtitle02";
    CommonVerbiage["fomoio_vip_testimonials_text"] = "fomoio_vip_testimonials_text";
    CommonVerbiage["fomoio_vip_title01"] = "fomoio_vip_title01";
    CommonVerbiage["fomoio_vip_title02"] = "fomoio_vip_title02";
    CommonVerbiage["fomoio_wager_required"] = "fomoio_wager_required";
    CommonVerbiage["fomoio_wager_requirements"] = "fomoio_wager_requirements";
    CommonVerbiage["fomoio_wagering_required"] = "fomoio_wagering_required";
    CommonVerbiage["fomoio_want_to_be_affiliate"] = "fomoio_want_to_be_affiliate";
    CommonVerbiage["fomoio_weekly_bonus_text"] = "fomoio_weekly_bonus_text";
    CommonVerbiage["fomoio_weekly_bonuses_text"] = "fomoio_weekly_bonuses_text";
    CommonVerbiage["fomoio_weekly_cashback"] = "fomoio_weekly_cashback";
    CommonVerbiage["fomoio_welcome_bonus_text"] = "fomoio_welcome_bonus_text";
    CommonVerbiage["fomoio_welcome_message"] = "fomoio_welcome_message";
    CommonVerbiage["fomoio_welcome_to_the_pinnacle"] = "fomoio_welcome_to_the_pinnacle";
    CommonVerbiage["fomoio_welcome_to_vip_club_text"] = "fomoio_welcome_to_vip_club_text";
    CommonVerbiage["fomoio_why_choose_partners"] = "fomoio_why_choose_partners";
    CommonVerbiage["fomoio_with_rewards"] = "fomoio_with_rewards";
    CommonVerbiage["fomoio_you_25_comission"] = "fomoio_you_25_comission";
    CommonVerbiage["fomoio_you_can_earn"] = "fomoio_you_can_earn";
    CommonVerbiage["fomoio_your_bonuses_unlocked"] = "fomoio_your_bonuses_unlocked";
    CommonVerbiage["football"] = "football";
    CommonVerbiage["footer_text"] = "footer_text";
    CommonVerbiage["footer_text_flush"] = "footer_text_flush";
    CommonVerbiage["forfeit_bonus"] = "forfeit_bonus";
    CommonVerbiage["forgot_password"] = "forgot_password";
    CommonVerbiage["free"] = "free";
    CommonVerbiage["freebets_modal_choose_slot"] = "freebets_modal_choose_slot";
    CommonVerbiage["freebets_modal_no_deposit_needed"] = "freebets_modal_no_deposit_needed";
    CommonVerbiage["freebets_modal_title"] = "freebets_modal_title";
    CommonVerbiage["freebets_modal_win_real_prizes"] = "freebets_modal_win_real_prizes";
    CommonVerbiage["free_guaranteed_wins"] = "free_guaranteed_wins";
    CommonVerbiage["freespins"] = "freespins";
    CommonVerbiage["free_spins_and_bonus_spins"] = "free_spins_and_bonus_spins";
    CommonVerbiage["frequently_asked_questions"] = "frequently_asked_questions";
    CommonVerbiage["frequently_asked_questions_text"] = "frequently_asked_questions_text";
    CommonVerbiage["friends"] = "friends";
    CommonVerbiage["friends_level"] = "friends_level";
    CommonVerbiage["front"] = "front";
    CommonVerbiage["full_screen"] = "full_screen";
    CommonVerbiage["fury_of_anubis_daily_tournaments"] = "fury_of_anubis_daily_tournaments";
    CommonVerbiage["fury_of_anubis_daily_tournaments_description"] = "fury_of_anubis_daily_tournaments_description";
    CommonVerbiage["futsal"] = "futsal";
    CommonVerbiage["gamble_aware"] = "gamble_aware";
    CommonVerbiage["game"] = "game";
    CommonVerbiage["game_info_not_available"] = "game_info_not_available";
    CommonVerbiage["game_providers"] = "game_providers";
    CommonVerbiage["game_review_theme"] = "game_review_theme";
    CommonVerbiage["game_shows"] = "game_shows";
    CommonVerbiage["games"] = "games";
    CommonVerbiage["games_details"] = "games_details";
    CommonVerbiage["gaming_license_norms_text"] = "gaming_license_norms_text";
    CommonVerbiage["gaming_license_norms_text_mobile"] = "gaming_license_norms_text_mobile";
    CommonVerbiage["general"] = "general";
    CommonVerbiage["generated_reward"] = "generated_reward";
    CommonVerbiage["get"] = "get";
    CommonVerbiage["get_up_to_25"] = "get_up_to_25";
    CommonVerbiage["get_your"] = "get_your";
    CommonVerbiage["get_your_cash_back"] = "get_your_cash_back";
    CommonVerbiage["get_your_deposit_bonus"] = "get_your_deposit_bonus";
    CommonVerbiage["get_started"] = "get_started";
    CommonVerbiage["getting_started"] = "getting_started";
    CommonVerbiage["get_rewarded"] = "get_rewarded";
    CommonVerbiage["get_rewarded_description"] = "get_rewarded_description";
    CommonVerbiage["go_vip"] = "go_vip";
    CommonVerbiage["go_to_races"] = "go_to_races";
    CommonVerbiage["go_to_slots"] = "go_to_slots";
    CommonVerbiage["go_to_sports"] = "go_to_sports";
    CommonVerbiage["go_to_vip"] = "go_to_vip";
    CommonVerbiage["gold"] = "gold";
    CommonVerbiage["golf"] = "golf";
    CommonVerbiage["googleAuth"] = "googleAuth";
    CommonVerbiage["googleAuthDisabled"] = "googleAuthDisabled";
    CommonVerbiage["googleAuthEnabled"] = "googleAuthEnabled";
    CommonVerbiage["great_to_have_you_back"] = "great_to_have_you_back";
    CommonVerbiage["half_bet_amount"] = "half_bet_amount";
    CommonVerbiage["handball"] = "handball";
    CommonVerbiage["hash_round"] = "hash_round";
    CommonVerbiage["hashed_server_seed"] = "hashed_server_seed";
    CommonVerbiage["hello"] = "hello";
    CommonVerbiage["help"] = "help";
    CommonVerbiage["help_center"] = "help_center";
    CommonVerbiage["helpdesk"] = "helpdesk";
    CommonVerbiage["hidden"] = "hidden";
    CommonVerbiage["hide"] = "hide";
    CommonVerbiage["hide_profit"] = "hide_profit";
    CommonVerbiage["hide_progress"] = "hide_progress";
    CommonVerbiage["hide_stats"] = "hide_stats";
    CommonVerbiage["hide_wagered"] = "hide_wagered";
    CommonVerbiage["hide_zero_balances"] = "hide_zero_balances";
    CommonVerbiage["high_ngr_increased_revenue"] = "high_ngr_increased_revenue";
    CommonVerbiage["high_rollers"] = "high_rollers";
    CommonVerbiage["highest_rtp"] = "highest_rtp";
    CommonVerbiage["hilo"] = "hilo";
    CommonVerbiage["history"] = "history";
    CommonVerbiage["hit_rate"] = "hit_rate";
    CommonVerbiage["hockey"] = "hockey";
    CommonVerbiage["hold"] = "hold";
    CommonVerbiage["home_welcome"] = "home_welcome";
    CommonVerbiage["homepage"] = "homepage";
    CommonVerbiage["hot_promos"] = "hot_promos";
    CommonVerbiage["hotkeys"] = "hotkeys";
    CommonVerbiage["hotkeys_enabled"] = "hotkeys_enabled";
    CommonVerbiage["house_edge"] = "house_edge";
    CommonVerbiage["how_it_works"] = "how_it_works";
    CommonVerbiage["how_it_works_referral_bonus"] = "how_it_works_referral_bonus";
    CommonVerbiage["how_it_works_referral_bonus_description"] = "how_it_works_referral_bonus_description";
    CommonVerbiage["huge_jackpot"] = "huge_jackpot";
    CommonVerbiage["i_accept"] = "i_accept";
    CommonVerbiage["i_agree"] = "i_agree";
    CommonVerbiage["i_confirm_enabling_signin_to_brand_with_this_wallet"] = "i_confirm_enabling_signin_to_brand_with_this_wallet";
    CommonVerbiage["i_want_a_deposit_bonus"] = "i_want_a_deposit_bonus";
    CommonVerbiage["i_want_to_earn_monthly"] = "i_want_to_earn_monthly";
    CommonVerbiage["ice_hockey"] = "ice_hockey";
    CommonVerbiage["id_copied_to_clipboard"] = "id_copied_to_clipboard";
    CommonVerbiage["id_copied_to_clipboard_successfully"] = "id_copied_to_clipboard_successfully";
    CommonVerbiage["in_progress"] = "in_progress";
    CommonVerbiage["inactive"] = "inactive";
    CommonVerbiage["incorrect_code"] = "incorrect_code";
    CommonVerbiage["info_card_description_1"] = "info_card_description_1";
    CommonVerbiage["info_card_description_2"] = "info_card_description_2";
    CommonVerbiage["info_card_description_3"] = "info_card_description_3";
    CommonVerbiage["info_card_description_4"] = "info_card_description_4";
    CommonVerbiage["info_card_footer_1"] = "info_card_footer_1";
    CommonVerbiage["info_card_footer_2"] = "info_card_footer_2";
    CommonVerbiage["info_card_title_part_1"] = "info_card_title_part_1";
    CommonVerbiage["info_card_title_part_2"] = "info_card_title_part_2";
    CommonVerbiage["information_updated"] = "information_updated";
    CommonVerbiage["instructions"] = "instructions";
    CommonVerbiage["instructions_with_deposit_benefit"] = "instructions_with_deposit_benefit";
    CommonVerbiage["instant_cashback_ineligible_balance"] = "instant_cashback_ineligible_balance";
    CommonVerbiage["instant_cashback_ineligible_cashback"] = "instant_cashback_ineligible_cashback";
    CommonVerbiage["instant_cashback_ineligible_deposit"] = "instant_cashback_ineligible_deposit";
    CommonVerbiage["instant_cashback_ineligible_min_deposit"] = "instant_cashback_ineligible_min_deposit";
    CommonVerbiage["instant_cashback_ineligible_game"] = "instant_cashback_ineligible_game";
    CommonVerbiage["instant_cashback_ineligible_title"] = "instant_cashback_ineligible_title";
    CommonVerbiage["instant_cashback_ineligible_withdrawal"] = "instant_cashback_ineligible_withdrawal";
    CommonVerbiage["instant_cashback_not_ready"] = "instant_cashback_not_ready";
    CommonVerbiage["instant_cashback_tooltip"] = "instant_cashback_tooltip";
    CommonVerbiage["instant_cashback"] = "instant_cashback";
    CommonVerbiage["instant_cashback_claimed"] = "instant_cashback_claimed";
    CommonVerbiage["instant_payouts"] = "instant_payouts";
    CommonVerbiage["insufficient_funds"] = "insufficient_funds";
    CommonVerbiage["invalid_address_type"] = "invalid_address_type";
    CommonVerbiage["invalid_address_type_description"] = "invalid_address_type_description";
    CommonVerbiage["invalid_amount"] = "invalid_amount";
    CommonVerbiage["invalid_number_of_people"] = "invalid_number_of_people";
    CommonVerbiage["invalid_password_username_or_email"] = "invalid_password_username_or_email";
    CommonVerbiage["invite_new_users_and_get_commission"] = "invite_new_users_and_get_commission";
    CommonVerbiage["invite_new_users_to_get"] = "invite_new_users_to_get";
    CommonVerbiage["invite_only_promotions"] = "invite_only_promotions";
    CommonVerbiage["invite_referrals"] = "invite_referrals";
    CommonVerbiage["invite_your"] = "invite_your";
    CommonVerbiage["invite_your_friends_banner_description"] = "invite_your_friends_banner_description";
    CommonVerbiage["iron"] = "iron";
    CommonVerbiage["item"] = "item";
    CommonVerbiage["jackpot"] = "jackpot";
    CommonVerbiage["jackpot_brand"] = "jackpot_brand";
    CommonVerbiage["jackpot_brand_2"] = "jackpot_brand_2";
    CommonVerbiage["jackpot_description"] = "jackpot_description";
    CommonVerbiage["jackpot_description_2"] = "jackpot_description_2";
    CommonVerbiage["jackpot_subtitle"] = "jackpot_subtitle";
    CommonVerbiage["jackpot_title"] = "jackpot_title";
    CommonVerbiage["jackpot_major"] = "jackpot_major";
    CommonVerbiage["jackpot_mega"] = "jackpot_mega";
    CommonVerbiage["jackpot_mini"] = "jackpot_mini";
    CommonVerbiage["jackpot_minor"] = "jackpot_minor";
    CommonVerbiage["jelly_express_daily_tournaments"] = "jelly_express_daily_tournaments";
    CommonVerbiage["join"] = "join";
    CommonVerbiage["join_now"] = "join_now";
    CommonVerbiage["join_now_text"] = "join_now_text";
    CommonVerbiage["join_us_at_the_merit"] = "join_us_at_the_merit";
    CommonVerbiage["join_us_at_the_merit_description"] = "join_us_at_the_merit_description";
    CommonVerbiage["join_the_raffle"] = "join_the_raffle";
    CommonVerbiage["join_the_races"] = "join_the_races";
    CommonVerbiage["join_the_vip_club"] = "join_the_vip_club";
    CommonVerbiage["join_vip_club_call_to_action"] = "join_vip_club_call_to_action";
    CommonVerbiage["join_vip_club_description"] = "join_vip_club_description";
    CommonVerbiage["join_vip_club_first_part_title"] = "join_vip_club_first_part_title";
    CommonVerbiage["join_vip_club_second_part_title"] = "join_vip_club_second_part_title";
    CommonVerbiage["join_vip_club_title_highlight"] = "join_vip_club_title_highlight";
    CommonVerbiage["joined_on"] = "joined_on";
    CommonVerbiage["jump_in"] = "jump_in";
    CommonVerbiage["keno"] = "keno";
    CommonVerbiage["kyc_policy"] = "kyc_policy";
    CommonVerbiage["language"] = "language";
    CommonVerbiage["language_privacy"] = "language_privacy";
    CommonVerbiage["last_name"] = "last_name";
    CommonVerbiage["last_name_required"] = "last_name_required";
    CommonVerbiage["lastNameLabel"] = "lastNameLabel";
    CommonVerbiage["lastNamePlaceholder"] = "lastNamePlaceholder";
    CommonVerbiage["latest_bets"] = "latest_bets";
    CommonVerbiage["launch_to_riches"] = "launch_to_riches";
    CommonVerbiage["launch_to_riches_description"] = "launch_to_riches_description";
    CommonVerbiage["leaderboard_desc"] = "leaderboard_desc";
    CommonVerbiage["leaderboard_title"] = "leaderboard_title";
    CommonVerbiage["league_of_legends"] = "league_of_legends";
    CommonVerbiage["le_bandit_hold_and_win"] = "le_bandit_hold_and_win";
    CommonVerbiage["le_bandit_hold_and_win_description"] = "le_bandit_hold_and_win_description";
    CommonVerbiage["le_bunny_description"] = "le_bunny_description";
    CommonVerbiage["le_bunny_title"] = "le_bunny_title";
    CommonVerbiage["le_digger"] = "le_digger";
    CommonVerbiage["le_digger_description"] = "le_digger_description";
    CommonVerbiage["learn_more"] = "learn_more";
    CommonVerbiage["learn_more_label"] = "learn_more_label";
    CommonVerbiage["learn_more_tooltip_content"] = "learn_more_tooltip_content";
    CommonVerbiage["level_up_reward_text"] = "level_up_reward_text";
    CommonVerbiage["level_up_rewards_description"] = "level_up_rewards_description";
    CommonVerbiage["level_up_rewards_earnings_description"] = "level_up_rewards_earnings_description";
    CommonVerbiage["level_up_tooltip"] = "level_up_tooltip";
    CommonVerbiage["lifetime_commissions"] = "lifetime_commissions";
    CommonVerbiage["lifetime_commissions_details"] = "lifetime_commissions_details";
    CommonVerbiage["like"] = "like";
    CommonVerbiage["like_what_you_see_text"] = "like_what_you_see_text";
    CommonVerbiage["limit_daily"] = "limit_daily";
    CommonVerbiage["limit_daily_remaining"] = "limit_daily_remaining";
    CommonVerbiage["limit_monthly"] = "limit_monthly";
    CommonVerbiage["limit_monthly_remaining"] = "limit_monthly_remaining";
    CommonVerbiage["limit_weekly"] = "limit_weekly";
    CommonVerbiage["limit_weekly_remaining"] = "limit_weekly_remaining";
    CommonVerbiage["live"] = "live";
    CommonVerbiage["live_baccarat"] = "live_baccarat";
    CommonVerbiage["live_bets"] = "live_bets";
    CommonVerbiage["live_bitcoin_betting"] = "live_bitcoin_betting";
    CommonVerbiage["live_blackjack"] = "live_blackjack";
    CommonVerbiage["live_casino"] = "live_casino";
    CommonVerbiage["live_roulette"] = "live_roulette";
    CommonVerbiage["global_sports_premium_odds"] = "global_sports_premium_odds";
    CommonVerbiage["live_stats"] = "live_stats";
    CommonVerbiage["live_support"] = "live_support";
    CommonVerbiage["live_wins"] = "live_wins";
    CommonVerbiage["loading"] = "loading";
    CommonVerbiage["loading_games"] = "loading_games";
    CommonVerbiage["loading_more_games"] = "loading_more_games";
    CommonVerbiage["more_games"] = "more_games";
    CommonVerbiage["lobby"] = "lobby";
    CommonVerbiage["locked_balance"] = "locked_balance";
    CommonVerbiage["log_in"] = "log_in";
    CommonVerbiage["log_out"] = "log_out";
    CommonVerbiage["login"] = "login";
    CommonVerbiage["login_via_wallet"] = "login_via_wallet";
    CommonVerbiage["logout"] = "logout";
    CommonVerbiage["lose"] = "lose";
    CommonVerbiage["lucky_spin"] = "lucky_spin";
    CommonVerbiage["luna_all_rights_reserved"] = "luna_all_rights_reserved";
    CommonVerbiage["maintenance_contact_support"] = "maintenance_contact_support";
    CommonVerbiage["maintenance_description_intro"] = "maintenance_description_intro";
    CommonVerbiage["maintenance_description_outro"] = "maintenance_description_outro";
    CommonVerbiage["maintenance_follow_us"] = "maintenance_follow_us";
    CommonVerbiage["maintenance_sorry_text"] = "maintenance_sorry_text";
    CommonVerbiage["maintenance_support"] = "maintenance_support";
    CommonVerbiage["maintenance_title"] = "maintenance_title";
    CommonVerbiage["make_a_bet"] = "make_a_bet";
    CommonVerbiage["make_it_rain"] = "make_it_rain";
    CommonVerbiage["make_primary"] = "make_primary";
    CommonVerbiage["magical_macau"] = "magical_macau";
    CommonVerbiage["magical_macau_description"] = "magical_macau_description";
    CommonVerbiage["mark_all_as_read"] = "mark_all_as_read";
    CommonVerbiage["mark_as_read"] = "mark_as_read";
    CommonVerbiage["marketing_emails"] = "marketing_emails";
    CommonVerbiage["max"] = "max";
    CommonVerbiage["max_bonus"] = "max_bonus";
    CommonVerbiage["max_eligible_users"] = "max_eligible_users";
    CommonVerbiage["max_tip"] = "max_tip";
    CommonVerbiage["max_win"] = "max_win";
    CommonVerbiage["maximize_playtime_rewards_description"] = "maximize_playtime_rewards_description";
    CommonVerbiage["maximum_deposit"] = "maximum_deposit";
    CommonVerbiage["maximum_is"] = "maximum_is";
    CommonVerbiage["meme_coins"] = "meme_coins";
    CommonVerbiage["menu"] = "menu";
    CommonVerbiage["message"] = "message";
    CommonVerbiage["message_optional"] = "message_optional";
    CommonVerbiage["min"] = "min";
    CommonVerbiage["min_deposit"] = "min_deposit";
    CommonVerbiage["min_deposit_amount"] = "min_deposit_amount";
    CommonVerbiage["min_tip"] = "min_tip";
    CommonVerbiage["mines"] = "mines";
    CommonVerbiage["minimal_claim"] = "minimal_claim";
    CommonVerbiage["minimum_deposit"] = "minimum_deposit";
    CommonVerbiage["minimum_deposit_short"] = "minimum_deposit_short";
    CommonVerbiage["minimum_deposit_tooltip"] = "minimum_deposit_tooltip";
    CommonVerbiage["minimum_withdrawal"] = "minimum_withdrawal";
    CommonVerbiage["missed"] = "missed";
    CommonVerbiage["missed_it_by_the_day"] = "missed_it_by_the_day";
    CommonVerbiage["mobile_number"] = "mobile_number";
    CommonVerbiage["mobile_number_error"] = "mobile_number_error";
    CommonVerbiage["mobile_number_invalid"] = "mobile_number_invalid";
    CommonVerbiage["mobile_number_required"] = "mobile_number_required";
    CommonVerbiage["mma"] = "mma";
    CommonVerbiage["mnf_bet_builder_bailout"] = "mnf_bet_builder_bailout";
    CommonVerbiage["mnf_bet_builder_bailout_description"] = "mnf_bet_builder_bailout_description";
    CommonVerbiage["modal_dialog"] = "modal_dialog";
    CommonVerbiage["moderator"] = "moderator";
    CommonVerbiage["monaco_vip_hospitality"] = "monaco_vip_hospitality";
    CommonVerbiage["monaco_vip_hospitality_description"] = "monaco_vip_hospitality_description";
    CommonVerbiage["monthLabel"] = "monthLabel";
    CommonVerbiage["monthly"] = "monthly";
    CommonVerbiage["monthly_bonus"] = "monthly_bonus";
    CommonVerbiage["monthly_bonus_text"] = "monthly_bonus_text";
    CommonVerbiage["monthly_bonuses_text"] = "monthly_bonuses_text";
    CommonVerbiage["monthly_cashback"] = "monthly_cashback";
    CommonVerbiage["monthly_limit"] = "monthly_limit";
    CommonVerbiage["monthly_reward"] = "monthly_reward";
    CommonVerbiage["monthly_rewards_tooltip"] = "monthly_rewards_tooltip";
    CommonVerbiage["monthly_rewards_tooltip_flush"] = "monthly_rewards_tooltip_flush";
    CommonVerbiage["more_info"] = "more_info";
    CommonVerbiage["more_text"] = "more_text";
    CommonVerbiage["movie_mode"] = "movie_mode";
    CommonVerbiage["multiplier"] = "multiplier";
    CommonVerbiage["multiplier_madness"] = "multiplier_madness";
    CommonVerbiage["multiplier_madness_description"] = "multiplier_madness_description";
    CommonVerbiage["my_balance"] = "my_balance";
    CommonVerbiage["my_bets"] = "my_bets";
    CommonVerbiage["my_campaigns"] = "my_campaigns";
    CommonVerbiage["my_commission"] = "my_commission";
    CommonVerbiage["my_profit"] = "my_profit";
    CommonVerbiage["my_referral_campaign"] = "my_referral_campaign";
    CommonVerbiage["my_referral_rewards"] = "my_referral_rewards";
    CommonVerbiage["my_referrals"] = "my_referrals";
    CommonVerbiage["my_total_profit"] = "my_total_profit";
    CommonVerbiage["my_total_referrals"] = "my_total_referrals";
    CommonVerbiage["name"] = "name";
    CommonVerbiage["nba_2k"] = "nba_2k";
    CommonVerbiage["negative_balances_policy"] = "negative_balances_policy";
    CommonVerbiage["negative_balances_policy_answer"] = "negative_balances_policy_answer";
    CommonVerbiage["network"] = "network";
    CommonVerbiage["network_error"] = "network_error";
    CommonVerbiage["networks"] = "networks";
    CommonVerbiage["new"] = "new";
    CommonVerbiage["new_bonuses_in"] = "new_bonuses_in";
    CommonVerbiage["new_casino_games"] = "new_casino_games";
    CommonVerbiage["new_client_seed"] = "new_client_seed";
    CommonVerbiage["new_games"] = "new_games";
    CommonVerbiage["new_release"] = "new_release";
    CommonVerbiage["new_releases"] = "new_releases";
    CommonVerbiage["new_server_seed_hashed"] = "new_server_seed_hashed";
    CommonVerbiage["next"] = "next";
    CommonVerbiage["next_rank"] = "next_rank";
    CommonVerbiage["next_ranks"] = "next_ranks";
    CommonVerbiage["next_rank_up_reward"] = "next_rank_up_reward";
    CommonVerbiage["next_reward"] = "next_reward";
    CommonVerbiage["next_reward_in"] = "next_reward_in";
    CommonVerbiage["nfl"] = "nfl";
    CommonVerbiage["ngr_details"] = "ngr_details";
    CommonVerbiage["nickname"] = "nickname";
    CommonVerbiage["no"] = "no";
    CommonVerbiage["no_bets_transactions_found_flush_part_1"] = "no_bets_transactions_found_flush_part_1";
    CommonVerbiage["no_bets_transactions_found_flush_part_2"] = "no_bets_transactions_found_flush_part_2";
    CommonVerbiage["no_bonus"] = "no_bonus";
    CommonVerbiage["no_cashback_to_claim"] = "no_cashback_to_claim";
    CommonVerbiage["no_deposits_transactions_found_flush_part_1"] = "no_deposits_transactions_found_flush_part_1";
    CommonVerbiage["no_deposits_transactions_found_flush_part_2"] = "no_deposits_transactions_found_flush_part_2";
    CommonVerbiage["no_games_found"] = "no_games_found";
    CommonVerbiage["no_games_found_flush_part_1"] = "no_games_found_flush_part_1";
    CommonVerbiage["no_games_found_flush_part_2"] = "no_games_found_flush_part_2";
    CommonVerbiage["no_info_available"] = "no_info_available";
    CommonVerbiage["no_information"] = "no_information";
    CommonVerbiage["no_instant_cashback_to_claim"] = "no_instant_cashback_to_claim";
    CommonVerbiage["no_ratings_yet"] = "no_ratings_yet";
    CommonVerbiage["no_response_from_server"] = "no_response_from_server";
    CommonVerbiage["no_reward_yet"] = "no_reward_yet";
    CommonVerbiage["no_rewards"] = "no_rewards";
    CommonVerbiage["no_transactions_found_flush_part_1"] = "no_transactions_found_flush_part_1";
    CommonVerbiage["no_transactions_found_flush_part_2"] = "no_transactions_found_flush_part_2";
    CommonVerbiage["no_user_found"] = "no_user_found";
    CommonVerbiage["no_withdrawals_transactions_found_flush_part_1"] = "no_withdrawals_transactions_found_flush_part_1";
    CommonVerbiage["no_withdrawals_transactions_found_flush_part_2"] = "no_withdrawals_transactions_found_flush_part_2";
    CommonVerbiage["non_calendar_reward_claimed_successfully"] = "non_calendar_reward_claimed_successfully";
    CommonVerbiage["non_calendar_reward_claimed_successfully_text"] = "non_calendar_reward_claimed_successfully_text";
    CommonVerbiage["nonce"] = "nonce";
    CommonVerbiage["none"] = "none";
    CommonVerbiage["nor_any_network"] = "nor_any_network";
    CommonVerbiage["nor_any_token"] = "nor_any_token";
    CommonVerbiage["not_eligible"] = "not_eligible";
    CommonVerbiage["not_found"] = "not_found";
    CommonVerbiage["notifications"] = "notifications";
    CommonVerbiage["now_its_time_to_win"] = "now_its_time_to_win";
    CommonVerbiage["number_referrals"] = "number_referrals";
    CommonVerbiage["obsidian"] = "obsidian";
    CommonVerbiage["of"] = "of";
    CommonVerbiage["offers"] = "offers";
    CommonVerbiage["on"] = "on";
    CommonVerbiage["online"] = "online";
    CommonVerbiage["online_casino"] = "online_casino";
    CommonVerbiage["online_slots"] = "online_slots";
    CommonVerbiage["online_slots_providers"] = "online_slots_providers";
    CommonVerbiage["one_time_verification_to_claim_bonuses"] = "one_time_verification_to_claim_bonuses";
    CommonVerbiage["only_the_games_you_want_to_play"] = "only_the_games_you_want_to_play";
    CommonVerbiage["only_on_turbo"] = "only_on_turbo";
    CommonVerbiage["open_in_new_tab"] = "open_in_new_tab";
    CommonVerbiage["opt_in_now"] = "opt_in_now";
    CommonVerbiage["optional"] = "optional";
    CommonVerbiage["or"] = "or";
    CommonVerbiage["or_more_and_get_a"] = "or_more_and_get_a";
    CommonVerbiage["ordinal"] = "ordinal";
    CommonVerbiage["originals"] = "originals";
    CommonVerbiage["originals_fomoio"] = "originals_fomoio";
    CommonVerbiage["other"] = "other";
    CommonVerbiage["other_currencies"] = "other_currencies";
    CommonVerbiage["out_of_days_done"] = "out_of_days_done";
    CommonVerbiage["over_x_payment_methods"] = "over_x_payment_methods";
    CommonVerbiage["padel_masters_2026"] = "padel_masters_2026";
    CommonVerbiage["padel_masters_2026_description"] = "padel_masters_2026_description";
    CommonVerbiage["page"] = "page";
    CommonVerbiage["page_not_found"] = "page_not_found";
    CommonVerbiage["participating_games"] = "participating_games";
    CommonVerbiage["participating_games_title"] = "participating_games_title";
    CommonVerbiage["partner_review_1"] = "partner_review_1";
    CommonVerbiage["partner_review_10"] = "partner_review_10";
    CommonVerbiage["partner_review_11"] = "partner_review_11";
    CommonVerbiage["partner_review_12"] = "partner_review_12";
    CommonVerbiage["partner_review_13"] = "partner_review_13";
    CommonVerbiage["partner_review_14"] = "partner_review_14";
    CommonVerbiage["partner_review_15"] = "partner_review_15";
    CommonVerbiage["partner_review_16"] = "partner_review_16";
    CommonVerbiage["partner_review_17"] = "partner_review_17";
    CommonVerbiage["partner_review_18"] = "partner_review_18";
    CommonVerbiage["partner_review_19"] = "partner_review_19";
    CommonVerbiage["partner_review_2"] = "partner_review_2";
    CommonVerbiage["partner_review_20"] = "partner_review_20";
    CommonVerbiage["partner_review_21"] = "partner_review_21";
    CommonVerbiage["partner_review_22"] = "partner_review_22";
    CommonVerbiage["partner_review_23"] = "partner_review_23";
    CommonVerbiage["partner_review_24"] = "partner_review_24";
    CommonVerbiage["partner_review_25"] = "partner_review_25";
    CommonVerbiage["partner_review_26"] = "partner_review_26";
    CommonVerbiage["partner_review_27"] = "partner_review_27";
    CommonVerbiage["partner_review_28"] = "partner_review_28";
    CommonVerbiage["partner_review_29"] = "partner_review_29";
    CommonVerbiage["partner_review_30"] = "partner_review_30";
    CommonVerbiage["partner_review_31"] = "partner_review_31";
    CommonVerbiage["partner_review_32"] = "partner_review_32";
    CommonVerbiage["partner_review_33"] = "partner_review_33";
    CommonVerbiage["partner_review_34"] = "partner_review_34";
    CommonVerbiage["partner_review_35"] = "partner_review_35";
    CommonVerbiage["partner_review_36"] = "partner_review_36";
    CommonVerbiage["partner_review_37"] = "partner_review_37";
    CommonVerbiage["partner_review_38"] = "partner_review_38";
    CommonVerbiage["partner_review_39"] = "partner_review_39";
    CommonVerbiage["partner_review_40"] = "partner_review_40";
    CommonVerbiage["partner_review_41"] = "partner_review_41";
    CommonVerbiage["partner_review_42"] = "partner_review_42";
    CommonVerbiage["partner_review_43"] = "partner_review_43";
    CommonVerbiage["partner_review_44"] = "partner_review_44";
    CommonVerbiage["partner_review_45"] = "partner_review_45";
    CommonVerbiage["partner_review_3"] = "partner_review_3";
    CommonVerbiage["partner_review_4"] = "partner_review_4";
    CommonVerbiage["partner_review_5"] = "partner_review_5";
    CommonVerbiage["partner_review_6"] = "partner_review_6";
    CommonVerbiage["partner_review_7"] = "partner_review_7";
    CommonVerbiage["partner_review_8"] = "partner_review_8";
    CommonVerbiage["partner_review_9"] = "partner_review_9";
    CommonVerbiage["partner_testimonials"] = "partner_testimonials";
    CommonVerbiage["partners_perks"] = "partners_perks";
    CommonVerbiage["partners_program"] = "partners_program";
    CommonVerbiage["partners_program_overview"] = "partners_program_overview";
    CommonVerbiage["partners_program_overview_answer"] = "partners_program_overview_answer";
    CommonVerbiage["partnership_enquiries"] = "partnership_enquiries";
    CommonVerbiage["reach_out_at"] = "reach_out_at";
    CommonVerbiage["response_time"] = "response_time";
    CommonVerbiage["within_1_business_day"] = "within_1_business_day";
    CommonVerbiage["send_an_email"] = "send_an_email";
    CommonVerbiage["password"] = "password";
    CommonVerbiage["password_complexity_hint"] = "password_complexity_hint";
    CommonVerbiage["password_updated"] = "password_updated";
    CommonVerbiage["passwordMethod"] = "passwordMethod";
    CommonVerbiage["passwords_do_not_match"] = "passwords_do_not_match";
    CommonVerbiage["payment_details"] = "payment_details";
    CommonVerbiage["payment_policy"] = "payment_policy";
    CommonVerbiage["payout"] = "payout";
    CommonVerbiage["pending"] = "pending";
    CommonVerbiage["pending_commission"] = "pending_commission";
    CommonVerbiage["pending_reward"] = "pending_reward";
    CommonVerbiage["pending_rewards"] = "pending_rewards";
    CommonVerbiage["period"] = "period";
    CommonVerbiage["personal"] = "personal";
    CommonVerbiage["personal_tab"] = "personal_tab";
    CommonVerbiage["platform"] = "platform";
    CommonVerbiage["platinum"] = "platinum";
    CommonVerbiage["play"] = "play";
    CommonVerbiage["play_now"] = "play_now";
    CommonVerbiage["play_online"] = "play_online";
    CommonVerbiage["play_requirement"] = "play_requirement";
    CommonVerbiage["play_requirement_description"] = "play_requirement_description";
    CommonVerbiage["play_enjoy"] = "play_enjoy";
    CommonVerbiage["play_enjoy_description"] = "play_enjoy_description";
    CommonVerbiage["player"] = "player";
    CommonVerbiage["player_since"] = "player_since";
    CommonVerbiage["players_online"] = "players_online";
    CommonVerbiage["players_settings"] = "players_settings";
    CommonVerbiage["please_check_wallet_and_accept_the_request_to_continue"] = "please_check_wallet_and_accept_the_request_to_continue";
    CommonVerbiage["please_enter_deposit_amount"] = "please_enter_deposit_amount";
    CommonVerbiage["please_enter_your_new_password"] = "please_enter_your_new_password";
    CommonVerbiage["please_only_use_one_of_these_networks"] = "please_only_use_one_of_these_networks";
    CommonVerbiage["please_contact_support"] = "please_contact_support";
    CommonVerbiage["please_contact_player_support"] = "please_contact_player_support";
    CommonVerbiage["please_try_again"] = "please_try_again";
    CommonVerbiage["please_try_again_later"] = "please_try_again_later";
    CommonVerbiage["plinko"] = "plinko";
    CommonVerbiage["preferences"] = "preferences";
    CommonVerbiage["primary"] = "primary";
    CommonVerbiage["popular"] = "popular";
    CommonVerbiage["popular_casino"] = "popular_casino";
    CommonVerbiage["popular_games"] = "popular_games";
    CommonVerbiage["popular_sports"] = "popular_sports";
    CommonVerbiage["popularity"] = "popularity";
    CommonVerbiage["postalCodeLabel"] = "postalCodeLabel";
    CommonVerbiage["postalCodePlaceholder"] = "postalCodePlaceholder";
    CommonVerbiage["potencial_questions"] = "potencial_questions";
    CommonVerbiage["POWER_BET"] = "POWER_BET";
    CommonVerbiage["preferredNameLabel"] = "preferredNameLabel";
    CommonVerbiage["previous_rounds_history"] = "previous_rounds_history";
    CommonVerbiage["price_tooltip"] = "price_tooltip";
    CommonVerbiage["privacy"] = "privacy";
    CommonVerbiage["powered_by"] = "powered_by";
    CommonVerbiage["privacy_policy"] = "privacy_policy";
    CommonVerbiage["privacy_settings"] = "privacy_settings";
    CommonVerbiage["prize_pool_table_header_position"] = "prize_pool_table_header_position";
    CommonVerbiage["prize_pool_table_header_prize"] = "prize_pool_table_header_prize";
    CommonVerbiage["prize_pool_table_header_username"] = "prize_pool_table_header_username";
    CommonVerbiage["prize_pool_table_header_wagered"] = "prize_pool_table_header_wagered";
    CommonVerbiage["prize_pool_title_part_1"] = "prize_pool_title_part_1";
    CommonVerbiage["prize_pool_title_part_2"] = "prize_pool_title_part_2";
    CommonVerbiage["processing"] = "processing";
    CommonVerbiage["profile"] = "profile";
    CommonVerbiage["profit"] = "profit";
    CommonVerbiage["program_working_details"] = "program_working_details";
    CommonVerbiage["program_working_details_answer"] = "program_working_details_answer";
    CommonVerbiage["progress"] = "progress";
    CommonVerbiage["progress_to_rank"] = "progress_to_rank";
    CommonVerbiage["promo"] = "promo";
    CommonVerbiage["promo_materials"] = "promo_materials";
    CommonVerbiage["promoted_game"] = "promoted_game";
    CommonVerbiage["promotion"] = "promotion";
    CommonVerbiage["promotion_period_from_label"] = "promotion_period_from_label";
    CommonVerbiage["promotion_period_to_label"] = "promotion_period_to_label";
    CommonVerbiage["promotion_restrictions"] = "promotion_restrictions";
    CommonVerbiage["promotion_restrictions_answer"] = "promotion_restrictions_answer";
    CommonVerbiage["promotional_materials_provided"] = "promotional_materials_provided";
    CommonVerbiage["promotional_materials_provided_answer"] = "promotional_materials_provided_answer";
    CommonVerbiage["promotions"] = "promotions";
    CommonVerbiage["promotions_details"] = "promotions_details";
    CommonVerbiage["provably_fair"] = "provably_fair";
    CommonVerbiage["provably_fair_casino_games"] = "provably_fair_casino_games";
    CommonVerbiage["provider_search"] = "provider_search";
    CommonVerbiage["providers"] = "providers";
    CommonVerbiage["provinceLabel"] = "provinceLabel";
    CommonVerbiage["provincePlaceholder"] = "provincePlaceholder";
    CommonVerbiage["public"] = "public";
    CommonVerbiage["public_key_not_found"] = "public_key_not_found";
    CommonVerbiage["qualifying_range"] = "qualifying_range";
    CommonVerbiage["quest"] = "quest";
    CommonVerbiage["question_daily_weekly_monthly"] = "question_daily_weekly_monthly";
    CommonVerbiage["question_how_communicate"] = "question_how_communicate";
    CommonVerbiage["question_how_ofter_bonuses"] = "question_how_ofter_bonuses";
    CommonVerbiage["question_monthly_bonus"] = "question_monthly_bonus";
    CommonVerbiage["question_vip_club_stand_out"] = "question_vip_club_stand_out";
    CommonVerbiage["question_wagering"] = "question_wagering";
    CommonVerbiage["question_what_are_calendar_distribuition_days"] = "question_what_are_calendar_distribuition_days";
    CommonVerbiage["question_what_is_cashback"] = "question_what_is_cashback";
    CommonVerbiage["question_what_is_happy_hour"] = "question_what_is_happy_hour";
    CommonVerbiage["question_what_is_rakeback"] = "question_what_is_rakeback";
    CommonVerbiage["question_which_tier_im_on"] = "question_which_tier_im_on";
    CommonVerbiage["quote"] = "quote";
    CommonVerbiage["race_leaderboard"] = "race_leaderboard";
    CommonVerbiage["race_now"] = "race_now";
    CommonVerbiage["race_your_way"] = "race_your_way";
    CommonVerbiage["races"] = "races";
    CommonVerbiage["races_banner_description"] = "races_banner_description";
    CommonVerbiage["races_description"] = "races_description";
    CommonVerbiage["races_fomoio"] = "races_fomoio";
    CommonVerbiage["racing"] = "racing";
    CommonVerbiage["raffles"] = "raffles";
    CommonVerbiage["rain"] = "rain";
    CommonVerbiage["rain_amount"] = "rain_amount";
    CommonVerbiage["rain_currency"] = "rain_currency";
    CommonVerbiage["rain_error_status"] = "rain_error_status";
    CommonVerbiage["rain_exceeds_balance"] = "rain_exceeds_balance";
    CommonVerbiage["rain_failed"] = "rain_failed";
    CommonVerbiage["rain_invalid"] = "rain_invalid";
    CommonVerbiage["rain_maximum_description"] = "rain_maximum_description";
    CommonVerbiage["rain_minimum_description"] = "rain_minimum_description";
    CommonVerbiage["rain_sent"] = "rain_sent";
    CommonVerbiage["rain_sent_success"] = "rain_sent_success";
    CommonVerbiage["rain_too_large"] = "rain_too_large";
    CommonVerbiage["rain_too_small"] = "rain_too_small";
    CommonVerbiage["rain_total_overall_max_description"] = "rain_total_overall_max_description";
    CommonVerbiage["rain_total_too_large_description"] = "rain_total_too_large_description";
    CommonVerbiage["rain_total_too_small_description"] = "rain_total_too_small_description";
    CommonVerbiage["raise_your_game_and_stay"] = "raise_your_game_and_stay";
    CommonVerbiage["rakeback"] = "rakeback";
    CommonVerbiage["rakeback_claimed"] = "rakeback_claimed";
    CommonVerbiage["rakeback_perks_description"] = "rakeback_perks_description";
    CommonVerbiage["rakeback_text"] = "rakeback_text";
    CommonVerbiage["rakeback_tooltip"] = "rakeback_tooltip";
    CommonVerbiage["rakeboost"] = "rakeboost";
    CommonVerbiage["rakeboost_description"] = "rakeboost_description";
    CommonVerbiage["rakeboost_happy_hour_description"] = "rakeboost_happy_hour_description";
    CommonVerbiage["rakeboost_text"] = "rakeboost_text";
    CommonVerbiage["rakeboost_tooltip"] = "rakeboost_tooltip";
    CommonVerbiage["rank"] = "rank";
    CommonVerbiage["rank_bronze"] = "rank_bronze";
    CommonVerbiage["rank_details"] = "rank_details";
    CommonVerbiage["rank_diamond"] = "rank_diamond";
    CommonVerbiage["rank_emerald"] = "rank_emerald";
    CommonVerbiage["rank_gold"] = "rank_gold";
    CommonVerbiage["rank_iron"] = "rank_iron";
    CommonVerbiage["rank_obsidian"] = "rank_obsidian";
    CommonVerbiage["rank_platinum"] = "rank_platinum";
    CommonVerbiage["rank_silver"] = "rank_silver";
    CommonVerbiage["rank_titanium"] = "rank_titanium";
    CommonVerbiage["rank_up"] = "rank_up";
    CommonVerbiage["rank_up_reward"] = "rank_up_reward";
    CommonVerbiage["rank_up_reward_full"] = "rank_up_reward_full";
    CommonVerbiage["rank_up_tooltip"] = "rank_up_tooltip";
    CommonVerbiage["rank_vibranium"] = "rank_vibranium";
    CommonVerbiage["rank_vip"] = "rank_vip";
    CommonVerbiage["rankname"] = "rankname";
    CommonVerbiage["ranks"] = "ranks";
    CommonVerbiage["read_more"] = "read_more";
    CommonVerbiage["ready"] = "ready";
    CommonVerbiage["ready_to_hit_jackpot"] = "ready_to_hit_jackpot";
    CommonVerbiage["ready_to_text"] = "ready_to_text";
    CommonVerbiage["real_action"] = "real_action";
    CommonVerbiage["real_dealers"] = "real_dealers";
    CommonVerbiage["real_money"] = "real_money";
    CommonVerbiage["real_play"] = "real_play";
    CommonVerbiage["real_time_affiliate_data"] = "real_time_affiliate_data";
    CommonVerbiage["receives_your_referral"] = "receives_your_referral";
    CommonVerbiage["recently_added"] = "recently_added";
    CommonVerbiage["recently_played"] = "recently_played";
    CommonVerbiage["reel_design"] = "reel_design";
    CommonVerbiage["refer_and_earn"] = "refer_and_earn";
    CommonVerbiage["refer_and_earn_banner_description"] = "refer_and_earn_banner_description";
    CommonVerbiage["refer_and_earn_banner_description_mobile"] = "refer_and_earn_banner_description_mobile";
    CommonVerbiage["refer_and_earn_banner_title"] = "refer_and_earn_banner_title";
    CommonVerbiage["refer_new_users_to_get"] = "refer_new_users_to_get";
    CommonVerbiage["refer_now"] = "refer_now";
    CommonVerbiage["referal_code"] = "referal_code";
    CommonVerbiage["referral"] = "referral";
    CommonVerbiage["referral_program"] = "referral_program";
    CommonVerbiage["referral_banner_description_part_1"] = "referral_banner_description_part_1";
    CommonVerbiage["referral_banner_description_part_2"] = "referral_banner_description_part_2";
    CommonVerbiage["referral_banner_title_part_1"] = "referral_banner_title_part_1";
    CommonVerbiage["referral_banner_title_part_2"] = "referral_banner_title_part_2";
    CommonVerbiage["referral_code"] = "referral_code";
    CommonVerbiage["referral_commission"] = "referral_commission";
    CommonVerbiage["referral_commission_rewards"] = "referral_commission_rewards";
    CommonVerbiage["referral_dashboard"] = "referral_dashboard";
    CommonVerbiage["referral_limit_details"] = "referral_limit_details";
    CommonVerbiage["referral_limit_details_answer"] = "referral_limit_details_answer";
    CommonVerbiage["referral_link"] = "referral_link";
    CommonVerbiage["referral_link_code"] = "referral_link_code";
    CommonVerbiage["referral_progress_tooltip"] = "referral_progress_tooltip";
    CommonVerbiage["referral_progress_tooltip_2"] = "referral_progress_tooltip_2";
    CommonVerbiage["referral_reward"] = "referral_reward";
    CommonVerbiage["referral_rewards_rules"] = "referral_rewards_rules";
    CommonVerbiage["referral_rewards_rules_step_1"] = "referral_rewards_rules_step_1";
    CommonVerbiage["referral_rewards_rules_step_2"] = "referral_rewards_rules_step_2";
    CommonVerbiage["referral_rewards_rules_step_3"] = "referral_rewards_rules_step_3";
    CommonVerbiage["referral_rules_added_to_your_balance"] = "referral_rules_added_to_your_balance";
    CommonVerbiage["referral_rules_period"] = "referral_rules_period";
    CommonVerbiage["referral_rules_primary_description"] = "referral_rules_primary_description";
    CommonVerbiage["referral_rules_primary_referrals"] = "referral_rules_primary_referrals";
    CommonVerbiage["referral_rules_secondary_description"] = "referral_rules_secondary_description";
    CommonVerbiage["referral_rules_secondary_referrals"] = "referral_rules_secondary_referrals";
    CommonVerbiage["referral_rules_tertiary_description"] = "referral_rules_tertiary_description";
    CommonVerbiage["referral_rules_tertiary_referrals"] = "referral_rules_tertiary_referrals";
    CommonVerbiage["referral_rules_you_earn"] = "referral_rules_you_earn";
    CommonVerbiage["referral_stats_tooltip"] = "referral_stats_tooltip";
    CommonVerbiage["referral_subtitle"] = "referral_subtitle";
    CommonVerbiage["referral_system"] = "referral_system";
    CommonVerbiage["referral_tier"] = "referral_tier";
    CommonVerbiage["referral_tracking_details"] = "referral_tracking_details";
    CommonVerbiage["referral_tracking_details_answer"] = "referral_tracking_details_answer";
    CommonVerbiage["referral_username"] = "referral_username";
    CommonVerbiage["referrals"] = "referrals";
    CommonVerbiage["referrers_bonus"] = "referrers_bonus";
    CommonVerbiage["refresh_page"] = "refresh_page";
    CommonVerbiage["register"] = "register";
    CommonVerbiage["registered"] = "registered";
    CommonVerbiage["REGULAR"] = "REGULAR";
    CommonVerbiage["regular_promotions"] = "regular_promotions";
    CommonVerbiage["rejected"] = "rejected";
    CommonVerbiage["remember_only_usdt"] = "remember_only_usdt";
    CommonVerbiage["reporting_details"] = "reporting_details";
    CommonVerbiage["request"] = "request";
    CommonVerbiage["requested"] = "requested";
    CommonVerbiage["requirekeyOrCode"] = "requirekeyOrCode";
    CommonVerbiage["resend"] = "resend";
    CommonVerbiage["resend_code"] = "resend_code";
    CommonVerbiage["reset"] = "reset";
    CommonVerbiage["reset_action"] = "reset_action";
    CommonVerbiage["reset_cashback_confirm_body"] = "reset_cashback_confirm_body";
    CommonVerbiage["reset_cashback_confirm_title"] = "reset_cashback_confirm_title";
    CommonVerbiage["reset_cashback_cta"] = "reset_cashback_cta";
    CommonVerbiage["reset_cashback_retry"] = "reset_cashback_retry";
    CommonVerbiage["reset_cashback_success"] = "reset_cashback_success";
    CommonVerbiage["reset_cta"] = "reset_cta";
    CommonVerbiage["reset_password"] = "reset_password";
    CommonVerbiage["reset_password_email_instructions"] = "reset_password_email_instructions";
    CommonVerbiage["responsible_gaming"] = "responsible_gaming";
    CommonVerbiage["returned"] = "returned";
    CommonVerbiage["returning"] = "returning";
    CommonVerbiage["reversed"] = "reversed";
    CommonVerbiage["reviewing"] = "reviewing";
    CommonVerbiage["reward"] = "reward";
    CommonVerbiage["reward_claimed_successfully"] = "reward_claimed_successfully";
    CommonVerbiage["reward_claimed_successfully_text"] = "reward_claimed_successfully_text";
    CommonVerbiage["reward_details"] = "reward_details";
    CommonVerbiage["reward_history"] = "reward_history";
    CommonVerbiage["reward_promo_daily_bonus_description"] = "reward_promo_daily_bonus_description";
    CommonVerbiage["reward_promo_daily_bonus_title"] = "reward_promo_daily_bonus_title";
    CommonVerbiage["reward_promo_level_up_bonus_description"] = "reward_promo_level_up_bonus_description";
    CommonVerbiage["reward_promo_level_up_bonus_title"] = "reward_promo_level_up_bonus_title";
    CommonVerbiage["reward_promo_monthly_bonus_description"] = "reward_promo_monthly_bonus_description";
    CommonVerbiage["reward_promo_monthly_bonus_title"] = "reward_promo_monthly_bonus_title";
    CommonVerbiage["reward_promo_rakeback_description"] = "reward_promo_rakeback_description";
    CommonVerbiage["reward_promo_rakeback_title"] = "reward_promo_rakeback_title";
    CommonVerbiage["reward_promo_weekly_bonus_description"] = "reward_promo_weekly_bonus_description";
    CommonVerbiage["reward_promo_weekly_bonus_title"] = "reward_promo_weekly_bonus_title";
    CommonVerbiage["rewards_progress"] = "rewards_progress";
    CommonVerbiage["reward_to_claim"] = "reward_to_claim";
    CommonVerbiage["rewarded"] = "rewarded";
    CommonVerbiage["rewards"] = "rewards";
    CommonVerbiage["rewards_and_cashback_description"] = "rewards_and_cashback_description";
    CommonVerbiage["rewards_increase"] = "rewards_increase";
    CommonVerbiage["rewards_text"] = "rewards_text";
    CommonVerbiage["rewards_program"] = "rewards_program";
    CommonVerbiage["rewards_program_description"] = "rewards_program_description";
    CommonVerbiage["rocket_affiliate_managers_details"] = "rocket_affiliate_managers_details";
    CommonVerbiage["rocket_affiliate_marketing_promotion"] = "rocket_affiliate_marketing_promotion";
    CommonVerbiage["rocket_boost_up"] = "rocket_boost_up";
    CommonVerbiage["rocket_commission_schemes_details"] = "rocket_commission_schemes_details";
    CommonVerbiage["rocket_contact_us"] = "rocket_contact_us";
    CommonVerbiage["rocket_crypto_casino"] = "rocket_crypto_casino";
    CommonVerbiage["rocket_crypto_casino_description"] = "rocket_crypto_casino_description";
    CommonVerbiage["rocket_dedicated_affiliate_managers"] = "rocket_dedicated_affiliate_managers";
    CommonVerbiage["rocket_different_commission_schemes"] = "rocket_different_commission_schemes";
    CommonVerbiage["rocket_earnings_potential_with_partners"] = "rocket_earnings_potential_with_partners";
    CommonVerbiage["rocket_fast_efficient_payments"] = "rocket_fast_efficient_payments";
    CommonVerbiage["rocket_games_details"] = "rocket_games_details";
    CommonVerbiage["rocket_high_ngr_increased_revenue"] = "rocket_high_ngr_increased_revenue";
    CommonVerbiage["rocket_inner_circle_telegram_description"] = "rocket_inner_circle_telegram_description";
    CommonVerbiage["rocket_inner_circle_telegram_title"] = "rocket_inner_circle_telegram_title";
    CommonVerbiage["rocket_jackpot_million_description"] = "rocket_jackpot_million_description";
    CommonVerbiage["rocket_jackpot_million_title"] = "rocket_jackpot_million_title";
    CommonVerbiage["rocket_lifetime_commissions"] = "rocket_lifetime_commissions";
    CommonVerbiage["rocket_lifetime_commissions_details"] = "rocket_lifetime_commissions_details";
    CommonVerbiage["rocket_ngr_details"] = "rocket_ngr_details";
    CommonVerbiage["rocket_partners_perks"] = "rocket_partners_perks";
    CommonVerbiage["rocket_partners_program"] = "rocket_partners_program";
    CommonVerbiage["rocket_payment_details"] = "rocket_payment_details";
    CommonVerbiage["rocket_promotions_details"] = "rocket_promotions_details";
    CommonVerbiage["rocket_rakeboost_promo_description"] = "rocket_rakeboost_promo_description";
    CommonVerbiage["rocket_rakeboost_promo_title"] = "rocket_rakeboost_promo_title";
    CommonVerbiage["rocket_races"] = "rocket_races";
    CommonVerbiage["rocket_real_time_affiliate_data"] = "rocket_real_time_affiliate_data";
    CommonVerbiage["rocket_regular_promotions"] = "rocket_regular_promotions";
    CommonVerbiage["rocket_reporting_details"] = "rocket_reporting_details";
    CommonVerbiage["rocket_start_earning_today"] = "rocket_start_earning_today";
    CommonVerbiage["rocket_support_details"] = "rocket_support_details";
    CommonVerbiage["rocket_support_in_multiple_languages"] = "rocket_support_in_multiple_languages";
    CommonVerbiage["rocket_thousands_of_casino_games"] = "rocket_thousands_of_casino_games";
    CommonVerbiage["rocket_weekly_prizes_description"] = "rocket_weekly_prizes_description";
    CommonVerbiage["rocket_weekly_prizes_title"] = "rocket_weekly_prizes_title";
    CommonVerbiage["rocket_why_choose_partners"] = "rocket_why_choose_partners";
    CommonVerbiage["rocketbet_commission_percentage"] = "rocketbet_commission_percentage";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_1"] = "rocketbet_faq_about_refer_and_earn_1";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_1_answer"] = "rocketbet_faq_about_refer_and_earn_1_answer";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_2"] = "rocketbet_faq_about_refer_and_earn_2";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_2_answer"] = "rocketbet_faq_about_refer_and_earn_2_answer";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_3"] = "rocketbet_faq_about_refer_and_earn_3";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_3_answer"] = "rocketbet_faq_about_refer_and_earn_3_answer";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_4"] = "rocketbet_faq_about_refer_and_earn_4";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_4_answer"] = "rocketbet_faq_about_refer_and_earn_4_answer";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_5"] = "rocketbet_faq_about_refer_and_earn_5";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_5_answer"] = "rocketbet_faq_about_refer_and_earn_5_answer";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_6"] = "rocketbet_faq_about_refer_and_earn_6";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_6_answer"] = "rocketbet_faq_about_refer_and_earn_6_answer";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_7"] = "rocketbet_faq_about_refer_and_earn_7";
    CommonVerbiage["rocketbet_faq_about_refer_and_earn_7_answer"] = "rocketbet_faq_about_refer_and_earn_7_answer";
    CommonVerbiage["rocketbet_invite_new_users_and_get_commission"] = "rocketbet_invite_new_users_and_get_commission";
    CommonVerbiage["rocketbet_invite_your_friends_banner_description"] = "rocketbet_invite_your_friends_banner_description";
    CommonVerbiage["rocketbet_my_referral_rewards"] = "rocketbet_my_referral_rewards";
    CommonVerbiage["rocketbet_my_total_referrals"] = "rocketbet_my_total_referrals";
    CommonVerbiage["rocketbet_number_referrals"] = "rocketbet_number_referrals";
    CommonVerbiage["rocketbet_read_more"] = "rocketbet_read_more";
    CommonVerbiage["rocketbet_refer_and_earn"] = "rocketbet_refer_and_earn";
    CommonVerbiage["rocketbet_refer_and_earn_banner_tagline"] = "rocketbet_refer_and_earn_banner_tagline";
    CommonVerbiage["rocketbet_register"] = "rocketbet_register";
    CommonVerbiage["rocketbet_referral_reward"] = "rocketbet_referral_reward";
    CommonVerbiage["rocketbet_referral_tier"] = "rocketbet_referral_tier";
    CommonVerbiage["rocketbet_share_via_socials"] = "rocketbet_share_via_socials";
    CommonVerbiage["rocketbet_tier1_referrals"] = "rocketbet_tier1_referrals";
    CommonVerbiage["rocketbet_tier2_referrals"] = "rocketbet_tier2_referrals";
    CommonVerbiage["rocketbet_tier3_referrals"] = "rocketbet_tier3_referrals";
    CommonVerbiage["rocketbet_your_referral_link"] = "rocketbet_your_referral_link";
    CommonVerbiage["rocketbet_vegas_takeover"] = "rocketbet_vegas_takeover";
    CommonVerbiage["rocketbet_vegas_takeover_description"] = "rocketbet_vegas_takeover_description";
    CommonVerbiage["rocketbet_promotions_footer_text_3000_welcome_bonus"] = "rocketbet_promotions_footer_text_3000_welcome_bonus";
    CommonVerbiage["rocketbet_promotions_footer_text_1500_every_week"] = "rocketbet_promotions_footer_text_1500_every_week";
    CommonVerbiage["rocketbet_promotions_footer_text_all_caps"] = "rocketbet_promotions_footer_text_all_caps";
    CommonVerbiage["rocketbet_promotions_footer_text_500_cash_prize"] = "rocketbet_promotions_footer_text_500_cash_prize";
    CommonVerbiage["rocketbet_promotions_footer_text_daily_rewards"] = "rocketbet_promotions_footer_text_daily_rewards";
    CommonVerbiage["rocketbet_promotions_footer_text_vip_galaxy"] = "rocketbet_promotions_footer_text_vip_galaxy";
    CommonVerbiage["rocketbet_promotions_footer_text_exclusive_bonuses"] = "rocketbet_promotions_footer_text_exclusive_bonuses";
    CommonVerbiage["rocketbet_promotions_footer_text_boost_your_rewards"] = "rocketbet_promotions_footer_text_boost_your_rewards";
    CommonVerbiage["rollback"] = "rollback";
    CommonVerbiage["rollover_progress"] = "rollover_progress";
    CommonVerbiage["rotate_seed_pair"] = "rotate_seed_pair";
    CommonVerbiage["roulette"] = "roulette";
    CommonVerbiage["rugby"] = "rugby";
    CommonVerbiage["rule_1"] = "rule_1";
    CommonVerbiage["rule_2"] = "rule_2";
    CommonVerbiage["rule_3"] = "rule_3";
    CommonVerbiage["rule_4"] = "rule_4";
    CommonVerbiage["rule_5"] = "rule_5";
    CommonVerbiage["rule_6"] = "rule_6";
    CommonVerbiage["rules"] = "rules";
    CommonVerbiage["santa_still_pays"] = "santa_still_pays";
    CommonVerbiage["saveBirthdayButtonText"] = "saveBirthdayButtonText";
    CommonVerbiage["saveButtonText"] = "saveButtonText";
    CommonVerbiage["save_password"] = "save_password";
    CommonVerbiage["scan_the_qr_code_with_your_mobile_device_if_you_prefer"] = "scan_the_qr_code_with_your_mobile_device_if_you_prefer";
    CommonVerbiage["scan_verify"] = "scan_verify";
    CommonVerbiage["schedule"] = "schedule";
    CommonVerbiage["scroll_to_see_leaderboards"] = "scroll_to_see_leaderboards";
    CommonVerbiage["search"] = "search";
    CommonVerbiage["search_games"] = "search_games";
    CommonVerbiage["search_gifs"] = "search_gifs";
    CommonVerbiage["searching"] = "searching";
    CommonVerbiage["see_less"] = "see_less";
    CommonVerbiage["see_more"] = "see_more";
    CommonVerbiage["security"] = "security";
    CommonVerbiage["security_tab"] = "security_tab";
    CommonVerbiage["seeds"] = "seeds";
    CommonVerbiage["select"] = "select";
    CommonVerbiage["select_address_and_network"] = "select_address_and_network";
    CommonVerbiage["select_amount_withdraw"] = "select_amount_withdraw";
    CommonVerbiage["select_an_option"] = "select_an_option";
    CommonVerbiage["select_birthday_option"] = "select_birthday_option";
    CommonVerbiage["select_currency"] = "select_currency";
    CommonVerbiage["select_game"] = "select_game";
    CommonVerbiage["select_items_per_page"] = "select_items_per_page";
    CommonVerbiage["select_network"] = "select_network";
    CommonVerbiage["select_network_title"] = "select_network_title";
    CommonVerbiage["select_network_withdraw"] = "select_network_withdraw";
    CommonVerbiage["select_token"] = "select_token";
    CommonVerbiage["select_token_withdraw"] = "select_token_withdraw";
    CommonVerbiage["self_exclusion_description"] = "self_exclusion_description";
    CommonVerbiage["self_exclusion_duration_1_day"] = "self_exclusion_duration_1_day";
    CommonVerbiage["self_exclusion_duration_1_month"] = "self_exclusion_duration_1_month";
    CommonVerbiage["self_exclusion_duration_1_week"] = "self_exclusion_duration_1_week";
    CommonVerbiage["self_exclusion_duration_1_year"] = "self_exclusion_duration_1_year";
    CommonVerbiage["self_exclusion_duration_3_months"] = "self_exclusion_duration_3_months";
    CommonVerbiage["self_exclusion_duration_6_months"] = "self_exclusion_duration_6_months";
    CommonVerbiage["self_exclusion_duration_dropdown_placeholder"] = "self_exclusion_duration_dropdown_placeholder";
    CommonVerbiage["self_exclusion_duration_indefinite"] = "self_exclusion_duration_indefinite";
    CommonVerbiage["self_exclusion_duration_text"] = "self_exclusion_duration_text";
    CommonVerbiage["self_exclusion_period_disabled"] = "self_exclusion_period_disabled";
    CommonVerbiage["self_exclusion_period_enabled"] = "self_exclusion_period_enabled";
    CommonVerbiage["self_exclusion_period_requested"] = "self_exclusion_period_requested";
    CommonVerbiage["self_exclusion_permanent_exclusion_button_text"] = "self_exclusion_permanent_exclusion_button_text";
    CommonVerbiage["self_exclusion_permanent_exclusion_message"] = "self_exclusion_permanent_exclusion_message";
    CommonVerbiage["self_exclusion_permanent_exclusion_title"] = "self_exclusion_permanent_exclusion_title";
    CommonVerbiage["self_exclusion_reinstate_account_button_text"] = "self_exclusion_reinstate_account_button_text";
    CommonVerbiage["self_exclusion_reinstate_account_message"] = "self_exclusion_reinstate_account_message";
    CommonVerbiage["self_exclusion_reinstate_account_title"] = "self_exclusion_reinstate_account_title";
    CommonVerbiage["self_exclusion_tab"] = "self_exclusion_tab";
    CommonVerbiage["self_exclusion_warning_toast_message"] = "self_exclusion_warning_toast_message";
    CommonVerbiage["self_exclusion_warning_toast_title"] = "self_exclusion_warning_toast_title";
    CommonVerbiage["self_family_referral_policy"] = "self_family_referral_policy";
    CommonVerbiage["self_family_referral_policy_answer"] = "self_family_referral_policy_answer";
    CommonVerbiage["selfie"] = "selfie";
    CommonVerbiage["send_code"] = "send_code";
    CommonVerbiage["send_only"] = "send_only";
    CommonVerbiage["send_only_warning"] = "send_only_warning";
    CommonVerbiage["send_the_amount_meme_coins"] = "send_the_amount_meme_coins";
    CommonVerbiage["send_the_amount_of"] = "send_the_amount_of";
    CommonVerbiage["send_tip"] = "send_tip";
    CommonVerbiage["sent"] = "sent";
    CommonVerbiage["server_seed"] = "server_seed";
    CommonVerbiage["set_as_default_campaign"] = "set_as_default_campaign";
    CommonVerbiage["set_new_password"] = "set_new_password";
    CommonVerbiage["set_password"] = "set_password";
    CommonVerbiage["set_up_your_campaign"] = "set_up_your_campaign";
    CommonVerbiage["settings"] = "settings";
    CommonVerbiage["settings_bet_feed_username"] = "settings_bet_feed_username";
    CommonVerbiage["settings_joined_date"] = "settings_joined_date";
    CommonVerbiage["settings_leaderboards_username"] = "settings_leaderboards_username";
    CommonVerbiage["settings_marketing_emails"] = "settings_marketing_emails";
    CommonVerbiage["settings_private"] = "settings_private";
    CommonVerbiage["settings_public"] = "settings_public";
    CommonVerbiage["setup"] = "setup";
    CommonVerbiage["share_via_socials"] = "share_via_socials";
    CommonVerbiage["share_via_socials_message"] = "share_via_socials_message";
    CommonVerbiage["share_via_socials_message_flush"] = "share_via_socials_message_flush";
    CommonVerbiage["share_via_socials_message_fomo"] = "share_via_socials_message_fomo";
    CommonVerbiage["share_via_socials_text"] = "share_via_socials_text";
    CommonVerbiage["share_your_message"] = "share_your_message";
    CommonVerbiage["share_your_rewards"] = "share_your_rewards";
    CommonVerbiage["share_your_rewards_text"] = "share_your_rewards_text";
    CommonVerbiage["shared"] = "shared";
    CommonVerbiage["show"] = "show";
    CommonVerbiage["show_full_birthday"] = "show_full_birthday";
    CommonVerbiage["show_less"] = "show_less";
    CommonVerbiage["show_more"] = "show_more";
    CommonVerbiage["show_only_day"] = "show_only_day";
    CommonVerbiage["show_only_month"] = "show_only_month";
    CommonVerbiage["sidebar_jackpot_banner_aria_label"] = "sidebar_jackpot_banner_aria_label";
    CommonVerbiage["sign"] = "sign";
    CommonVerbiage["sign_up"] = "sign_up";
    CommonVerbiage["sign_up_text"] = "sign_up_text";
    CommonVerbiage["sign_up_claim"] = "sign_up_claim";
    CommonVerbiage["sign_up_claim_description"] = "sign_up_claim_description";
    CommonVerbiage["sign_up_today_call_to_action"] = "sign_up_today_call_to_action";
    CommonVerbiage["signature_required"] = "signature_required";
    CommonVerbiage["signup"] = "signup";
    CommonVerbiage["signup_via_wallet"] = "signup_via_wallet";
    CommonVerbiage["signup_bonus_150"] = "signup_bonus_150";
    CommonVerbiage["silver"] = "silver";
    CommonVerbiage["similar_games"] = "similar_games";
    CommonVerbiage["sixdigit"] = "sixdigit";
    CommonVerbiage["ski_jumping"] = "ski_jumping";
    CommonVerbiage["sky_high_limits"] = "sky_high_limits";
    CommonVerbiage["slots"] = "slots";
    CommonVerbiage["slots_live"] = "slots_live";
    CommonVerbiage["sms_verification"] = "sms_verification";
    CommonVerbiage["snooker"] = "snooker";
    CommonVerbiage["something_went_wrong"] = "something_went_wrong";
    CommonVerbiage["soon"] = "soon";
    CommonVerbiage["sorry_text"] = "sorry_text";
    CommonVerbiage["sort_by"] = "sort_by";
    CommonVerbiage["sound"] = "sound";
    CommonVerbiage["specials"] = "specials";
    CommonVerbiage["spin"] = "spin";
    CommonVerbiage["spin_again"] = "spin_again";
    CommonVerbiage["SPIN_ONLY_WIN"] = "SPIN_ONLY_WIN";
    CommonVerbiage["SPIN_UNTIL_YOU_WIN"] = "SPIN_UNTIL_YOU_WIN";
    CommonVerbiage["sport"] = "sport";
    CommonVerbiage["sport_betting"] = "sport_betting";
    CommonVerbiage["sports"] = "sports";
    CommonVerbiage["sports_description"] = "sports_description";
    CommonVerbiage["sports_subtitle"] = "sports_subtitle";
    CommonVerbiage["sports_terms"] = "sports_terms";
    CommonVerbiage["sportsbook"] = "sportsbook";
    CommonVerbiage["squash"] = "squash";
    CommonVerbiage["stakes_range"] = "stakes_range";
    CommonVerbiage["starcraft"] = "starcraft";
    CommonVerbiage["start_earning_today"] = "start_earning_today";
    CommonVerbiage["start_inviting_your_friends"] = "start_inviting_your_friends";
    CommonVerbiage["start_now"] = "start_now";
    CommonVerbiage["started"] = "started";
    CommonVerbiage["starting_shortly"] = "starting_shortly";
    CommonVerbiage["starts"] = "starts";
    CommonVerbiage["statistics"] = "statistics";
    CommonVerbiage["status"] = "status";
    CommonVerbiage["step_1_description"] = "step_1_description";
    CommonVerbiage["step_1_text"] = "step_1_text";
    CommonVerbiage["step_2_description"] = "step_2_description";
    CommonVerbiage["step_2_text"] = "step_2_text";
    CommonVerbiage["step_3_description"] = "step_3_description";
    CommonVerbiage["step_3_text"] = "step_3_text";
    CommonVerbiage["strategies_to_increase_earnings"] = "strategies_to_increase_earnings";
    CommonVerbiage["strategies_to_increase_earnings_answer"] = "strategies_to_increase_earnings_answer";
    CommonVerbiage["submit"] = "submit";
    CommonVerbiage["submit_and_deposit"] = "submit_and_deposit";
    CommonVerbiage["submit_and_withdraw"] = "submit_and_withdraw";
    CommonVerbiage["submitInfoButtonLabel"] = "submitInfoButtonLabel";
    CommonVerbiage["subscribe"] = "subscribe";
    CommonVerbiage["succeeded"] = "succeeded";
    CommonVerbiage["success"] = "success";
    CommonVerbiage["super_scatter"] = "super_scatter";
    CommonVerbiage["super_scatter_description"] = "super_scatter_description";
    CommonVerbiage["super_scatter_series_daily_tournaments"] = "super_scatter_series_daily_tournaments";
    CommonVerbiage["super_scatter_series_daily_tournaments_description"] = "super_scatter_series_daily_tournaments_description";
    CommonVerbiage["support"] = "support";
    CommonVerbiage["support_and_play"] = "support_and_play";
    CommonVerbiage["support_chat_account_help"] = "support_chat_account_help";
    CommonVerbiage["support_chat_agent_follow_up"] = "support_chat_agent_follow_up";
    CommonVerbiage["support_chat_agent_intro"] = "support_chat_agent_intro";
    CommonVerbiage["support_chat_agent_reply"] = "support_chat_agent_reply";
    CommonVerbiage["support_chat_ai_agent"] = "support_chat_ai_agent";
    CommonVerbiage["support_chat_ai_unavailable"] = "support_chat_ai_unavailable";
    CommonVerbiage["support_chat_ask_a_question_placeholder"] = "support_chat_ask_a_question_placeholder";
    CommonVerbiage["support_chat_ask_your_question"] = "support_chat_ask_your_question";
    CommonVerbiage["support_chat_assigned_notice"] = "support_chat_assigned_notice";
    CommonVerbiage["support_chat_attachment_error"] = "support_chat_attachment_error";
    CommonVerbiage["support_chat_conversation_closed"] = "support_chat_conversation_closed";
    CommonVerbiage["support_chat_customer_banned"] = "support_chat_customer_banned";
    CommonVerbiage["support_chat_conversation_resolved"] = "support_chat_conversation_resolved";
    CommonVerbiage["support_chat_depositing_usdt"] = "support_chat_depositing_usdt";
    CommonVerbiage["support_chat_filter_closed"] = "support_chat_filter_closed";
    CommonVerbiage["support_chat_filter_open"] = "support_chat_filter_open";
    CommonVerbiage["support_chat_handoff_notice"] = "support_chat_handoff_notice";
    CommonVerbiage["support_chat_home"] = "support_chat_home";
    CommonVerbiage["support_chat_how_can_we_help"] = "support_chat_how_can_we_help";
    CommonVerbiage["support_chat_human_agent"] = "support_chat_human_agent";
    CommonVerbiage["support_chat_message_meta"] = "support_chat_message_meta";
    CommonVerbiage["support_chat_message_meta_without_time"] = "support_chat_message_meta_without_time";
    CommonVerbiage["support_chat_message_too_long_error"] = "support_chat_message_too_long_error";
    CommonVerbiage["support_chat_messages"] = "support_chat_messages";
    CommonVerbiage["support_chat_messages_empty_description"] = "support_chat_messages_empty_description";
    CommonVerbiage["support_chat_money_matters"] = "support_chat_money_matters";
    CommonVerbiage["support_chat_no_messages"] = "support_chat_no_messages";
    CommonVerbiage["support_chat_perks_and_promos"] = "support_chat_perks_and_promos";
    CommonVerbiage["support_chat_quick_questions"] = "support_chat_quick_questions";
    CommonVerbiage["support_chat_search_for_help"] = "support_chat_search_for_help";
    CommonVerbiage["support_chat_search_in_articles"] = "support_chat_search_in_articles";
    CommonVerbiage["support_chat_sender_meta"] = "support_chat_sender_meta";
    CommonVerbiage["support_chat_two_step_verification"] = "support_chat_two_step_verification";
    CommonVerbiage["support_chat_vip_rewards_explained"] = "support_chat_vip_rewards_explained";
    CommonVerbiage["support_chat_welcome_bonus"] = "support_chat_welcome_bonus";
    CommonVerbiage["support_chat_withdrawals_usdt"] = "support_chat_withdrawals_usdt";
    CommonVerbiage["support_details"] = "support_details";
    CommonVerbiage["support_in_multiple_languages"] = "support_in_multiple_languages";
    CommonVerbiage["support_your"] = "support_your";
    CommonVerbiage["svelte_component"] = "svelte_component";
    CommonVerbiage["sweet_bonanza"] = "sweet_bonanza";
    CommonVerbiage["switch_inputs"] = "switch_inputs";
    CommonVerbiage["table_games"] = "table_games";
    CommonVerbiage["table_tennis"] = "table_tennis";
    CommonVerbiage["tailored_bonus_plan"] = "tailored_bonus_plan";
    CommonVerbiage["tailored_reload_bonuses_text"] = "tailored_reload_bonuses_text";
    CommonVerbiage["take_your_shot_today"] = "take_your_shot_today";
    CommonVerbiage["tanked_3_first_blood_2"] = "tanked_3_first_blood_2";
    CommonVerbiage["tanked_3_first_blood_2_description"] = "tanked_3_first_blood_2_description";
    CommonVerbiage["ten_per_page"] = "ten_per_page";
    CommonVerbiage["tennis"] = "tennis";
    CommonVerbiage["terms"] = "terms";
    CommonVerbiage["terms_and_conditions"] = "terms_and_conditions";
    CommonVerbiage["terms_and_conditions_1"] = "terms_and_conditions_1";
    CommonVerbiage["terms_and_conditions_10"] = "terms_and_conditions_10";
    CommonVerbiage["terms_and_conditions_11"] = "terms_and_conditions_11";
    CommonVerbiage["terms_and_conditions_2"] = "terms_and_conditions_2";
    CommonVerbiage["terms_and_conditions_3"] = "terms_and_conditions_3";
    CommonVerbiage["terms_and_conditions_4"] = "terms_and_conditions_4";
    CommonVerbiage["terms_and_conditions_5"] = "terms_and_conditions_5";
    CommonVerbiage["terms_and_conditions_6"] = "terms_and_conditions_6";
    CommonVerbiage["terms_and_conditions_7"] = "terms_and_conditions_7";
    CommonVerbiage["terms_and_conditions_8"] = "terms_and_conditions_8";
    CommonVerbiage["terms_and_conditions_9"] = "terms_and_conditions_9";
    CommonVerbiage["terms_and_conditions_title"] = "terms_and_conditions_title";
    CommonVerbiage["terms_of_service"] = "terms_of_service";
    CommonVerbiage["telegram_follow"] = "telegram_follow";
    CommonVerbiage["testimonial_1_text"] = "testimonial_1_text";
    CommonVerbiage["testimonial_2_text"] = "testimonial_2_text";
    CommonVerbiage["testimonial_3_text"] = "testimonial_3_text";
    CommonVerbiage["testimonial_4_text"] = "testimonial_4_text";
    CommonVerbiage["testimonials_text"] = "testimonials_text";
    CommonVerbiage["the_value_of_the"] = "the_value_of_the";
    CommonVerbiage["third_party"] = "third_party";
    CommonVerbiage["thousand_of_games"] = "thousand_of_games";
    CommonVerbiage["thousands_of_casino_games"] = "thousands_of_casino_games";
    CommonVerbiage["tier"] = "tier";
    CommonVerbiage["tier_name_text"] = "tier_name_text";
    CommonVerbiage["tier1_referrals"] = "tier1_referrals";
    CommonVerbiage["tier2_referrals"] = "tier2_referrals";
    CommonVerbiage["tier3_referrals"] = "tier3_referrals";
    CommonVerbiage["time"] = "time";
    CommonVerbiage["timer_days"] = "timer_days";
    CommonVerbiage["timer_hours"] = "timer_hours";
    CommonVerbiage["timer_minutes"] = "timer_minutes";
    CommonVerbiage["timer_seconds"] = "timer_seconds";
    CommonVerbiage["timezone_gmt_plus_7"] = "timezone_gmt_plus_7";
    CommonVerbiage["tip"] = "tip";
    CommonVerbiage["tip_amount"] = "tip_amount";
    CommonVerbiage["tip_below_minimum"] = "tip_below_minimum";
    CommonVerbiage["tip_error"] = "tip_error";
    CommonVerbiage["tip_exceeds_balance"] = "tip_exceeds_balance";
    CommonVerbiage["tip_exceeds_maximum"] = "tip_exceeds_maximum";
    CommonVerbiage["tip_invalid"] = "tip_invalid";
    CommonVerbiage["tip_network_error"] = "tip_network_error";
    CommonVerbiage["tip_sent"] = "tip_sent";
    CommonVerbiage["tip_sent_success"] = "tip_sent_success";
    CommonVerbiage["tip_too_large"] = "tip_too_large";
    CommonVerbiage["tip_too_small"] = "tip_too_small";
    CommonVerbiage["titanium"] = "titanium";
    CommonVerbiage["title"] = "title";
    CommonVerbiage["to_enable_login_via_wallet_please_click_sign_and_then_go_to_your_wallet_to_view_and_confirm_this_message"] = "to_enable_login_via_wallet_please_click_sign_and_then_go_to_your_wallet_to_view_and_confirm_this_message";
    CommonVerbiage["to_get"] = "to_get";
    CommonVerbiage["to_next_lvl"] = "to_next_lvl";
    CommonVerbiage["to_this_address"] = "to_this_address";
    CommonVerbiage["today"] = "today";
    CommonVerbiage["token_balance_label"] = "token_balance_label";
    CommonVerbiage["tokens"] = "tokens";
    CommonVerbiage["too_many_attempts_please_try_again_later"] = "too_many_attempts_please_try_again_later";
    CommonVerbiage["too_many_attempts_please_contact_support"] = "too_many_attempts_please_contact_support";
    CommonVerbiage["top_card_live_casino_description"] = "top_card_live_casino_description";
    CommonVerbiage["top_card_live_casino_title"] = "top_card_live_casino_title";
    CommonVerbiage["top_direct_referrals"] = "top_direct_referrals";
    CommonVerbiage["total"] = "total";
    CommonVerbiage["total_balance"] = "total_balance";
    CommonVerbiage["total_bets"] = "total_bets";
    CommonVerbiage["total_bets_made_with_pair"] = "total_bets_made_with_pair";
    CommonVerbiage["total_claimed"] = "total_claimed";
    CommonVerbiage["total_claimed_rewards"] = "total_claimed_rewards";
    CommonVerbiage["total_earnings"] = "total_earnings";
    CommonVerbiage["total_level_up_rewards"] = "total_level_up_rewards";
    CommonVerbiage["total_level_up_rewards_text"] = "total_level_up_rewards_text";
    CommonVerbiage["total_referrals"] = "total_referrals";
    CommonVerbiage["total_referrals_table_tooltip"] = "total_referrals_table_tooltip";
    CommonVerbiage["total_rewarded"] = "total_rewarded";
    CommonVerbiage["total_tips"] = "total_tips";
    CommonVerbiage["total_wager"] = "total_wager";
    CommonVerbiage["total_wagered"] = "total_wagered";
    CommonVerbiage["totp_setup"] = "totp_setup";
    CommonVerbiage["totp_verify"] = "totp_verify";
    CommonVerbiage["tournaments"] = "tournaments";
    CommonVerbiage["tournaments_and_raffles_description"] = "tournaments_and_raffles_description";
    CommonVerbiage["tournaments_and_raffles_first_part_title"] = "tournaments_and_raffles_first_part_title";
    CommonVerbiage["tournaments_and_raffles_second_part_title"] = "tournaments_and_raffles_second_part_title";
    CommonVerbiage["tournaments_and_raffles_title_highlight"] = "tournaments_and_raffles_title_highlight";
    CommonVerbiage["tournaments_description"] = "tournaments_description";
    CommonVerbiage["transaction"] = "transaction";
    CommonVerbiage["transaction_id"] = "transaction_id";
    CommonVerbiage["transactions"] = "transactions";
    CommonVerbiage["triple_rakeback_description"] = "triple_rakeback_description";
    CommonVerbiage["triple_your_rakeback"] = "triple_your_rakeback";
    CommonVerbiage["try_again"] = "try_again";
    CommonVerbiage["twenty_per_page"] = "twenty_per_page";
    CommonVerbiage["twofa"] = "twofa";
    CommonVerbiage["twofa_setup"] = "twofa_setup";
    CommonVerbiage["twofa_totp_code"] = "twofa_totp_code";
    CommonVerbiage["twoStepVerification"] = "twoStepVerification";
    CommonVerbiage["transparency"] = "transparency";
    CommonVerbiage["transparency_all_bets_made_on_our_site_last_month"] = "transparency_all_bets_made_on_our_site_last_month";
    CommonVerbiage["transparency_audits_description"] = "transparency_audits_description";
    CommonVerbiage["transparency_average_payout_speed"] = "transparency_average_payout_speed";
    CommonVerbiage["transparency_average_response"] = "transparency_average_response";
    CommonVerbiage["transparency_avg_time_real_person_responds"] = "transparency_avg_time_real_person_responds";
    CommonVerbiage["transparency_bonus_terms_description"] = "transparency_bonus_terms_description";
    CommonVerbiage["transparency_bonus_terms_plain"] = "transparency_bonus_terms_plain";
    CommonVerbiage["transparency_clear_tiers"] = "transparency_clear_tiers";
    CommonVerbiage["transparency_deposit_500_bet"] = "transparency_deposit_500_bet";
    CommonVerbiage["transparency_earn_play_description"] = "transparency_earn_play_description";
    CommonVerbiage["transparency_earn_play_smarter"] = "transparency_earn_play_smarter";
    CommonVerbiage["transparency_earn_real_rewards"] = "transparency_earn_real_rewards";
    CommonVerbiage["transparency_every_month"] = "transparency_every_month";
    CommonVerbiage["transparency_fair_bonuses"] = "transparency_fair_bonuses";
    CommonVerbiage["transparency_fair_bonuses_description"] = "transparency_fair_bonuses_description";
    CommonVerbiage["transparency_fair_examples"] = "transparency_fair_examples";
    CommonVerbiage["transparency_fair_play_report"] = "transparency_fair_play_report";
    CommonVerbiage["transparency_fast_withdrawals"] = "transparency_fast_withdrawals";
    CommonVerbiage["transparency_fast_withdrawals_description"] = "transparency_fast_withdrawals_description";
    CommonVerbiage["transparency_features_description"] = "transparency_features_description";
    CommonVerbiage["transparency_faq_bonus_wagering_a"] = "transparency_faq_bonus_wagering_a";
    CommonVerbiage["transparency_faq_bonus_wagering_q"] = "transparency_faq_bonus_wagering_q";
    CommonVerbiage["transparency_faq_fast_withdrawals_a"] = "transparency_faq_fast_withdrawals_a";
    CommonVerbiage["transparency_faq_fast_withdrawals_q"] = "transparency_faq_fast_withdrawals_q";
    CommonVerbiage["transparency_faq_language_a"] = "transparency_faq_language_a";
    CommonVerbiage["transparency_faq_language_q"] = "transparency_faq_language_q";
    CommonVerbiage["transparency_faq_responsible_play_a"] = "transparency_faq_responsible_play_a";
    CommonVerbiage["transparency_faq_responsible_play_q"] = "transparency_faq_responsible_play_q";
    CommonVerbiage["transparency_faq_verify_fairness_a"] = "transparency_faq_verify_fairness_a";
    CommonVerbiage["transparency_faq_verify_fairness_q"] = "transparency_faq_verify_fairness_q";
    CommonVerbiage["transparency_frequently_asked"] = "transparency_frequently_asked";
    CommonVerbiage["transparency_hero_description"] = "transparency_hero_description";
    CommonVerbiage["transparency_how_we_are_fair"] = "transparency_how_we_are_fair";
    CommonVerbiage["transparency_human_support"] = "transparency_human_support";
    CommonVerbiage["transparency_human_support_247"] = "transparency_human_support_247";
    CommonVerbiage["transparency_100_percent_towards_tier_3"] = "transparency_100_percent_towards_tier_3";
    CommonVerbiage["transparency_independent_audits"] = "transparency_independent_audits";
    CommonVerbiage["transparency_loyalty_description"] = "transparency_loyalty_description";
    CommonVerbiage["transparency_loyalty_that_feels_fair"] = "transparency_loyalty_that_feels_fair";
    CommonVerbiage["transparency_manifesto"] = "transparency_manifesto";
    CommonVerbiage["transparency_manifesto_1"] = "transparency_manifesto_1";
    CommonVerbiage["transparency_manifesto_2"] = "transparency_manifesto_2";
    CommonVerbiage["transparency_manifesto_3"] = "transparency_manifesto_3";
    CommonVerbiage["transparency_manifesto_4"] = "transparency_manifesto_4";
    CommonVerbiage["transparency_manifesto_5"] = "transparency_manifesto_5";
    CommonVerbiage["transparency_manifesto_6"] = "transparency_manifesto_6";
    CommonVerbiage["transparency_manifesto_7"] = "transparency_manifesto_7";
    CommonVerbiage["transparency_manifesto_8"] = "transparency_manifesto_8";
    CommonVerbiage["transparency_manifesto_9"] = "transparency_manifesto_9";
    CommonVerbiage["transparency_manifesto_10"] = "transparency_manifesto_10";
    CommonVerbiage["transparency_manifesto_description"] = "transparency_manifesto_description";
    CommonVerbiage["transparency_median_time_from_withdrawal_request"] = "transparency_median_time_from_withdrawal_request";
    CommonVerbiage["transparency_payout_ratio"] = "transparency_payout_ratio";
    CommonVerbiage["transparency_payouts_description"] = "transparency_payouts_description";
    CommonVerbiage["transparency_payouts_processed"] = "transparency_payouts_processed";
    CommonVerbiage["transparency_player_first"] = "transparency_player_first";
    CommonVerbiage["transparency_player_first_description"] = "transparency_player_first_description";
    CommonVerbiage["transparency_playersss"] = "transparency_playersss";
    CommonVerbiage["transparency_predictable_payouts"] = "transparency_predictable_payouts";
    CommonVerbiage["transparency_questions"] = "transparency_questions";
    CommonVerbiage["transparency_rng_certified"] = "transparency_rng_certified";
    CommonVerbiage["transparency_rng_description"] = "transparency_rng_description";
    CommonVerbiage["transparency_rtp_description"] = "transparency_rtp_description";
    CommonVerbiage["transparency_rtp_on_every_game"] = "transparency_rtp_on_every_game";
    CommonVerbiage["transparency_see_your_progress"] = "transparency_see_your_progress";
    CommonVerbiage["transparency_support_description"] = "transparency_support_description";
    CommonVerbiage["transparency_the_transparency"] = "transparency_the_transparency";
    CommonVerbiage["transparency_tier_1_5_percent"] = "transparency_tier_1_5_percent";
    CommonVerbiage["transparency_tier_2_faster"] = "transparency_tier_2_faster";
    CommonVerbiage["transparency_tier_3_vip"] = "transparency_tier_3_vip";
    CommonVerbiage["transparency_tier_explanation"] = "transparency_tier_explanation";
    CommonVerbiage["transparency_transparency"] = "transparency_transparency";
    CommonVerbiage["transparency_we_publish_our_numbers"] = "transparency_we_publish_our_numbers";
    CommonVerbiage["transparency_where"] = "transparency_where";
    CommonVerbiage["transparency_win_shown_last_12_mo"] = "transparency_win_shown_last_12_mo";
    CommonVerbiage["transparency_wins"] = "transparency_wins";
    CommonVerbiage["transparency_you_can_see"] = "transparency_you_can_see";
    CommonVerbiage["transparency_wins_title"] = "transparency_wins_title";
    CommonVerbiage["transparency_tier_hit_milestones"] = "transparency_tier_hit_milestones";
    CommonVerbiage["transparency_tier_2_label"] = "transparency_tier_2_label";
    CommonVerbiage["transparency_tier_2_cashback"] = "transparency_tier_2_cashback";
    CommonVerbiage["transparency_tier_3_label"] = "transparency_tier_3_label";
    CommonVerbiage["transparency_tier_3_faster_withdrawals"] = "transparency_tier_3_faster_withdrawals";
    CommonVerbiage["transparency_vip_label"] = "transparency_vip_label";
    CommonVerbiage["transparency_vip_support_early_access"] = "transparency_vip_support_early_access";
    CommonVerbiage["transparency_progress_towards"] = "transparency_progress_towards";
    CommonVerbiage["transparency_frequently"] = "transparency_frequently";
    CommonVerbiage["transparency_asked_questions"] = "transparency_asked_questions";
    CommonVerbiage["try_it_now"] = "try_it_now";
    CommonVerbiage["try_your_luck"] = "try_your_luck";
    CommonVerbiage["turboslots_all_rights_reserved"] = "turboslots_all_rights_reserved";
    CommonVerbiage["turboslots_read_more"] = "turboslots_read_more";
    CommonVerbiage["turboslots_special_for_new_members"] = "turboslots_special_for_new_members";
    CommonVerbiage["turboslots_unlock_your_rewards"] = "turboslots_unlock_your_rewards";
    CommonVerbiage["turboslots_unlock_your_rewards_tile_subtitle"] = "turboslots_unlock_your_rewards_tile_subtitle";
    CommonVerbiage["turboslots_welcome_bonus_banner_title"] = "turboslots_welcome_bonus_banner_title";
    CommonVerbiage["turboslots_welcome_bonus_headline"] = "turboslots_welcome_bonus_headline";
    CommonVerbiage["turboslots_welcome_bonus_tile_subtitle"] = "turboslots_welcome_bonus_tile_subtitle";
    CommonVerbiage["turkish"] = "turkish";
    CommonVerbiage["turn_every_spin_into_cash_prizes"] = "turn_every_spin_into_cash_prizes";
    CommonVerbiage["unknown"] = "unknown";
    CommonVerbiage["unlock_the_bonus"] = "unlock_the_bonus";
    CommonVerbiage["unlocked_balance"] = "unlocked_balance";
    CommonVerbiage["unlocking"] = "unlocking";
    CommonVerbiage["unlocking_rules"] = "unlocking_rules";
    CommonVerbiage["unlocking_rules_text"] = "unlocking_rules_text";
    CommonVerbiage["unread"] = "unread";
    CommonVerbiage["unsubscribe"] = "unsubscribe";
    CommonVerbiage["unverified"] = "unverified";
    CommonVerbiage["unwrap_daily_wins"] = "unwrap_daily_wins";
    CommonVerbiage["up_to"] = "up_to";
    CommonVerbiage["up_to_3000_bonus_on_your_first_3_deposits"] = "up_to_3000_bonus_on_your_first_3_deposits";
    CommonVerbiage["up_to_x_bonus_on_your_first_x_deposits"] = "up_to_x_bonus_on_your_first_x_deposits";
    CommonVerbiage["x_percent_up_to_x_bonus"] = "x_percent_up_to_x_bonus";
    CommonVerbiage["upcoming"] = "upcoming";
    CommonVerbiage["upcoming_referral_reward"] = "upcoming_referral_reward";
    CommonVerbiage["upcoming_reward"] = "upcoming_reward";
    CommonVerbiage["upcoming_rewards"] = "upcoming_rewards";
    CommonVerbiage["user"] = "user";
    CommonVerbiage["user_banned"] = "user_banned";
    CommonVerbiage["user_id"] = "user_id";
    CommonVerbiage["user_not_eligible"] = "user_not_eligible";
    CommonVerbiage["username"] = "username";
    CommonVerbiage["username_format_hint"] = "username_format_hint";
    CommonVerbiage["username_is_unavailable"] = "username_is_unavailable";
    CommonVerbiage["username_must_be_letters_and_numbers"] = "username_must_be_letters_and_numbers";
    CommonVerbiage["username_or_email"] = "username_or_email";
    CommonVerbiage["validation_error"] = "validation_error";
    CommonVerbiage["value_may_change"] = "value_may_change";
    CommonVerbiage["verification"] = "verification";
    CommonVerbiage["verification_code"] = "verification_code";
    CommonVerbiage["verification_tab"] = "verification_tab";
    CommonVerbiage["verify"] = "verify";
    CommonVerbiage["verify_mobile_number"] = "verify_mobile_number";
    CommonVerbiage["verify_your_identity_and_start_playing"] = "verify_your_identity_and_start_playing";
    CommonVerbiage["verify_your_identity_and_start_playing_description"] = "verify_your_identity_and_start_playing_description";
    CommonVerbiage["vibranium"] = "vibranium";
    CommonVerbiage["video_poker"] = "video_poker";
    CommonVerbiage["view"] = "view";
    CommonVerbiage["view_all"] = "view_all";
    CommonVerbiage["view_all_games"] = "view_all_games";
    CommonVerbiage["view_all_pending_rewards"] = "view_all_pending_rewards";
    CommonVerbiage["view_all_ranks"] = "view_all_ranks";
    CommonVerbiage["view_calculation_breakdown"] = "view_calculation_breakdown";
    CommonVerbiage["view_my_accrual_history"] = "view_my_accrual_history";
    CommonVerbiage["view_vip_level_details_text"] = "view_vip_level_details_text";
    CommonVerbiage["viewAll"] = "viewAll";
    CommonVerbiage["vip"] = "vip";
    CommonVerbiage["vip_program"] = "vip_program";
    CommonVerbiage["vip_alt2_cashback_description"] = "vip_alt2_cashback_description";
    CommonVerbiage["vip_alt2_freespins_description"] = "vip_alt2_freespins_description";
    CommonVerbiage["vip_alt2_level_up_description"] = "vip_alt2_level_up_description";
    CommonVerbiage["vip_alt2_rakeback_description"] = "vip_alt2_rakeback_description";
    CommonVerbiage["vip_alt2_rakeback_perks"] = "vip_alt2_rakeback_perks";
    CommonVerbiage["vip_alt2_referral_bonus"] = "vip_alt2_referral_bonus";
    CommonVerbiage["vip_alt2_referral_description"] = "vip_alt2_referral_description";
    CommonVerbiage["vip_benefits_text"] = "vip_benefits_text";
    CommonVerbiage["vip_club"] = "vip_club";
    CommonVerbiage["vip_club_description"] = "vip_club_description";
    CommonVerbiage["vip_club_text"] = "vip_club_text";
    CommonVerbiage["vip_desc"] = "vip_desc";
    CommonVerbiage["vip_description"] = "vip_description";
    CommonVerbiage["vip_events"] = "vip_events";
    CommonVerbiage["vip_galaxy"] = "vip_galaxy";
    CommonVerbiage["vip_level"] = "vip_level";
    CommonVerbiage["vip_modern_always_cash_rewards_no_wagering"] = "vip_modern_always_cash_rewards_no_wagering";
    CommonVerbiage["vip_modern_bigger_bonus_bigger_requirement"] = "vip_modern_bigger_bonus_bigger_requirement";
    CommonVerbiage["vip_modern_calendar_label"] = "vip_modern_calendar_label";
    CommonVerbiage["vip_modern_cash_rewards"] = "vip_modern_cash_rewards";
    CommonVerbiage["vip_modern_cash_rewards_body"] = "vip_modern_cash_rewards_body";
    CommonVerbiage["vip_modern_cashback_body1"] = "vip_modern_cashback_body1";
    CommonVerbiage["vip_modern_cashback_body2"] = "vip_modern_cashback_body2";
    CommonVerbiage["vip_modern_cashback_body3"] = "vip_modern_cashback_body3";
    CommonVerbiage["vip_modern_cashback_daily_formula"] = "vip_modern_cashback_daily_formula";
    CommonVerbiage["vip_modern_cashback_monthly_formula"] = "vip_modern_cashback_monthly_formula";
    CommonVerbiage["vip_modern_cashback_title"] = "vip_modern_cashback_title";
    CommonVerbiage["vip_modern_cashback_title_line1"] = "vip_modern_cashback_title_line1";
    CommonVerbiage["vip_modern_cashback_title_line2"] = "vip_modern_cashback_title_line2";
    CommonVerbiage["vip_modern_cashback_total_formula"] = "vip_modern_cashback_total_formula";
    CommonVerbiage["vip_modern_cashback_weekly_formula"] = "vip_modern_cashback_weekly_formula";
    CommonVerbiage["vip_modern_claim_reward"] = "vip_modern_claim_reward";
    CommonVerbiage["vip_modern_claim_steps_body"] = "vip_modern_claim_steps_body";
    CommonVerbiage["vip_modern_claim_steps_title"] = "vip_modern_claim_steps_title";
    CommonVerbiage["vip_modern_click_the_claim_button"] = "vip_modern_click_the_claim_button";
    CommonVerbiage["vip_modern_cta_body"] = "vip_modern_cta_body";
    CommonVerbiage["vip_modern_daily_cashback"] = "vip_modern_daily_cashback";
    CommonVerbiage["vip_modern_daily_cashback_2"] = "vip_modern_daily_cashback_2";
    CommonVerbiage["vip_modern_distribution_over_30_days"] = "vip_modern_distribution_over_30_days";
    CommonVerbiage["vip_modern_distribution_over_3_days"] = "vip_modern_distribution_over_3_days";
    CommonVerbiage["vip_modern_distribution_over_7_days"] = "vip_modern_distribution_over_7_days";
    CommonVerbiage["vip_modern_earn_more"] = "vip_modern_earn_more";
    CommonVerbiage["vip_modern_formula"] = "vip_modern_formula";
    CommonVerbiage["vip_modern_hero_body"] = "vip_modern_hero_body";
    CommonVerbiage["vip_modern_hero_title"] = "vip_modern_hero_title";
    CommonVerbiage["vip_modern_how"] = "vip_modern_how";
    CommonVerbiage["vip_modern_level_up"] = "vip_modern_level_up";
    CommonVerbiage["vip_modern_level_up_body"] = "vip_modern_level_up_body";
    CommonVerbiage["vip_modern_level_up_reward"] = "vip_modern_level_up_reward";
    CommonVerbiage["vip_modern_level_up_title"] = "vip_modern_level_up_title";
    CommonVerbiage["vip_modern_marketing"] = "vip_modern_marketing";
    CommonVerbiage["vip_modern_monthly_cashback"] = "vip_modern_monthly_cashback";
    CommonVerbiage["vip_modern_monthly_cashback_010"] = "vip_modern_monthly_cashback_010";
    CommonVerbiage["vip_modern_one_hour_boost"] = "vip_modern_one_hour_boost";
    CommonVerbiage["vip_modern_other_casinos"] = "vip_modern_other_casinos";
    CommonVerbiage["vip_modern_paid_instantly"] = "vip_modern_paid_instantly";
    CommonVerbiage["vip_modern_payouts"] = "vip_modern_payouts";
    CommonVerbiage["vip_modern_percentage_credited_to_balance_remaining_over_following_days"] = "vip_modern_percentage_credited_to_balance_remaining_over_following_days";
    CommonVerbiage["vip_modern_players_wanting_higher_risk_and_reward"] = "vip_modern_players_wanting_higher_risk_and_reward";
    CommonVerbiage["vip_modern_premium_betting"] = "vip_modern_premium_betting";
    CommonVerbiage["vip_modern_rakeback_body"] = "vip_modern_rakeback_body";
    CommonVerbiage["vip_modern_rakeback_cooldown_body"] = "vip_modern_rakeback_cooldown_body";
    CommonVerbiage["vip_modern_rakeback_gets_better_with_each_tier"] = "vip_modern_rakeback_gets_better_with_each_tier";
    CommonVerbiage["vip_modern_rakeboost_body"] = "vip_modern_rakeboost_body";
    CommonVerbiage["vip_modern_rakeboost_title"] = "vip_modern_rakeboost_title";
    CommonVerbiage["vip_modern_reason_body"] = "vip_modern_reason_body";
    CommonVerbiage["vip_modern_reason_one"] = "vip_modern_reason_one";
    CommonVerbiage["vip_modern_reason_title"] = "vip_modern_reason_title";
    CommonVerbiage["vip_modern_reason_two"] = "vip_modern_reason_two";
    CommonVerbiage["vip_modern_register_cta"] = "vip_modern_register_cta";
    CommonVerbiage["vip_modern_rewards_are_glowing"] = "vip_modern_rewards_are_glowing";
    CommonVerbiage["vip_modern_rewards_distribution_title"] = "vip_modern_rewards_distribution_title";
    CommonVerbiage["vip_modern_sportsbook_body1"] = "vip_modern_sportsbook_body1";
    CommonVerbiage["vip_modern_sportsbook_body2"] = "vip_modern_sportsbook_body2";
    CommonVerbiage["vip_modern_sportsbook_note"] = "vip_modern_sportsbook_note";
    CommonVerbiage["vip_modern_step_01"] = "vip_modern_step_01";
    CommonVerbiage["vip_modern_step_02"] = "vip_modern_step_02";
    CommonVerbiage["vip_modern_step_03"] = "vip_modern_step_03";
    CommonVerbiage["vip_modern_the_formula"] = "vip_modern_the_formula";
    CommonVerbiage["vip_modern_total_cashback"] = "vip_modern_total_cashback";
    CommonVerbiage["vip_modern_total_wagered_x_house_edge_x_rakeback"] = "vip_modern_total_wagered_x_house_edge_x_rakeback";
    CommonVerbiage["vip_modern_transparent_rewards"] = "vip_modern_transparent_rewards";
    CommonVerbiage["vip_modern_wager_it_into_real_cash"] = "vip_modern_wager_it_into_real_cash";
    CommonVerbiage["vip_modern_weekly_cashback"] = "vip_modern_weekly_cashback";
    CommonVerbiage["vip_modern_weekly_cashback_050"] = "vip_modern_weekly_cashback_050";
    CommonVerbiage["vip_modern_welcome_bonus_reason1_body"] = "vip_modern_welcome_bonus_reason1_body";
    CommonVerbiage["vip_modern_welcome_bonus_reason2_body"] = "vip_modern_welcome_bonus_reason2_body";
    CommonVerbiage["vip_modern_welcome_bonus_tag"] = "vip_modern_welcome_bonus_tag";
    CommonVerbiage["vip_modern_welcome_bonus_title"] = "vip_modern_welcome_bonus_title";
    CommonVerbiage["vip_modern_what_about_sportsbook"] = "vip_modern_what_about_sportsbook";
    CommonVerbiage["vip_modern_what_does_that_actually_mean_when_you_play_at_brand"] = "vip_modern_what_does_that_actually_mean_when_you_play_at_brand";
    CommonVerbiage["vip_modern_why"] = "vip_modern_why";
    CommonVerbiage["vip_modern_why_some_players_choose_it_anyway"] = "vip_modern_why_some_players_choose_it_anyway";
    CommonVerbiage["vip_modern_why_the_requirement_exists"] = "vip_modern_why_the_requirement_exists";
    CommonVerbiage["vip_modern_your_rewards"] = "vip_modern_your_rewards";
    CommonVerbiage["vip_modern_youre_probably_wondering"] = "vip_modern_youre_probably_wondering";
    CommonVerbiage["vip_momentum_every_day_title"] = "vip_momentum_every_day_title";
    CommonVerbiage["vip_momentum_faqs_title"] = "vip_momentum_faqs_title";
    CommonVerbiage["vip_momentum_hero_body1"] = "vip_momentum_hero_body1";
    CommonVerbiage["vip_momentum_hero_body2"] = "vip_momentum_hero_body2";
    CommonVerbiage["vip_momentum_hero_cta"] = "vip_momentum_hero_cta";
    CommonVerbiage["vip_momentum_hero_tagline"] = "vip_momentum_hero_tagline";
    CommonVerbiage["vip_momentum_hero_title"] = "vip_momentum_hero_title";
    CommonVerbiage["vip_momentum_instant_cashback_description"] = "vip_momentum_instant_cashback_description";
    CommonVerbiage["vip_momentum_instant_cashback_title"] = "vip_momentum_instant_cashback_title";
    CommonVerbiage["vip_momentum_intro"] = "vip_momentum_intro";
    CommonVerbiage["vip_momentum_monthly_reward_description"] = "vip_momentum_monthly_reward_description";
    CommonVerbiage["vip_momentum_monthly_reward_title"] = "vip_momentum_monthly_reward_title";
    CommonVerbiage["vip_momentum_play_more_earn_more"] = "vip_momentum_play_more_earn_more";
    CommonVerbiage["vip_momentum_rank_up_reward_description"] = "vip_momentum_rank_up_reward_description";
    CommonVerbiage["vip_momentum_rank_up_reward_title"] = "vip_momentum_rank_up_reward_title";
    CommonVerbiage["vip_momentum_ranks_benefits_title"] = "vip_momentum_ranks_benefits_title";
    CommonVerbiage["vip_momentum_register_cta"] = "vip_momentum_register_cta";
    CommonVerbiage["vip_momentum_row_custom_vip_bonuses"] = "vip_momentum_row_custom_vip_bonuses";
    CommonVerbiage["vip_momentum_row_dedicated_vip_host"] = "vip_momentum_row_dedicated_vip_host";
    CommonVerbiage["vip_momentum_row_invite_only_promotions"] = "vip_momentum_row_invite_only_promotions";
    CommonVerbiage["vip_momentum_row_monthly_rewards"] = "vip_momentum_row_monthly_rewards";
    CommonVerbiage["vip_momentum_row_rank_up_rewards"] = "vip_momentum_row_rank_up_rewards";
    CommonVerbiage["vip_momentum_row_rewards_increase"] = "vip_momentum_row_rewards_increase";
    CommonVerbiage["vip_momentum_row_weekly_rewards"] = "vip_momentum_row_weekly_rewards";
    CommonVerbiage["vip_momentum_terms_title"] = "vip_momentum_terms_title";
    CommonVerbiage["vip_momentum_tier_black_diamond"] = "vip_momentum_tier_black_diamond";
    CommonVerbiage["vip_momentum_tier_bronze"] = "vip_momentum_tier_bronze";
    CommonVerbiage["vip_momentum_tier_diamond"] = "vip_momentum_tier_diamond";
    CommonVerbiage["vip_momentum_tier_emerald"] = "vip_momentum_tier_emerald";
    CommonVerbiage["vip_momentum_tier_gold"] = "vip_momentum_tier_gold";
    CommonVerbiage["vip_momentum_tier_iron"] = "vip_momentum_tier_iron";
    CommonVerbiage["vip_momentum_tier_legendary"] = "vip_momentum_tier_legendary";
    CommonVerbiage["vip_momentum_tier_platinum"] = "vip_momentum_tier_platinum";
    CommonVerbiage["vip_momentum_tier_ruby"] = "vip_momentum_tier_ruby";
    CommonVerbiage["vip_momentum_tier_sapphire"] = "vip_momentum_tier_sapphire";
    CommonVerbiage["vip_momentum_tier_silver"] = "vip_momentum_tier_silver";
    CommonVerbiage["vip_momentum_weekly_reward_description"] = "vip_momentum_weekly_reward_description";
    CommonVerbiage["vip_momentum_weekly_reward_title"] = "vip_momentum_weekly_reward_title";
    CommonVerbiage["vip_momentum_why_join_title"] = "vip_momentum_why_join_title";
    CommonVerbiage["vip_payouts"] = "vip_payouts";
    CommonVerbiage["vip_rank_rewards"] = "vip_rank_rewards";
    CommonVerbiage["vip_races"] = "vip_races";
    CommonVerbiage["vip_rewards"] = "vip_rewards";
    CommonVerbiage["vip_testimonials_text"] = "vip_testimonials_text";
    CommonVerbiage["volatility"] = "volatility";
    CommonVerbiage["voleyball"] = "voleyball";
    CommonVerbiage["wager"] = "wager";
    CommonVerbiage["wager_house_edge_commission"] = "wager_house_edge_commission";
    CommonVerbiage["wager_on_providers"] = "wager_on_providers";
    CommonVerbiage["wager_required"] = "wager_required";
    CommonVerbiage["wager_requirements"] = "wager_requirements";
    CommonVerbiage["wagered"] = "wagered";
    CommonVerbiage["wagering_progress"] = "wagering_progress";
    CommonVerbiage["wagering_required"] = "wagering_required";
    CommonVerbiage["wagers_in_feed"] = "wagers_in_feed";
    CommonVerbiage["wallet"] = "wallet";
    CommonVerbiage["wallet_address"] = "wallet_address";
    CommonVerbiage["wallet_cashier"] = "wallet_cashier";
    CommonVerbiage["wallet_not_eligible"] = "wallet_not_eligible";
    CommonVerbiage["want_to_be_affiliate"] = "want_to_be_affiliate";
    CommonVerbiage["warning"] = "warning";
    CommonVerbiage["water_polo"] = "water_polo";
    CommonVerbiage["waterpolo"] = "waterpolo";
    CommonVerbiage["weekly"] = "weekly";
    CommonVerbiage["weekly_bonus"] = "weekly_bonus";
    CommonVerbiage["weekly_bonus_text"] = "weekly_bonus_text";
    CommonVerbiage["weekly_bonuses_text"] = "weekly_bonuses_text";
    CommonVerbiage["weekly_cashback"] = "weekly_cashback";
    CommonVerbiage["weekly_limit"] = "weekly_limit";
    CommonVerbiage["weekly_raffle"] = "weekly_raffle";
    CommonVerbiage["weekly_raffle_description"] = "weekly_raffle_description";
    CommonVerbiage["weekly_race"] = "weekly_race";
    CommonVerbiage["weekly_races"] = "weekly_races";
    CommonVerbiage["weekly_races_description"] = "weekly_races_description";
    CommonVerbiage["weekly_races_description_2"] = "weekly_races_description_2";
    CommonVerbiage["weekly_reward"] = "weekly_reward";
    CommonVerbiage["weekly_rewards_tooltip"] = "weekly_rewards_tooltip";
    CommonVerbiage["welcome"] = "welcome";
    CommonVerbiage["welcome_back"] = "welcome_back";
    CommonVerbiage["welcome_bonus"] = "welcome_bonus";
    CommonVerbiage["welcome_description"] = "welcome_description";
    CommonVerbiage["welcome_message"] = "welcome_message";
    CommonVerbiage["welcome_modal_button_text"] = "welcome_modal_button_text";
    CommonVerbiage["welcome_modal_description"] = "welcome_modal_description";
    CommonVerbiage["welcome_modal_subtitle_first_part"] = "welcome_modal_subtitle_first_part";
    CommonVerbiage["welcome_modal_subtitle_second_part"] = "welcome_modal_subtitle_second_part";
    CommonVerbiage["welcome_modal_title"] = "welcome_modal_title";
    CommonVerbiage["welcome_offer"] = "welcome_offer";
    CommonVerbiage["welcome_offer_text"] = "welcome_offer_text";
    CommonVerbiage["welcome_offer_description"] = "welcome_offer_description";
    CommonVerbiage["welcome_offer_description_text"] = "welcome_offer_description_text";
    CommonVerbiage["welcome_to"] = "welcome_to";
    CommonVerbiage["welcome_to_brand"] = "welcome_to_brand";
    CommonVerbiage["welcome_to_fomoio"] = "welcome_to_fomoio";
    CommonVerbiage["welcome_to_the_pinnacle"] = "welcome_to_the_pinnacle";
    CommonVerbiage["welcome_to_vip_club_text"] = "welcome_to_vip_club_text";
    CommonVerbiage["we_ve_dropped_into_your_balance"] = "we_ve_dropped_into_your_balance";
    CommonVerbiage["what_should_you_play"] = "what_should_you_play";
    CommonVerbiage["wheel"] = "wheel";
    CommonVerbiage["why_choose_partners"] = "why_choose_partners";
    CommonVerbiage["will_receive_equivalent"] = "will_receive_equivalent";
    CommonVerbiage["win"] = "win";
    CommonVerbiage["win_real_cash_prizes_every_week"] = "win_real_cash_prizes_every_week";
    CommonVerbiage["win_ways"] = "win_ways";
    CommonVerbiage["with_rewards"] = "with_rewards";
    CommonVerbiage["withdraw"] = "withdraw";
    CommonVerbiage["withdraw_cash"] = "withdraw_cash";
    CommonVerbiage["withdraw_disabled"] = "withdraw_disabled";
    CommonVerbiage["withdraw_funds"] = "withdraw_funds";
    CommonVerbiage["withdrawal"] = "withdrawal";
    CommonVerbiage["withdrawal_address"] = "withdrawal_address";
    CommonVerbiage["withdrawal_address_invalid"] = "withdrawal_address_invalid";
    CommonVerbiage["withdrawal_amount"] = "withdrawal_amount";
    CommonVerbiage["withdrawal_approve"] = "withdrawal_approve";
    CommonVerbiage["withdrawal_approve_text"] = "withdrawal_approve_text";
    CommonVerbiage["withdrawal_approve_text_with_amount"] = "withdrawal_approve_text_with_amount";
    CommonVerbiage["withdrawal_error"] = "withdrawal_error";
    CommonVerbiage["withdrawal_expired"] = "withdrawal_expired";
    CommonVerbiage["withdrawal_fee"] = "withdrawal_fee";
    CommonVerbiage["withdrawal_min_amount"] = "withdrawal_min_amount";
    CommonVerbiage["withdrawal_preview"] = "withdrawal_preview";
    CommonVerbiage["withdrawal_requirement_ineligible_account"] = "withdrawal_requirement_ineligible_account";
    CommonVerbiage["withdrawal_requirement_seek_support"] = "withdrawal_requirement_seek_support";
    CommonVerbiage["withdrawal_reversed_notification_title"] = "withdrawal_reversed_notification_title";
    CommonVerbiage["withdrawal_sent"] = "withdrawal_sent";
    CommonVerbiage["withdrawal_transaction_fee"] = "withdrawal_transaction_fee";
    CommonVerbiage["withdrawals"] = "withdrawals";
    CommonVerbiage["withdrawals_frozen"] = "withdrawals_frozen";
    CommonVerbiage["withdrawals_max_pending"] = "withdrawals_max_pending";
    CommonVerbiage["withdrawals_not_supported"] = "withdrawals_not_supported";
    CommonVerbiage["world_series_bad_beat_bailout"] = "world_series_bad_beat_bailout";
    CommonVerbiage["world_series_bad_beat_bailout_description"] = "world_series_bad_beat_bailout_description";
    CommonVerbiage["write_here"] = "write_here";
    CommonVerbiage["write_your_message"] = "write_your_message";
    CommonVerbiage["x_hours"] = "x_hours";
    CommonVerbiage["xmas_pursuit"] = "xmas_pursuit";
    CommonVerbiage["yearLabel"] = "yearLabel";
    CommonVerbiage["yes"] = "yes";
    CommonVerbiage["you_25_comission"] = "you_25_comission";
    CommonVerbiage["you_can_earn"] = "you_can_earn";
    CommonVerbiage["you_get"] = "you_get";
    CommonVerbiage["you_receive"] = "you_receive";
    CommonVerbiage["you_send"] = "you_send";
    CommonVerbiage["your"] = "your";
    CommonVerbiage["your_balance"] = "your_balance";
    CommonVerbiage["your_bonuses_unlocked"] = "your_bonuses_unlocked";
    CommonVerbiage["your_commissions"] = "your_commissions";
    CommonVerbiage["you_must_first_wager_your_deposit_1_time_before_you_can_withdraw"] = "you_must_first_wager_your_deposit_1_time_before_you_can_withdraw";
    CommonVerbiage["you_need_to_open_your_wallet_and_sign_to_approve"] = "you_need_to_open_your_wallet_and_sign_to_approve";
    CommonVerbiage["your_notifications"] = "your_notifications";
    CommonVerbiage["your_rank"] = "your_rank";
    CommonVerbiage["your_referral_code"] = "your_referral_code";
    CommonVerbiage["your_referral_link"] = "your_referral_link";
    CommonVerbiage["all_bets_fuels_your_rewards"] = "all_bets_fuels_your_rewards";
    // Review & Comments
    CommonVerbiage["reviews_rate_this_game"] = "reviews_rate_this_game";
    CommonVerbiage["reviews_average_rating"] = "reviews_average_rating";
    CommonVerbiage["reviews_based_on_user_ratings"] = "reviews_based_on_user_ratings";
    CommonVerbiage["reviews_comments"] = "reviews_comments";
    CommonVerbiage["reviews_most_recent"] = "reviews_most_recent";
    CommonVerbiage["reviews_most_popular"] = "reviews_most_popular";
    CommonVerbiage["reviews_oldest"] = "reviews_oldest";
    CommonVerbiage["reviews_leave_your_comment"] = "reviews_leave_your_comment";
    CommonVerbiage["reviews_post"] = "reviews_post";
    CommonVerbiage["reviews_login_to_post"] = "reviews_login_to_post";
    CommonVerbiage["reviews_no_comments_yet"] = "reviews_no_comments_yet";
    CommonVerbiage["reviews_be_first_to_comment"] = "reviews_be_first_to_comment";
    CommonVerbiage["reviews_view_more_comments"] = "reviews_view_more_comments";
    CommonVerbiage["reviews_reply"] = "reviews_reply";
    CommonVerbiage["reviews_replies"] = "reviews_replies";
    CommonVerbiage["reviews_tab"] = "reviews_tab";
    CommonVerbiage["reviews_rating_poor"] = "reviews_rating_poor";
    CommonVerbiage["reviews_rating_fair"] = "reviews_rating_fair";
    CommonVerbiage["reviews_rating_good"] = "reviews_rating_good";
    CommonVerbiage["reviews_rating_very_good"] = "reviews_rating_very_good";
    CommonVerbiage["reviews_rating_amazing"] = "reviews_rating_amazing";
    CommonVerbiage["reviews_i_love_it"] = "reviews_i_love_it";
    CommonVerbiage["super_bowl_free_bet"] = "super_bowl_free_bet";
    CommonVerbiage["super_bowl_free_bet_description"] = "super_bowl_free_bet_description";
    CommonVerbiage["champions_league_free_bet"] = "champions_league_free_bet";
    CommonVerbiage["champions_league_free_bet_description"] = "champions_league_free_bet_description";
    CommonVerbiage["luna_jackpot"] = "luna_jackpot";
    CommonVerbiage["luna_bets"] = "luna_bets";
    CommonVerbiage["turbo_jackpot_logo_alt"] = "turbo_jackpot_logo_alt";
    CommonVerbiage["turbo_jackpot_promo_subtitle"] = "turbo_jackpot_promo_subtitle";
    CommonVerbiage["turbo_jackpot_promo_title"] = "turbo_jackpot_promo_title";
    CommonVerbiage["turbo_bets"] = "turbo_bets";
    CommonVerbiage["turbo_rakeback"] = "turbo_rakeback";
    CommonVerbiage["turbo_total_level_up_rewards"] = "turbo_total_level_up_rewards";
    CommonVerbiage["turbo_weekly_cashback"] = "turbo_weekly_cashback";
    CommonVerbiage["turbo_monthly_cashback"] = "turbo_monthly_cashback";
    CommonVerbiage["turbo_rewards_increase"] = "turbo_rewards_increase";
    CommonVerbiage["turbo_invite_only_promotions"] = "turbo_invite_only_promotions";
    CommonVerbiage["turbo_dedicated_vip_host"] = "turbo_dedicated_vip_host";
    CommonVerbiage["turbo_custom_vip_bonuses"] = "turbo_custom_vip_bonuses";
    CommonVerbiage["turbo_rank_iron"] = "turbo_rank_iron";
    CommonVerbiage["turbo_rank_bronze"] = "turbo_rank_bronze";
    CommonVerbiage["turbo_rank_silver"] = "turbo_rank_silver";
    CommonVerbiage["turbo_rank_gold"] = "turbo_rank_gold";
    CommonVerbiage["turbo_rank_platinum"] = "turbo_rank_platinum";
    CommonVerbiage["turbo_rank_diamond"] = "turbo_rank_diamond";
    CommonVerbiage["turbo_rank_ruby"] = "turbo_rank_ruby";
    CommonVerbiage["turbo_rank_sapphire"] = "turbo_rank_sapphire";
    CommonVerbiage["turbo_rank_emerald"] = "turbo_rank_emerald";
    CommonVerbiage["turbo_rank_black_diamond"] = "turbo_rank_black_diamond";
    CommonVerbiage["turbo_rank_legendary"] = "turbo_rank_legendary";
    CommonVerbiage["turbo_cashier_deposit_cash"] = "turbo_cashier_deposit_cash";
    CommonVerbiage["turbo_cashier_withdraw_cash"] = "turbo_cashier_withdraw_cash";
})(CommonVerbiage || (CommonVerbiage = {}));
